import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import {
  Chart,
  ChartConfiguration,
  ChartEvent,
  ChartType,
  Title,
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import * as moment from 'moment';
import { CountryISO, SearchCountryField } from 'ngx-intl-tel-input';
import { ToastrService } from 'ngx-toastr';
import { ApiService } from 'src/app/services/api.service';
import { CommonEnums } from 'src/app/utils/enum-utils';
import { Otp } from 'src/app/model/qModel.model';
import annotationPlugin from 'chartjs-plugin-annotation';
import { TranslateService } from '@ngx-translate/core';
import { left } from '@popperjs/core';

declare let $: any;
Chart.register(annotationPlugin);
@Component({
  selector: 'app-parental-control',
  templateUrl: './parental-control.component.html',
  styleUrls: ['./parental-control.component.scss'],
})
export class ParentalControlComponent implements OnInit {
  @ViewChild('ngOtpInput') ngOtpInputRef: any;
  @ViewChild('EmailOrMobile') EmailOrMobile: any;
  @ViewChild('barChartGraph') barChartGraph: any;
  @ViewChild('slideDoughnutChart') slideDoughnutChart: any;
  @ViewChild('#myChartYouTubeReport') myYouTubeChart: any;
  isListView: boolean = false;
  isGraphView: boolean = true;
  enableListView: boolean = false;
  isGraphTrueFalse: boolean = true;
  isTable: boolean = false;
  dataValue: any;
  data: any;
  xaxisTittleYoutube: string;
  norecords: boolean = false;
  norecordsWeeklyLimitScreenTime: boolean = false;
  norecordsYouTubeReport: boolean = false;
  norecordsThreatWebUsage: boolean = false;
  norecordsScreentimeDougnut: boolean = false;
  norecordsThreatReportArea: boolean = false;
  norecordsWeekScreenTimeControl: boolean = false;
  norecordsAppUsage: boolean = false;
  deviceType: string = '';
  public chart: any;
  public barChartType: ChartType = 'bar';
  public barChartPlugins = [];
  public barChartOptions: ChartConfiguration['options'] = {};
  public jsonArray: any = [];
  delSchedule: boolean = false;
  deleteMsg: boolean = false;
  PARENTALREPORTS: any;
  Weekday: any[] = [];
  cat1List: any[] = [];
  cat2List: any[] = [];
  cat3List: any[] = [];
  listOfMaps: any;
  keysList: any;
  screenToggle: boolean;
  totalCatScreentime: String;
  cat1ScreenTime: String;
  cat2ScreenTime: String;
  cat3ScreenTime: String;
  totalHitCounts: Number;
  totalAppHits: Number = 0;
  totalWebHits: Number = 0;
  totalRestWebHits: Number = 0;
  totalAppUsage: String;
  restAppChart: boolean;
  restWebChart: boolean;
  appUsageChart: boolean;
  webUsageChart: boolean;
  parentalDeviceReport: boolean;
  paretalToggle: boolean;
  parentalPremiumStatus: boolean;
  horizontalGrid: boolean = false;
  verticalGrid: boolean = true;
  usageTimeLabel: any;
  isRestAppReport: boolean;
  isRestWebReport: boolean;
  restWebTable: any;
  showParentalTab: boolean = true;
  status: any;
  renewalLink: any;
  showPremium: boolean = false;
  parentalRepInfo: any;
  productKey: any;
  responseData: any;
  productKeyType: any;
  systemList: any;
  antiTrackerReportCnt: any;
  antiTrackerDeviceWiseReportCnt: any;
  antiTrackerChartAxis: any = 'y';
  antiTracker_X_lable: string;
  antiTracker_Y_lable: string;
  antiTrackersBlockedCnt: any = 0;
  youtubeDevices: any;
  videoCounts: any;
  totalVideoHits: any;
  isBlockedVideoReport: boolean;
  channelList: any;
  totalChannelCounts: number = 0;
  channelVistValue: any;
  blockedVideoTable: any[] = [];
  videoCatTableData: any[] = [];
  isChannelVisitReport: boolean;
  channelVisitTableData: any;
  totalVideoCatVisits: any;
  toatlChannelVisits: any;
  isBlockedVideoChart: boolean;
  isBlockedChannnelChart: boolean;
  isVideoCatChart: boolean;
  isChannelVisitChart: boolean;
  isYoutubeUsageChart: boolean;
  youtubeChartAxis: 'x' | 'y' | undefined;
  totalYoutubeUsage: any;
  youtubeToggle: boolean;
  youTubeDeviceToggle: any;
  systemId: any;
  appUsageTableReport: any;
  webUsageTableReport: any;
  showDesktopReports: boolean = false;
  showFirewallReports: boolean = false;
  mobilesList: any;
  parentalGraph: boolean;
  parentalDeviceToggle: any;
  screenDonutApps: any[];
  screenDonutPercentage: any[];
  screenDeviceToggle: boolean;
  public chartClicked({
    event,
    active,
  }: {
    event?: ChartEvent;
    active?: {}[];
  }): void { }
  public chartHovered({
    event,
    active,
  }: {
    event?: ChartEvent;
    active?: {}[];
  }): void { }
  scheduleStatusArray: any[] = [];
  searchText: any;
  scheduleData: any;
  maxDate: any;
  startMin: any;
  minDate: Date;
  websiteList: any[] = [];
  isRecordFound: boolean = false;
  enableAddSchedule: boolean = false;
  isParentalControls: boolean = false;
  isParentalWebUsageReport: boolean = false;
  isYoutubeReports: boolean = false;
  isScreentimeMonitoring: boolean = false;
  isThreatReport: boolean = false;
  isAntiTrackerReport: boolean = false;
  isFirewallReport: boolean = false;
  isIdsIpsReport: boolean = false;
  isChannel: boolean = true;
  p: number = 1;
  doughnutChartDataFirst: any;
  public doughnutChartType: ChartType = 'doughnut';
  public doughnutChartOptions: ChartConfiguration['options'] = {};
  isApp: boolean = false;
  isLoading: boolean = false;
  userResponse: any[] = [];
  devicesList: any;
  user: any = '';
  deviceid: any = '';
  deviceId: any;
  deviceName: any;
  websiteDtoList: any[] = [];
  openShowSchedulePagePopup: boolean = false;
  successpopup: boolean = false;
  otpError: any;
  currentUserData: any;
  mobileNumber: string = '';
  emailResponse: string = '';
  sentMobileNo: string = '';
  mobileOTPResponse: string = '';
  durationMinutes: string = '';
  timer: any;
  timeOver: any;
  otpValue: string = '';
  otpDto: Otp = new Otp();
  isMobile: boolean = true;
  isOTP: boolean = false;
  isDone: boolean = false;
  CountryISO = CountryISO;
  mobileNoWrong: boolean = false;
  preferredCountries: CountryISO[] = [
    CountryISO.UnitedStates,
    CountryISO.UnitedKingdom,
  ];
  SearchCountryField = SearchCountryField;
  editScheduleData: boolean = false;
  endMin: any;
  screenWidth: any;
  screenHeight: any;
  virusReport: any[] = [];
  firewallReport: any[] = [];
  idsIpsReport: any[] = [];
  videoReport: any;
  channelReport: any;
  short: number = 0;
  isChannelCategoryReport: boolean = false;
  isYoutubeVideoReport: boolean = false;
  isYoutubeChannelReport: boolean = false;
  isThreatReportTable: boolean = false;
  isParentalAppUsageReport: boolean = false;
  isFirewallReportTable: boolean = false;
  ScreenMonitoringTable: any[] = [];
  viewmoreArray: any[] = [];
  appUsageTable: any[] = [];
  webUsageTable: any[] = [];
  restAppTable: any[] = [];
  screentimeHorizon: any = 'y';
  parentalChartAxis: any = 'y';
  recommdAxis: string = 'x';
  X_axis_label: string;
  Y_axix_label: string;
  X_label_parental: string;
  Y_label_parental: string;
  totalScreentime: number = 0.0;
  totalHours: number = 0;
  totalMin: number = 0;
  dailyAppTime: number = 0.0;
  dailyAppTH: number = 0;
  dailyAppTM: number = 0;
  noOfDeviceData: number = 0;
  webCat: String[] = [];
  webCatValue: number[] = [];
  appUsageCat: String[] = [];
  appUsageValue: number[] = [];
  showWeeklyST: boolean = false;
  weeklyScreenHour: number = 0;
  weeklyScreenMins: number = 0;
  showDailyAppChart: boolean = false;
  showAppCatChart: boolean = false;
  showScreentimeDonut: boolean = false;
  isBlockedChannelReport: boolean = false;
  isVideoVisitReport: boolean = false;
  blockedChannelTableData: any;
  noOfItemToShowThreat: any;
  threatsnew: number;
  threatname: any;
  threatcount: any;
  threatsdetected: any;
  antiTrackerDeviceCnt: any;
  deviceNameListMap: Map<any, any>;
  getUserIndexData: any;
  crwSupportedProductTypes: string[] = [
    'QH_LITE',
    'QH_IS_ESSENTIAL',
    'QH_PLUS',
    'QH_TS',
  ];
  actionLabelMap: { [key: string]: string } = {};
  ScheduleReportForm: FormGroup = new FormGroup({
    reportTypeList: new FormControl([]),
    deviceId: new FormControl(''),
    emailId: new FormControl('', [
      Validators.required,
      Validators.email,
      Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$'),
    ]),
    endDate: new FormControl('', [Validators.required]),
    frequencyType: new FormControl('', [Validators.required]),
    reportId: new FormControl(''),
    startDate: new FormControl('', [Validators.required]),
    time: new FormControl('', [Validators.required]),
    dayOfWeek: new FormControl(''),
  });
  deviceDetailForm: FormGroup = new FormGroup({
    userName: new FormControl(''),
    countryCode: new FormControl(''),
  });
  userTimezone: string;
  constructor(
    private translateService: TranslateService,
    private _service: ApiService,
    private router: Router,
    private _formBuilder: FormBuilder,
    private DatePipe: DatePipe,
    private _toaster: ToastrService,
    private route: ActivatedRoute
  ) {
    let filterDropDown = [];
    translateService.get(['PARENTALREPORTS']).subscribe((values) => {
      filterDropDown = Object.keys(values).map((key) => values[key]);
      this.chartsStrings = filterDropDown[0];
    });
  }

  chartsStrings: any;
  selectedLanguage: string = '';
  ngOnInit() {
    this.userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
    this.resetGraphData();
    //this.getRestrictedHitsPerDevice(this.user);
    this.screenWidth = window.screen.width;
    this.screenHeight = window.screen.height;
    this.enableListView = false;
    this.route.queryParams.subscribe(params => {
      const lang = params['lang'];
      if (lang) {
        this.selectedLanguage = lang;
        localStorage.setItem('selectedLang', lang);
      }
    });
    let logginUserStringValue = localStorage.getItem('currentUser');
    if (logginUserStringValue) {
      this.currentUserData = JSON.parse(logginUserStringValue);
    }
    if (this.currentUserData.roleType != 'CHILD') {
      this.getMyUser();
    } else {
      this.getUserDevices(null);
    }

    let selectedLangStringValue = localStorage.getItem('selectedLang');
    if (selectedLangStringValue) {
      this.selectedLanguage = selectedLangStringValue;
      this.translateService.use(this.selectedLanguage);
    }

    setTimeout(() => {
      if (this.currentUserData.mobileNo) {
        this.deviceDetailForm.controls['userName'].setValue(
          this.currentUserData.mobileNo
        );
      }
    }, 1000);

    this.startMin = new Date().toISOString().split('T')[0];
    let time = new Date();
    let localTimeStr = time.toLocaleString('en-US', {
      timeZone: 'Asia/Shanghai',
    });
    let today = new Date(localTimeStr);
    this.endMin = new Date(today.setDate(today.getDate() + 1))
      .toISOString()
      .split('T')[0];
    Chart.register(ChartDataLabels);
    this.Weekday = [
      { id: 'SUNDAY', value: this.translateService.instant('PARENTALREPORTS.WEEKDAYS.SUNDAY') },
      { id: 'MONDAY', value: this.translateService.instant('PARENTALREPORTS.WEEKDAYS.MONDAY') },
      { id: 'TUESDAY', value: this.translateService.instant('PARENTALREPORTS.WEEKDAYS.TUESDAY') },
      { id: 'WEDNESDAY', value: this.translateService.instant('PARENTALREPORTS.WEEKDAYS.WEDNESDAY') },
      { id: 'THURSDAY', value: this.translateService.instant('PARENTALREPORTS.WEEKDAYS.THURSDAY') },
      { id: 'FRIDAY', value: this.translateService.instant('PARENTALREPORTS.WEEKDAYS.FRIDAY') },
      { id: 'SATURDAY', value: this.translateService.instant('PARENTALREPORTS.WEEKDAYS.SATURDAY') },
    ];

    this.X_axis_label = this.translateService.instant('PARENTALREPORTS.CHART.HOURS');
    this.Y_axix_label = this.translateService.instant('PARENTALREPORTS.CHART.DEVICES');
    this.X_label_parental = this.translateService.instant('PARENTALREPORTS.CHART.NOOFATTEMPTS');
    this.Y_label_parental = this.translateService.instant('PARENTALREPORTS.CHART.DEVICES');
    this.antiTracker_X_lable = this.translateService.instant('PARENTALREPORTS.CHART.TRACKERSBLOCKED');
    this.antiTracker_Y_lable = this.translateService.instant('PARENTALREPORTS.CHART.DEVICES');
    this.xaxisTittleYoutube = this.translateService.instant('PARENTALREPORTS.CHART.CHANNELNAME');

    this.actionLabelMap = {
      'IDS_FP_ACTION_ALLOWED': this.translateService.instant('PARENTALREPORTS.ACTIONS.ALLOWED'),
      'IDS_FP_ACTION_BLOCKED': this.translateService.instant('PARENTALREPORTS.ACTIONS.BLOCKED'),
      'IDS_FW_ACTION_BLOCKED': this.translateService.instant('PARENTALREPORTS.ACTIONS.BLOCKED'),
      'IDS_DESCRIPTION': this.translateService.instant('PARENTALREPORTS.ACTIONS.DESCRIPTION')
    };
  }

  getTruncatedText(text: string, limit: number): string {
    if (!text) return '';
    return text.length > limit ? text.substring(0, limit) + '...' : text;
  }

  openTable(reportName: String) {
    this.isGraphTrueFalse = false;
    if (reportName === 'appUsageReport') {
      this.isTable = true;
      this.getAppData(this.deviceId);
      this.isParentalAppUsageReport = true;
    }
    if (reportName === 'webUsageReport') {
      this.isTable = true;
      this.getWebData(this.deviceId);
      this.isParentalWebUsageReport = true;
    }
    if (reportName === 'restAppReport') {
      this.isTable = true;
      this.getRestrictedAppData(this.deviceId);
      this.isRestAppReport = true;
    }
    if (reportName === 'restWebReport') {
      this.isTable = true;
      this.createParentalRestWebChart(this.deviceId);
      this.isRestWebReport = true;
    }
    if (reportName === 'blockedVideoReport') {
      this.getBlockedVideoData(this.deviceId, true);
      this.isBlockedVideoReport = true;
    }
    if (reportName === 'blockedChannelReport') {
      this.getBlockedChannelsData(this.deviceId, true);
      this.isBlockedChannelReport = true;
    }
    if (reportName === 'videoVisitReport') {
      this.getVideoCatData(this.deviceId, true);
      this.isVideoVisitReport = true;
    }
    if (reportName === 'channelVisitReport') {
      this.getChannelVisitsData(this.deviceId, true);
      this.isChannelVisitReport = true;
    }
    $('#restAppsTablePopup').modal('show');
  }
  // Displaying the Date based on Selecting of Grid view or List view

  openGridOrTreeView(viewType: any, isGraphTrueFalse: any) {
    this.isGraphTrueFalse = isGraphTrueFalse;
    if (this.deviceId != '') {
      if (viewType === 'list') {
        this.enableListView = true;
        this.isListView = true;
        this.isGraphView = false;
        if (this.isYoutubeReports) {
          this.youTubeTableData(this.deviceId);
        } else if (this.isParentalControls) {
          this.getAppData(this.deviceId);
          this.getRestrictedAppData(this.deviceId);
          this.createParentalRestWebChart(this.deviceId);
          this.getWebData(this.deviceId);
        } else if (this.isScreentimeMonitoring) {
          this.screenTimeTableData(this.deviceId);
        }
      } else {
        this.short = 0;
        this.enableListView = false;
        this.isListView = false;
        this.isGraphView = true;
        setTimeout(() => {
          if (this.isYoutubeReports) {
            this.barchartYouTubeReport(this.deviceId);
          } else if (this.isParentalControls) {
            this.getRestrictedAppData(this.deviceId);
            this.createParentalRestWebChart(this.deviceId);
            this.getRestrictedHitsPerDevice(this.user);
            this.getAppData(this.deviceId);
            this.getWebData(this.deviceId);
          } else if (this.isScreentimeMonitoring) {
            this.barchartWeekScreenTimeControl(this.deviceId);
            this.getCatScreenTimeData(this.deviceId);
            this.screenTimeDoughnutChart(this.deviceId);
            this.barchartWeeklyLimitScreenTimeControl(this.deviceId);
          }
        }, 100);
      }
    }
  }

  addDevice() {
    this.otpError = null;
    try {
      if (this.currentUserData.mobileVerified) {
        this.router.navigateByUrl('/home/add-device');
      } else {
        this._service
          .getService(this._service.API_URL.checkVerifiedMobile)
          .subscribe((response) => {
            if (response && response.status.code === 200) {
              if (response.data) {
                this.router.navigateByUrl('/home/add-device');
              } else {
                this.isMobile = true;
                this.isOTP = false;
                this.isDone = false;
                $('#verifyDetailsPopup').modal('show');
              }
            } else {
              this.isLoading = false;
              this._toaster.error('', response.status.message);
            }
          });
      }
    } catch (error) { }
  }

  //Verify Device Popup Form Data Submit - Deepa
  verifyDeviceDetail() {
    try {
      this.mobileNumber =
        this.deviceDetailForm.controls['userName'].value.number;
      let data = {
        userName: this.deviceDetailForm.controls['userName'].value.number,
        countryCode: this.deviceDetailForm.controls['userName'].value.dialCode,
      };
      this.sentMobileNo =
        this.deviceDetailForm.controls['userName'].value.number;
      this._service
        .postService(this._service.API_URL.generateOTP, data)
        .subscribe((response: any) => {
          if (response.status.code === 200) {
            this.emailResponse = response.data;
            this.isMobile = false;
            this.mobileOTPResponse = response.data;
            this.isOTP = true;
            this.timeOver = true;
            this.startTimerForFiveMinute(3);
          } else {
            this.isOTP = false;
            this._toaster.error('', response.status.message);
          }
        });
    } catch (error) { }
  }

  //  Start timer for Email Verification, Forgot Password
  startTimerForFiveMinute(minute: number) {
    let seconds: number = minute * 60;
    let textSec: any = '0';
    let statSec: number = 60;
    const prefix = minute < 10 ? '0' : '';
    this.timer = setInterval(() => {
      seconds--;
      if (statSec != 0) statSec--;
      else statSec = 59;
      if (statSec < 10) {
        textSec = '0' + statSec;
      } else textSec = statSec;
      this.durationMinutes = `${prefix}${Math.floor(seconds / 60)}:${textSec}`;
      if (seconds == 0) {
        this.timeOver = false;
        clearInterval(this.timer);
      }
    }, 500);
  }

  submitOTP() {
    try {
      if (this.otpValue?.length == 4) {
        this.otpDto.otpNo = this.otpValue;
        this.otpDto.otpType = CommonEnums.MOBILE_VERIFICATION;
        this.otpDto.otpChar = this.emailResponse;
        this._service
          .postService(this._service.API_URL.otpVerification, this.otpDto)
          .subscribe((response: any) => {
            if (response && response.status.code === 200) {
              $('#verifyDetailsPopup').modal('show');
              this.isOTP = false;
              this.isDone = true;
            } else {
              this.otpError = response.status.message;
            }
          });
      }
    } catch (e) { }
  }

  resendOtp() {
    try {
      this.otpError = null;
      this.ngOtpInputRef.setValue(null);
      clearInterval(this.timer);
      this.isOTP = true;
      this.timeOver = true;
      this.isMobile = false;
      let vinit = this.sentMobileNo;
      let data = {
        userName: vinit,
        otpType: CommonEnums.MOBILE_VERIFICATION,
        isResendOTP: true,
      };

      this._service
        .postService(this._service.API_URL.generateOTP, data)
        .subscribe((response: any) => {
          if (response && response.status.code === 200) {
            this.emailResponse = response.data;
            this.isMobile = false;
            this.isOTP = true;
            this.timeOver = true;
            this.startTimerForFiveMinute(3);
          } else {
            this.otpError = response.status.message;
            this.timeOver = false;
          }
        });
    } catch (e) { }
  }

  closeModalForMobileNumber() {
    this.isMobile = true;
    this.isOTP = false;
    this.isDone = false;
    this.deviceDetailForm.reset();
    $('#verifyDetailsPopup').modal('hide');
  }

  onOtpChange(event: any) {
    this.otpError = null;
    this.otpValue = event;
  }

  closeVerifyDetails() {
    this.isMobile = false;
    this.isOTP = false;
    this.isDone = false;
    this.deviceDetailForm.reset();
    $('#verifyDetailsPopup').modal('hide');
    this.router.navigateByUrl('/home/add-device');
  }

  //  Fetching the User Details here
  getMyUser() {
    try {
      this.isLoading = true;
      this._service
        .getService(this._service.API_URL.getMyUsers)
        .subscribe((response: any) => {
          if (response && response.status.code === 200) {
            this.isLoading = false;
            this.userResponse = response.data;
            if (this.userResponse?.length != 0) {
              let selectedUser = localStorage.getItem('selectedUser');
              if (selectedUser != null && selectedUser != '') {
                this.user = selectedUser;
              } else {
                this.user = response.data[0].id;
              }
              this.getRestrictedHitsPerDevice(this.user);
              this.userResponse.forEach((element: any) => {
                if (this.user == element.id) {
                  this.getUserDevices(element.id);
                }
              });
            }
          }
        });
    } catch (error) { }
  }

  //  Fetching the User device Details here
  getUserDevices(userId: any) {
    this.deviceid = '';
    this.devicesList = [];
    try {
      let url =
        userId && userId != null
          ? `${this._service.API_URL.getSystemMobileData}?userId=${encodeURIComponent(userId)}&timezone=${encodeURIComponent(this.userTimezone)}&selectedLang=${encodeURIComponent(this.selectedLanguage)}`
          : `${this._service.API_URL.getSystemMobileData}?timezone=${encodeURIComponent(this.userTimezone)}&selectedLang=${encodeURIComponent(this.selectedLanguage)}`;
      this._service.getService(url).subscribe((response) => {
        if (response && response.status.code === 200) {
          this.devicesList = response.data;
          if (response.data?.length != 0) {
            this.deviceType = response.data[0]?.deviceType;
          }
          this.mobilesList = response.data.filter(
            (data: any) => data.deviceType === 'MOBILE'
          );
          this.showParentalTab = this.mobilesList.length > 0;
          this.systemList = response.data.filter(
            (data: any) => data.deviceType === 'SYSTEM'
          );
          this.showDesktopReports = this.systemList?.length > 0;
          if (this.systemList?.length > 0) {
            this.systemId = this.systemList[0].id;
          }

          setTimeout(() => {
            if (this.devicesList == null || this.devicesList?.length == 0) {
              this.deviceid = '';
              this.websiteList = [];
              this.websiteDtoList = [];
              this.videoReport = [];
              this.ScreenMonitoringTable = [];
              this.virusReport = [];
            }
          }, 500);
          if (this.devicesList?.length != 0) {
            this.deviceid = response.data[0].id;
            this.devicesList.forEach((element: any) => {
              if (this.deviceid === element.id) {
                setTimeout(() => {
                  this.deviceName = element.deviceName;
                }, 200);
                this.deviceid = element.id;
                this.getDevicesId(this.deviceid, 'SCREEN');
              }
            });
          } else {
            if (this.devicesList?.length == 0) {
              this.deviceid = '';
              this.getDevicesId(this.deviceid, 'SCREEN');
            }
            this.resetGraphData();
          }
        } else {
          if (this.devicesList?.length == 0) {
            this.deviceid = '';
            this.getDevicesId(this.deviceid, 'SCREEN');
          }
          this.resetGraphData();
        }
      });
    } catch (error) { }
  }

  resetGraphData() {
    Chart.getChart('AppUsageChart')?.destroy(); // <canvas> id
    Chart.getChart('websiteUsageChart')?.destroy(); // <canvas> id
    Chart.getChart('AppUsageChartData')?.destroy(); // <canvas> id
    Chart.getChart('myChartYouTubeReport')?.destroy(); // <canvas> id
    Chart.getChart('myChartWeekScreenTimeControl')?.destroy(); // <canvas> id
    Chart.getChart('myChartWeeklyLimitScreenTimeControl')?.destroy(); // <canvas> id
    Chart.getChart('screentimeDougnut')?.destroy(); // <canvas> id
    Chart.getChart('threatReportChart')?.destroy(); // <canvas> id
    Chart.getChart('myChartWebUsage')?.destroy(); // <canvas> id
    Chart.getChart('deviceWiseScreentime')?.destroy(); //<canvas> id
    Chart.getChart('smallThreatReportChart')?.destroy(); // <canvas> id
    Chart.getChart('parentalRestrictedWebChart')?.destroy(); // Id
    Chart.getChart('parentalRestrictedAppsChart')?.destroy(); // canvas Id for chart
    Chart.getChart('parentalRestrictedWebChart')?.destroy(); // Id
    Chart.getChart('blockedVideosChart')?.destroy();
    Chart.getChart('blockedChannnelChart')?.destroy();
    Chart.getChart('videoCatVisitChart')?.destroy();
    Chart.getChart('channelVisitChart')?.destroy();

    this.chart = {};
    this.dataValue = {};
    this.websiteDtoList = [];
    this.websiteList = [];
    this.norecords = true;
    this.norecordsWeeklyLimitScreenTime = true;
    this.norecordsYouTubeReport = true;
    this.norecordsThreatWebUsage = true;
    this.norecordsScreentimeDougnut = true;
    this.norecordsThreatReportArea = true;
    this.norecordsWeekScreenTimeControl = true;
    this.norecordsAppUsage = true;
    this.doughnutChartDataFirst = [];
  }

  // On change the device we are calling here the api to update the value on the list and graph
  getDevicesId(event: any, reportType: any) {
    //need to pass report type here
    this.deviceType = '';
    this.deviceId = event;
    this.devicesList.forEach((element: any) => {
      if (this.deviceid === element.id) {
        setTimeout(() => {
          this.deviceType = element.deviceType;
          this.deviceName = element.name;
          this.isThreatReport = reportType === 'THREAT' ? true : false;
          this.isParentalControls = reportType === 'PARENTAL' ? true : false;
          this.isYoutubeReports = reportType === 'YOUTUBE' ? true : false;
          this.isScreentimeMonitoring = reportType === 'SCREEN' ? true : false;
          this.isAntiTrackerReport =
            reportType === 'ANTITRACKER' ? true : false;
          this.isFirewallReport = reportType === 'FIREWALL' ? true : false;
          this.isIdsIpsReport = reportType === 'IDSIPS' ? true : false;
          this.dropdownType = 'PARENTAL';
        }, 200);
      }
    });
    setTimeout(() => {
      if (
        this.deviceType == 'SYSTEM' ||
        this.deviceType == '' ||
        this.deviceType == null
      ) {
        this.virusReport = [];
        this.firewallReport = [];
        this.dropdownType = 'SCREEN';
      } else if (
        !this.isParentalControls &&
        !this.isYoutubeReports &&
        !this.isThreatReport &&
        !this.isScreentimeMonitoring
      ) {
        this.isParentalControls = true;
      }
    }, 200);

    setTimeout(() => {
      if (this.deviceid != '') {
        if (this.isParentalControls) {
          this.getWebAppLineGraphData(event);
          this.getRestrictedAppData(event);
          this.createParentalRestWebChart(event);
          this.getAppData(event);
          this.getWebData(event);
          this.getSmartParentalSettings(this.user);
          this.checkPremiumFeature(this.deviceId);
        } else if (this.isYoutubeReports) {
          if (this.isGraphView) {
            this.barchartYouTubeReport(this.deviceId);
            this.getBlockedVideoData(this.deviceId, false);
            this.getBlockedChannelsData(this.deviceId, false);
            this.getVideoCatData(this.deviceId, false);
            this.getChannelVisitsData(this.deviceId, false);
            this.getYoutubeSettings(this.user);
            this.checkPremiumFeature(this.deviceId);
          }
        } else if (this.isThreatReport) {
          this.areaChart(this.user);
          this.areaChartSmall(this.deviceId);
          this.donughtChart(this.deviceId);
          this.threatTableData(this.deviceId);
        } else if (this.isScreentimeMonitoring) {
          this.getScreentimeData(this.user);
          this.barchartWeekScreenTimeControl(this.deviceId);
          this.getCatScreenTimeData(this.deviceId);
          this.barchartWeeklyLimitScreenTimeControl(this.deviceId);
          if (this.isGraphView) {
            this.screenTimeDoughnutChart(this.deviceId);
          } else {
            this.screenTimeTableData(this.deviceId);
          }
        }
        this.isRecordFound = false;
        this.editScheduleData = true;
      } else if (this.systemId != '') {
        if (this.isFirewallReport) {
          this.firewallTableData(this.systemId);
        }

      } else {
        this.isRecordFound = true;
      }
    }, 300);
  }

  getRestrictedAppData(deviceId: any) {
    this.textArray = [
      {
        text: this.translateService.instant('PARENTALREPORTS.UTILIZATION.UNDER'),
        color: '#D0E2EA',
      },
      {
        text: this.translateService.instant('PARENTALREPORTS.UTILIZATION.OVER'),
        color: 'rgba(255, 189, 19, 0.5)',
      },
    ];
    if (this.isTable) {
      this._service
        .getService(
          this._service.API_URL.getRestrictedAppHit +
          deviceId +
          '?isTable=' +
          this.isTable
        )
        .subscribe((response: any) => {
          if (response && response.status.code === 200) {
            this.restAppTable = response.data;
            this.isTable = false;
          }
        });
    } else {
      this._service
        .getService(this._service.API_URL.getRestrictedAppHit + deviceId)
        .subscribe((response: any) => {
          if (response && response.status.code === 200) {
            this.data = response.data;
            this.isLoading = false;
            setTimeout(() => { }, 300);

            if (response.data?.length != 0) {
              this.restAppChart = true;
              setTimeout(() => {
                let chartExist = Chart.getChart('parentalRestrictedAppsChart'); // <canvas> id
                if (chartExist != undefined) {
                  chartExist.destroy();
                }
                let datalabels = response['data'].map(
                  (res: any) => res.category
                );
                let dataValue = response['data'].map(
                  (res: any) => res.hitCount
                );
                this.totalAppHits = dataValue.reduce(
                  (pre: any, curr: any) => pre + curr,
                  0
                );
                this.restAppTable = response.data;
                this.restAppTable.forEach((resp: any) => {
                  resp.category = resp.category;
                  resp.hitCount = resp.hitCount;
                });
                const titleTooltip = (tooltipItems: any) => {
                  return '';
                };
                const canvas = document.getElementById(
                  'parentalRestrictedAppsChart'
                );
                const ctx = (canvas as HTMLCanvasElement)?.getContext('2d');
                const gradient = ctx?.createLinearGradient(0, 0, 0, 600);
                gradient?.addColorStop(0, '#D0E2EA');
                gradient?.addColorStop(0.5, '#EEF4F7');
                const gradient2 = ctx?.createLinearGradient(0, 0, 0, 600);
                gradient2?.addColorStop(0, 'rgba(255, 189, 19, 0.4)');
                gradient2?.addColorStop(1, 'rgba(255, 213, 106, 0.1)');
                const translate = this.translateService;
                this.chart = new Chart('parentalRestrictedAppsChart', {
                  type: 'bar',
                  data: {
                    labels: datalabels,
                    datasets: [
                      {
                        data: dataValue,
                        label: this.translateService.instant('PARENTALREPORTS.CHART.RESTRICTEDAPPS'),
                        //maxBarThickness: window.screen.width > 768 ? 60 : window.screen.width < 768 && window.screen.width > 480 ? 30 : 20,
                        borderColor: '#FAA200',
                        borderRadius: {
                          topRight: 10,
                          bottomRight: 10,
                        },
                        barPercentage: 0.5,
                        barThickness: 10,
                        hoverBackgroundColor: '#FAA200',
                        backgroundColor: '#FAA200',
                        hoverBorderColor: '#FAA200',
                        borderWidth: 0,
                        borderSkipped: false,
                      },
                    ],
                  },
                  options: {
                    maintainAspectRatio: false,
                    indexAxis: 'y',
                    plugins: {
                      legend: {
                        display: false,
                        position: 'top',
                        align: 'end',
                        labels: {
                          padding: 30,
                          usePointStyle: true,
                          boxWidth: 15,
                        },
                      },
                      tooltip: {
                        displayColors: false,
                        backgroundColor: '#023047',
                        bodyColor: '#FFFFFF',
                        titleColor: '#FFFFFF',
                        borderColor: '#023047',
                        borderWidth: 1,
                        padding: {
                          right: 15,
                          left: 15,
                          top: 10,
                          bottom: 10,
                        },
                        callbacks: {
                          label(tooltipItem) {
                            const attemptsLabel = translate.instant('PARENTALREPORTS.CHART.ATTEMPTS');
                            return tooltipItem.formattedValue + ' ' + attemptsLabel;
                          },
                        },
                      },
                      datalabels: {
                        anchor: 'end',
                        align: 'end',
                        display: false,
                      },
                    },
                    responsive: true,
                    scales: {
                      x: {
                        stacked: false,
                        grid: {
                          display: true,
                          color: '#F1F1F1',
                          borderDash: [0, 0],
                          drawTicks: false,
                        },
                        title: {
                          display: true,
                          text: this.translateService.instant('PARENTALREPORTS.CHART.NOOFATTEMPTS'),
                          font: {
                            family: 'open sans',
                            size: 14,
                          },
                        },
                        ticks: {
                          autoSkip: false,
                          maxRotation: 0,
                          minRotation: 0,
                          precision: 0,
                        },
                      },
                      y: {
                        stacked: false,
                        grid: {
                          display: false,
                          color: '#F1F1F1',
                          borderDash: [0, 0],
                          drawTicks: false,
                        },
                        title: {
                          display: true,
                          text: this.translateService.instant('PARENTALREPORTS.CHART.CATEGORY'),
                          font: {
                            family: 'open sans',
                            size: 14,
                          },
                        },
                        ticks: {
                          callback: function (value: any) {
                            return datalabels[value]?.length > 10 &&
                              window.screen.width >= 768
                              ? datalabels[value].substring(0, 10) + '...'
                              : datalabels[value]?.length > 2 &&
                                window.screen.width < 768
                                ? datalabels[value].substring(0, 2) + '...'
                                : datalabels[value];
                          },
                        },
                      },
                    },
                  },
                });
              }, 500);
            } else {
              this.restAppChart = false;
            }
          } else {
            this.isLoading = false;
          }
        });
    }
  }

  checkPremiumFeature(deviceId: String) {
    let data: any[] = [];
    data = this.parentalRepInfo.filter(
      (device: any) => device.deviceId === deviceId
    );
    this.status = data[0]?.premiumStatus;
    this.showPremium =
      this.status != null
        ? this.status === 'LICENSE_EXPIRED' || this.status === 'Free version'
        : false;
    this.renewalLink = data[0]?.productLink;
    this.productKey = data[0]?.productKey;
    this.productKeyType = data[0]?.productType;
  }

  navigateToRenew() {
    if (this.productKeyType != 'MOBSEC_ADVANCE') {
      window.open(this.renewalLink + '?prdkey=' + this.productKey, '_blank');
    } else {
      $('#renewPopup').modal('show');
    }
  }

  createParentalRestWebChart(deviceId: any) {
    if (this.isTable) {
      this._service
        .getService(
          this._service.API_URL.getWebData +
          deviceId +
          '?isTable=' +
          this.isTable +
          '&isBlocked=' +
          true
        )
        .subscribe((response) => {
          if (response && response.status.code === 200) {
            this.restWebTable = response.data;
            this.isTable = false;
          }
        });
    } else {
      this._service
        .getService(
          this._service.API_URL.getWebData +
          deviceId +
          '?isGraph=' +
          true +
          '&isBlocked=' +
          true
        )
        .subscribe((response) => {
          if (response && response.status.code === 200) {
            this.data = response.data;
            this.isLoading = false;
            setTimeout(() => { }, 300);

            if (response.data?.length != 0) {
              this.restWebChart = true;
              setTimeout(() => {
                let chartExist = Chart.getChart('parentalRestrictedWebChart'); // <canvas> id
                if (chartExist != undefined) {
                  chartExist.destroy();
                }
                let datalabels = response['data'].map(
                  (res: any) => res.category
                );
                let dataValue = response['data'].map(
                  (res: any) => res.hitCount
                );
                this.totalWebHits = dataValue.reduce(
                  (prev: any, curr: any) => prev + curr,
                  0
                );
                this.restWebTable = response.data;
                this.restWebTable.forEach((resp: any) => {
                  resp.category = resp.category;
                  resp.hitCount = resp.hitCount;
                });
                const titleTooltip = (tooltipItems: any) => {
                  return '';
                };
                const canvas = document.getElementById(
                  'parentalRestrictedWebChart'
                );
                const ctx = (canvas as HTMLCanvasElement)?.getContext('2d');
                const gradient = ctx?.createLinearGradient(0, 0, 0, 600);
                gradient?.addColorStop(0, '#D0E2EA');
                gradient?.addColorStop(0.5, '#EEF4F7');
                const gradient2 = ctx?.createLinearGradient(0, 0, 0, 600);
                gradient2?.addColorStop(0, 'rgba(255, 189, 19, 0.4)');
                gradient2?.addColorStop(1, 'rgba(255, 213, 106, 0.1)');
                const translate = this.translateService;
                this.chart = new Chart('parentalRestrictedWebChart', {
                  type: 'bar',
                  data: {
                    labels: datalabels,
                    datasets: [
                      {
                        data: dataValue,
                        label: this.translateService.instant('PARENTALREPORTS.CHART.RESTRICTEDWEB'),
                        //maxBarThickness: window.screen.width > 768 ? 60 : window.screen.width < 768 && window.screen.width > 480 ? 30 : 20,
                        borderColor: '#FF3C33',
                        borderRadius: {
                          topRight: 10,
                          bottomRight: 10,
                        },
                        barPercentage: 0.5,
                        barThickness: 10,
                        hoverBackgroundColor: '#FF3C33',
                        backgroundColor: '#FF3C33',
                        hoverBorderColor: '#FF3C33',
                        borderWidth: 0,
                        borderSkipped: false,
                      },
                    ],
                  },
                  options: {
                    maintainAspectRatio: false,
                    indexAxis: 'y',
                    plugins: {
                      legend: {
                        display: false,
                        position: 'top',
                        align: 'end',
                        labels: {
                          padding: 30,
                          usePointStyle: true,
                          boxWidth: 15,
                        },
                      },
                      tooltip: {
                        displayColors: false,
                        backgroundColor: '#023047',
                        bodyColor: '#FFFFFF',
                        titleColor: '#FFFFFF',
                        borderColor: '#023047',
                        borderWidth: 1,
                        padding: {
                          right: 15,
                          left: 15,
                          top: 10,
                          bottom: 10,
                        },
                        callbacks: {
                          label(tooltipItem) {
                            const attemptsLabel = translate.instant('PARENTALREPORTS.CHART.ATTEMPTS');
                            return tooltipItem.formattedValue + ' ' + attemptsLabel;
                          },
                        },
                      },
                      datalabels: {
                        anchor: 'end',
                        align: 'end',
                        display: false,
                      },
                    },
                    responsive: true,
                    scales: {
                      x: {
                        stacked: false,
                        grid: {
                          display: true,
                          color: '#F1F1F1',
                          borderDash: [0, 0],
                          drawTicks: false,
                        },
                        title: {
                          display: true,
                          text: this.translateService.instant('PARENTALREPORTS.CHART.NOOFATTEMPTS'),
                          font: {
                            family: 'open sans',
                            size: 14,
                          },
                        },
                        ticks: {
                          // callback: function (value: any) {
                          //   return (datalabels[value]?.length > 10 && window.screen.width >= 768) ? (datalabels[value].substring(0, 10) + '...') : (datalabels[value]?.length > 2 && window.screen.width < 768) ? (datalabels[value].substring(0, 2) + '...') : datalabels[value];
                          // },
                          autoSkip: false,
                          maxRotation: 0,
                          minRotation: 0,
                          precision: 0,
                        },
                      },
                      y: {
                        stacked: false,
                        grid: {
                          display: false,
                          color: '#F1F1F1',
                          borderDash: [0, 0],
                          drawTicks: false,
                        },
                        title: {
                          display: true,
                          text: this.translateService.instant('PARENTALREPORTS.CHART.CATEGORY'),
                          font: {
                            family: 'open sans',
                            size: 14,
                          },
                        },
                        ticks: {
                          callback: function (value: any) {
                            return datalabels[value]?.length > 10 &&
                              window.screen.width >= 768
                              ? datalabels[value].substring(0, 10) + '...'
                              : datalabels[value]?.length > 2 &&
                                window.screen.width < 768
                                ? datalabels[value].substring(0, 2) + '...'
                                : datalabels[value];
                          },
                        },
                      },
                    },
                  },
                });
              }, 500);
            } else {
              this.restWebChart = false;
            }
          } else {
            this.isLoading = false;
          }
        });
    }
  }

  //  Fetching the data for the App graph and list
  getAppData(deviceId: any) {
    if (this.isTable) {
      this._service
        .getService(
          this._service.API_URL.getAppData +
          deviceId +
          '?isTable=' +
          this.isTable
        )
        .subscribe((response: any) => {
          if (response && response.status.code === 200) {
            this.appUsageTableReport = response.data.filter(
              (data: any) => data.totalDuration !== 0
            );
            this.appUsageTableReport.forEach((data: any) => {
              data.totalDuration = this.giveHourlyData(data['totalDuration']);
            });
            this.isTable = false;
          }
        });
    } else {
      this._service
        .getService(
          this._service.API_URL.getAppData +
          deviceId +
          '?isGraph=' +
          this.isGraphTrueFalse
        )
        .subscribe((response: any) => {
          if (response && response.status.code === 200) {
            this.websiteList = response.data;
            if (response.data?.length != 0) {
              this.appUsageChart = true;
            } else {
              this.appUsageChart = false;
            }
            let chartColors = [
              'rgba(112, 161, 255, 0.8)rgba(242,247,255,0)',
              'rgba(255, 200, 58, 0.8)rgba(255,222,137,0)',
              'rgba(250,51,255,0.8)rgba(253,175,255,0)',
              'rgba(80,51,255,0.8)rgba(80,51,255,0)',
              'rgba(255, 64, 64, 0.8)rgba(255,255,255,0)',
              'rgba(209,209,209,0.8)rgba(255,255,255,0)',
            ];
            if (response.data?.length != 0) {
              if (!this.isGraphTrueFalse) {
                this.appUsageTable = this.websiteList;
                this.appUsageTable.forEach((resp: any) => {
                  resp.date = this.transformDate(resp.appUsageDate);
                  resp.websiteList.forEach((response: any) => {
                    response.app = response['website'];
                    response.totalDuration = response['totalDuration'];
                  });
                });
              } else {
                setTimeout(() => {
                  let chartExist = Chart.getChart('AppUsageChartData'); // <canvas> id
                  if (chartExist != undefined) {
                    chartExist.destroy();
                  }
                  let datalabels = response['data'].map(
                    (res: any) => res.category
                  );
                  let dataValue = response['data'].map((res: any) =>
                    Math.round(res.percentage)
                  );
                  this.appUsageCat = datalabels;
                  this.appUsageValue = dataValue;
                  this.usageTimeLabel = response['data'].map(
                    (res: any) => res.totalDuration
                  );
                  let totalDuration = response['data']
                    .map((res: any) => res.totalDuration)
                    .reduce((prev: any, curr: any) => prev + curr, 0);
                  this.totalAppUsage = this.giveHourlyData(totalDuration);
                  let backgroundColor = [
                    '#38B2C5',
                    '#377BFF',
                    '#B94282',
                    '#D35FD7',
                    '#FFBE1A',
                    '#FF4040',
                  ];
                  if (dataValue[0] === 0 || dataValue[0] === 0.0) {
                    backgroundColor = ['#F0F0F0'];
                    dataValue = [99];
                    datalabels = [this.translateService.instant('PARENTALREPORTS.TIMESPENT')];
                  } else {
                    for (let i = 0; i < dataValue?.length; i++) {
                      if (dataValue[i] == 0 || dataValue[i] == 0.0) {
                        dataValue.splice(dataValue.indexOf(dataValue[i]), 1);
                        datalabels.splice(dataValue.indexOf(dataValue[i]), 1);
                        i--;
                      }
                    }
                  }
                  let substringLimit = 10;
                  const labelsData = datalabels;
                  let hovering = false;
                  let tooltip = document.getElementById('AppUsagetooltip'),
                    tooltips = datalabels;
                  const doughnutlabel = {
                    id: 'doughnutlabel',
                    beforeDraw(chart: any, args: any, pluginOptions: any) {
                      const { ctx, data } = chart;
                      ctx.save();
                      var text = chart.options.plugins.title.text;
                      var xCoor = chart.getDatasetMeta(0).data[0].x;
                      var yCoor = chart.getDatasetMeta(0).data[0].y;
                      ctx.fillStyle = '#393E4A';
                      ctx.textAlign = 'center';
                      ctx.textBaseline = 'middle';
                      const fontSize = chart.options.plugins.title.font.size;
                      ctx.font = 'bold ' + fontSize + 'px sans-serif';
                      ctx.fillText(text, xCoor, yCoor);
                    },
                  };
                  this.doughnutChartDataFirst = new Chart('AppUsageChartData', {
                    type: 'doughnut',
                    data: {
                      labels: datalabels,
                      datasets: [
                        {
                          backgroundColor: backgroundColor,
                          borderColor: [
                            '#FFFFFF',
                            '#FFFFFF',
                            '#FFFFFF',
                            '#FFFFFF',
                            '#FFFFFF',
                            '#FFFFFF',
                          ],
                          hoverBackgroundColor: backgroundColor,
                          hoverBorderColor: backgroundColor,
                          hoverBorderWidth: 2,
                          data: dataValue,
                          borderWidth: 4,
                          hoverOffset: 1,
                        },
                      ],
                    },
                    options: {
                      responsive: true,
                      maintainAspectRatio: false,
                      cutout: '86%',
                      layout: {
                        padding: {
                          bottom: 10,
                        },
                      },
                      plugins: {
                        title: {
                          display: false,
                          text: this.totalAppUsage + '',
                          font: {
                            size: 20,
                            weight: 'bold',
                          },
                        },
                        legend: {
                          display: false,
                          position: 'right',
                          maxWidth: 130,
                          onHover: function (event: any, legendItem: any) {
                            if (hovering) {
                              return datalabels[legendItem['index']];
                            }
                            hovering = true;
                            if (tooltip != null) {
                              tooltip.innerHTML = tooltips[legendItem['index']];
                              tooltip.style.left = 86 + '%';
                              tooltip.style.top = event.y - 40 + 'px';
                              tooltip.style.padding = '3.5px';
                              tooltip.style.minWidth = 'fit-content';
                              tooltip.style.whiteSpace = 'nowrap';
                            }
                          },
                          onLeave: function () {
                            hovering = false;
                            if (tooltip != null) {
                              tooltip.style.padding = '0px';
                              tooltip.innerHTML = '';
                            }
                          },
                          labels: {
                            generateLabels: (chart: any) => {
                              return chart.data.labels.map(
                                (l: any, i: any) => ({
                                  datasetIndex: 0,
                                  index: i,
                                  text:
                                    l?.length > substringLimit
                                      ? l.substring(0, substringLimit) + '...'
                                      : l,
                                  fillStyle:
                                    chart.data.datasets[0].backgroundColor[i],
                                  strokeStyle:
                                    chart.data.datasets[0].hoverBorderColor[i],
                                  hiddens:
                                    !chart.getDatasetMeta(0).data[i].hidden,
                                })
                              );
                            },
                            padding: 18,
                            usePointStyle: true,
                            font: {
                              size:
                                window.screen.width > 700 &&
                                  window.screen.width < 800
                                  ? 14
                                  : window.screen.width < 1366
                                    ? 10
                                    : 12,
                            },
                          },
                          onClick(e: any, legendItem: any, legend: any) {
                            const index = legendItem.index;
                            const currentLabels = this.chart.data.labels;
                            let newLabels: any[] = [];
                            if (currentLabels) {
                              for (let i = 0; i < currentLabels?.length; i++) {
                                if (i == index) {
                                  if (labelsData[i] == currentLabels[i]) {
                                    newLabels?.push(
                                      String(currentLabels[i])
                                        .split('')
                                        .map((char: any) => char + '\u0336')
                                        .join('')
                                    );
                                    legend.chart.getDatasetMeta(0).data[
                                      i
                                    ].hidden = true;
                                    legend.chart.getDatasetMeta(0).data[
                                      i
                                    ].visible = false;
                                    substringLimit = 15;
                                  } else {
                                    newLabels.push(String(labelsData[i]));
                                    legend.chart.getDatasetMeta(0).data[
                                      i
                                    ].hidden = false;
                                    legend.chart.getDatasetMeta(0).data[
                                      i
                                    ].visible = true;
                                  }
                                } else {
                                  newLabels.push(String(currentLabels[i]));
                                }
                              }
                            }
                            // Update the label at the clicked index
                            this.chart.data.labels = newLabels;
                            this.chart.update();
                          },
                        },
                        tooltip: {
                          enabled: true,
                          backgroundColor: '#023047',
                          bodyColor: '#FFFFFF',
                          titleColor: '#FFFFFF',
                          borderColor: '#023047',
                          borderWidth: 1,
                          callbacks: {
                            label: (tooltipItem) => {
                              let lbl =
                                tooltipItem.label +
                                ' : ' +
                                this.giveHourlyData(
                                  this.usageTimeLabel[tooltipItem.dataIndex]
                                );
                              return lbl;
                            },
                          },
                        },
                        datalabels: {
                          display: false,
                          formatter: function (value, context: any) {
                            let hiddens = context.chart._hiddenIndices;
                            let total = 0;
                            let datapoints = context.dataset.data;
                            datapoints.forEach((val: any, i: any) => {
                              if (hiddens[i] != undefined) {
                                if (!hiddens[i]) {
                                  total += val;
                                }
                              } else {
                                total += val;
                              }
                            });
                            let percentage =
                              ((value / total) * 100).toFixed(0) + '%';
                            let out =
                              context.chart.data.labels[context.dataIndex] ==
                                datalabels[context.dataIndex]
                                ? percentage
                                : '';
                            return out;
                          },
                          labels: {
                            value: {
                              color: 'black',
                              font: {
                                size:
                                  window.screen.width > 700 &&
                                    window.screen.width < 800
                                    ? 14
                                    : window.screen.width < 1366
                                      ? 10
                                      : 12,
                              },
                            },
                          },
                        },
                      },
                    },
                    plugins: [doughnutlabel],
                  });

                  var ctx1 = this.doughnutChartDataFirst.ctx;
                  var originalStroke = ctx1.stroke;
                  ctx1.stroke = function () {
                    ctx1.save();
                    ctx1.shadowColor = '#D4D5D9';
                    ctx1.shadowBlur = 10;
                    ctx1.shadowOffsetX = 0;
                    ctx1.shadowOffsetY = 4;
                    originalStroke.apply(this, arguments);
                    ctx1.restore();
                  };
                }, 600);
              }
            }
          }
        });
    }
  }

  //  Fetching the data for the web app for the List and graph
  getWebData(deviceId: any) {
    if (this.isTable) {
      this._service
        .getService(
          this._service.API_URL.getWebData +
          deviceId +
          '?isTable=' +
          this.isTable
        )
        .subscribe((response: any) => {
          if (response && response.status.code === 200) {
            this.webUsageTableReport = response.data;
            this.isTable = false;
          }
        });
    } else {
      this._service
        .getService(
          this._service.API_URL.getWebData +
          deviceId +
          '?isGraph=' +
          this.isGraphTrueFalse
        )
        .subscribe((response) => {
          if (response && response.status.code === 200) {
            this.websiteDtoList = response.data;
            if (response.data?.length != 0) {
              this.webUsageChart = true;
            } else {
              this.webUsageChart = false;
            }
            //this.createParentalRestWebChart(response.data);
            let chartColors = [
              'rgba(112, 161, 255, 0.8)rgba(242,247,255,0)',
              'rgba(255, 200, 58, 0.8)rgba(255,222,137,0)',
              'rgba(250,51,255,0.8)rgba(253,175,255,0)',
              'rgba(80,51,255,0.8)rgba(80,51,255,0)',
              'rgba(255, 64, 64, 0.8)rgba(255,255,255,0)',
              'rgba(209,209,209,0.8)rgba(255,255,255,0)',
            ];
            if (response.data?.length != 0) {
              if (!this.isGraphTrueFalse) {
                this.webUsageTable = this.websiteDtoList;
                this.webUsageTable.forEach((resp: any) => {
                  resp.date = this.transformDate(resp.date);
                  resp.websiteDtoList.forEach((response: any) => {
                    response.web = response['website'];
                    response.noOfVisits = response['visitedCount'];
                  });
                });
              } else {
                setTimeout(() => {
                  let chartExist = Chart.getChart('websiteUsageChart'); // <canvas> id
                  if (chartExist != undefined) chartExist.destroy();
                  let datalabels = response['data'].map(
                    (res: any) => res.category
                  );
                  let dataValue = response['data'].map((res: any) =>
                    Math.round(res.percentage)
                  );
                  let hitCountList = response['data'].map(
                    (res: any) => res.hitCount
                  );
                  this.webCat = datalabels;
                  this.webCatValue = dataValue;
                  this.totalRestWebHits = response['data']
                    .map((res: any) => res.hitCount)
                    .reduce((prev: any, curr: any) => prev + curr, 0);
                  for (let i = 0; i < dataValue?.length; i++) {
                    if (dataValue[i] == 0 || dataValue[i] == 0.0) {
                      dataValue.splice(dataValue.indexOf(dataValue[i]), 1);
                      datalabels.splice(dataValue.indexOf(dataValue[i]), 1);
                      hitCountList.splice(dataValue.indexOf(dataValue[i]), 1);
                      i = i - 1;
                    }
                  }
                  let substringLimit = 10;
                  const labelsData = datalabels;
                  let hovering = false;
                  let tooltip = document.getElementById('websiteUsagetooltip'),
                    tooltips = datalabels;
                  const doughnutlabel = {
                    id: 'doughnutlabel',
                    beforeDraw(chart: any, args: any, pluginOptions: any) {
                      const { ctx, data } = chart;
                      ctx.save();
                      var text = chart.options.plugins.title.text;
                      var xCoor = chart.getDatasetMeta(0).data[0].x;
                      var yCoor = chart.getDatasetMeta(0).data[0].y;
                      ctx.fillStyle = '#393E4A';
                      ctx.textAlign = 'center';
                      ctx.textBaseline = 'middle';
                      const fontSize = chart.options.plugins.title.font.size;
                      ctx.font = 'bold ' + fontSize + 'px sans-serif';
                      ctx.fillText(text, xCoor, yCoor);
                    },
                  };
                  this.doughnutChartDataFirst = new Chart('websiteUsageChart', {
                    type: 'doughnut',
                    data: {
                      labels: datalabels,
                      datasets: [
                        {
                          backgroundColor: [
                            '#38B2C5',
                            '#377BFF',
                            '#B94282',
                            '#D35FD7',
                            '#FFBE1A',
                            '#FF4040',
                          ],
                          borderColor: [
                            '#FFFFFF',
                            '#FFFFFF',
                            '#FFFFFF',
                            '#FFFFFF',
                            '#FFFFFF',
                            '#FFFFFF',
                          ],
                          hoverBackgroundColor: [
                            '#38B2C5',
                            '#377BFF',
                            '#B94282',
                            '#D35FD7',
                            '#FFBE1A',
                            '#FF4040',
                          ],
                          hoverBorderColor: [
                            '#38B2C5',
                            '#377BFF',
                            '#B94282',
                            '#D35FD7',
                            '#FFBE1A',
                            '#FF4040',
                          ],
                          borderWidth: 4,
                          hoverBorderWidth: 2,
                          data: dataValue,
                          hoverOffset: 1,
                        },
                      ],
                    },
                    options: {
                      responsive: true,
                      maintainAspectRatio: false,
                      cutout: '86%',
                      layout: {
                        padding: {
                          bottom: 10,
                        },
                      },
                      plugins: {
                        title: {
                          display: false,
                          text: this.totalRestWebHits + '',
                          font: {
                            size: 20,
                            weight: 'bold',
                          },
                        },
                        legend: {
                          display: false,
                          position: 'right',
                          maxWidth: 130,
                          onHover: function (event: any, legendItem: any) {
                            if (hovering) {
                              return datalabels[legendItem['index']];
                            }
                            hovering = true;
                            if (tooltip != null) {
                              tooltip.innerHTML = tooltips[legendItem['index']];
                              tooltip.style.left = 86 + '%';
                              tooltip.style.top = event.y - 40 + 'px';
                              tooltip.style.padding = '3.5px';
                              tooltip.style.minWidth = 'fit-content';
                              tooltip.style.whiteSpace = 'nowrap';
                            }
                          },
                          onLeave: function () {
                            hovering = false;
                            if (tooltip != null) {
                              tooltip.style.padding = '0px';
                              tooltip.innerHTML = '';
                            }
                          },
                          labels: {
                            generateLabels: (chart: any) => {
                              return chart.data.labels.map(
                                (l: any, i: any) => ({
                                  datasetIndex: 0,
                                  index: i,
                                  text:
                                    l?.length > substringLimit
                                      ? l.substring(0, substringLimit) + '...'
                                      : l,
                                  fillStyle:
                                    chart.data.datasets[0].backgroundColor[i],
                                  strokeStyle:
                                    chart.data.datasets[0].hoverBorderColor[i],
                                  hiddens:
                                    !chart.getDatasetMeta(0).data[i].hidden,
                                })
                              );
                            },
                            padding: 18,
                            usePointStyle: true,
                            font: {
                              size:
                                window.screen.width > 700 &&
                                  window.screen.width < 800
                                  ? 14
                                  : window.screen.width < 1366
                                    ? 10
                                    : 12,
                            },
                          },
                          onClick(e: any, legendItem: any, legend: any) {
                            const index = legendItem.index;
                            const currentLabels = this.chart.data.labels;
                            let newLabels: any[] = [];
                            if (currentLabels) {
                              for (let i = 0; i < currentLabels?.length; i++) {
                                if (i == index) {
                                  if (labelsData[i] == currentLabels[i]) {
                                    newLabels?.push(
                                      String(currentLabels[i])
                                        .split('')
                                        .map((char: any) => char + '\u0336')
                                        .join('')
                                    );
                                    legend.chart.getDatasetMeta(0).data[
                                      i
                                    ].hidden = true;
                                    legend.chart.getDatasetMeta(0).data[
                                      i
                                    ].visible = false;
                                    substringLimit = 15;
                                  } else {
                                    newLabels.push(String(labelsData[i]));
                                    legend.chart.getDatasetMeta(0).data[
                                      i
                                    ].hidden = false;
                                    legend.chart.getDatasetMeta(0).data[
                                      i
                                    ].visible = true;
                                  }
                                } else {
                                  newLabels.push(String(currentLabels[i]));
                                }
                              }
                            }
                            // Update the label at the clicked index
                            this.chart.data.labels = newLabels;
                            this.chart.update();
                          },
                        },
                        tooltip: {
                          enabled: true,
                          backgroundColor: '#023047',
                          bodyColor: '#FFFFFF',
                          titleColor: '#FFFFFF',
                          borderColor: '#023047',
                          borderWidth: 1,
                          callbacks: {
                            label: (tooltipItem) => {
                              const attemptsLabel = this.translateService.instant('PARENTALREPORTS.ATTEMPTS');
                              let lbl =
                                tooltipItem.label +
                                ' : ' +
                                hitCountList[tooltipItem.dataIndex] + ' ' +
                                attemptsLabel;
                              return lbl;
                            },
                          },
                        },
                        datalabels: {
                          display: false,
                          formatter: function (value, context: any) {
                            let hiddens = context.chart._hiddenIndices;
                            let total = 0;
                            let datapoints = context.dataset.data;
                            datapoints.forEach((val: any, i: any) => {
                              if (hiddens[i] != undefined) {
                                if (!hiddens[i]) {
                                  total += val;
                                }
                              } else {
                                total += val;
                              }
                            });
                            let percentage =
                              ((value / total) * 100).toFixed(0) + '%';
                            let out =
                              context.chart.data.labels[context.dataIndex] ==
                                datalabels[context.dataIndex]
                                ? percentage
                                : '';
                            return out;
                          },
                          labels: {
                            value: {
                              color: 'black',
                              font: {
                                size:
                                  window.screen.width > 700 &&
                                    window.screen.width < 800
                                    ? 14
                                    : window.screen.width < 1366
                                      ? 10
                                      : 12,
                              },
                            },
                          },
                        },
                      },
                    },
                    plugins: [doughnutlabel],
                  });
                  var ctx1 = this.doughnutChartDataFirst.ctx;
                  var originalStroke = ctx1.stroke;
                  ctx1.stroke = function () {
                    ctx1.save();
                    ctx1.shadowColor = '#D4D5D9';
                    ctx1.shadowBlur = 10;
                    ctx1.shadowOffsetX = 0;
                    ctx1.shadowOffsetY = 4;
                    originalStroke.apply(this, arguments);
                    ctx1.restore();
                  };
                }, 600);
              }
            }
          }
        });
    }
  }

  //  On Changing the type we are getting the data for the web and app
  timeInhours: string = 'Time In Minutes';
  optionChange(name: string, isGraph: boolean) {
    if (this.isApp != isGraph) {
      this.isApp = isGraph;
      this.a = 0;
    }
    setTimeout(() => {
      if (name == 'application') {
        this.timeInhours = this.chartsStrings['TIMEINMINS'];
      } else {
        this.timeInhours = this.chartsStrings['NOOFVISITS'];
      }
    }, 100);
    if (this.a == 0) {
      this.getWebAppLineGraphData(this.deviceId);
      this.a = 1;
    }
  }

  //OPTION CHANGE FUNTION FOR YOUTUBE REPORT TAB
  a: number = 0;
  optionChangeYoutube(name: string, isGraph: boolean) {
    if (this.isChannel != isGraph) {
      this.isChannel = isGraph;
      this.a = 0;
    }
    setTimeout(() => {
      if (name == 'channel') {
        this.timeInhours = this.chartsStrings['NOOFVISITS'];
        this.xaxisTittleYoutube = this.chartsStrings['CHANNELNAME'];
      } else {
        this.timeInhours = this.chartsStrings['NOOFVISITS'];
        this.xaxisTittleYoutube = this.chartsStrings['VIDEOCATEGORY'];
      }
    }, 200);
    if (this.isGraphView && this.a == 0) {
      this.barchartYouTubeReport(this.deviceId);
      this.a = 1;
    }
  }
  isApplication: boolean = true;

  //  Fetching the data for the line graph and displaying the same
  noOfItemToShow: any;
  lastUpdatedDate: any;
  getWebAppLineGraphData(deviceId: any) {
    let graph = this.isApp;
    this.isLoading = true;
    this._service
      .getService(
        this._service.API_URL.getWebAppLineGraphData +
        deviceId +
        '?isApp=' +
        graph +
        '&width=' +
        this.screenWidth +
        '&height=' +
        this.screenHeight
      )
      .subscribe((response) => {
        if (response && response.status.code === 200) {
          this.lastUpdatedDate = response.data.lastUpdatedDate;
          this.data = response.data;
          this.isLoading = false;
          this.noOfItemToShow = response.data.noOfItemToShow;
          if (response.data.graphList && response.data.graphList?.length != 0) {
            this.norecordsAppUsage = false;
          } else {
            this.norecordsAppUsage = true;
          }

          if (this.data.graphList?.length != 0 && this.data.graphList) {
            setTimeout(() => {
              let chartExist = Chart.getChart('AppUsageChart'); // <canvas> id
              if (chartExist != undefined) {
                chartExist.destroy();
              }
              let datalabels = response['data'].graphList.map(
                (res: any) => res.category
              );
              let dataValue = response['data'].graphList.map(
                (res: any) => res.appUsageDuration
              );
              const titleTooltip = (tooltipItems: any) => {
                return '';
              };
              const gradient = this.barChartGraph.nativeElement
                .getContext('2d')
                .createLinearGradient(0, 0, 0, 600);
              gradient.addColorStop(0, '#D0E2EA');
              gradient.addColorStop(0.5, '#EEF4F7');
              this.chart = new Chart('AppUsageChart', {
                type: 'bar',
                data: {
                  labels: datalabels,
                  datasets: [
                    {
                      data: dataValue,
                      maxBarThickness:
                        window.screen.width > 768
                          ? 60
                          : window.screen.width < 768 &&
                            window.screen.width > 480
                            ? 30
                            : 20,
                      borderColor: '#136B97',
                      borderRadius: {
                        topLeft: 10,
                        topRight: 10,
                      },
                      barPercentage: 0.5,
                      hoverBackgroundColor: '#136B97',
                      backgroundColor: gradient,
                      hoverBorderColor: '#9ecfdb',
                      borderWidth: 1,
                      borderSkipped: false,
                    },
                  ],
                },
                options: {
                  maintainAspectRatio: false,
                  plugins: {
                    legend: {
                      display: false,
                    },
                    tooltip: {
                      yAlign: 'bottom',
                      displayColors: false,
                      padding: {
                        right: 15,
                        left: 15,
                        top: 10,
                        bottom: 10,
                      },
                    },
                    datalabels: {
                      anchor: 'end',
                      align: 'end',
                      display: false,
                    },
                  },
                  responsive: true,
                  scales: {
                    x: {
                      grid: {
                        color: '#E7E6E6',
                        borderDash: [5, 5],
                      },
                      ticks: {
                        callback: function (value: any) {
                          return datalabels[value]?.length > 10 &&
                            window.screen.width >= 768
                            ? datalabels[value].substring(0, 10) + '...'
                            : datalabels[value]?.length > 2 &&
                              window.screen.width < 768
                              ? datalabels[value].substring(0, 2) + '...'
                              : datalabels[value];
                        },
                        autoSkip: false,
                        maxRotation: 0,
                        minRotation: 0,
                      },
                    },
                    y: {
                      grid: {
                        color: '#E7E6E6',
                        borderDash: [5, 5],
                      },
                      title: {
                        display: true,
                        text: this.timeInhours,
                        font: {
                          family: 'open sans',
                          size: 14,
                        },
                      },
                    },
                  },
                },
              });
            }, 500);
          }
        }
        this.isLoading = false;
      });
  }

  // Checking the min and max date validatio
  setDate(date: any) {
    this.minDate = date;
    let dateStart = this.ScheduleReportForm.controls['startDate'].value;
    dateStart = this.DatePipe.transform(date, 'yyyy-MM-dd');
    this.ScheduleReportForm.controls['startDate'].setValue(dateStart);
  }

  EndDate(date: any) {
    let dateStart = this.ScheduleReportForm.controls['endDate'].value;
    dateStart = this.DatePipe.transform(date, 'yyyy-MM-dd');
    this.ScheduleReportForm.controls['endDate'].setValue(dateStart);
  }

  createOrUpdateSchedule(type: any) {
    if (type == 'Add') {
      this.addSchedule();
    }
  }

  getChangedDate(e: any) {
    let time = e.target.value;
    this.ScheduleReportForm.controls['endDate'].reset();
    let localTimeStr = time.toLocaleString('en-US', {
      timeZone: 'Asia/Shanghai',
    });
    let today = new Date(localTimeStr);
    this.endMin = new Date(today.setDate(today.getDate() + 1))
      .toISOString()
      .split('T')[0];
  }

  getEndDate() {
    const dayNames = [
      { id: 'SUNDAY', value: this.translateService.instant('PARENTALREPORTS.WEEKDAYS.SUNDAY') },
      { id: 'MONDAY', value: this.translateService.instant('PARENTALREPORTS.WEEKDAYS.MONDAY') },
      { id: 'TUESDAY', value: this.translateService.instant('PARENTALREPORTS.WEEKDAYS.TUESDAY') },
      { id: 'WEDNESDAY', value: this.translateService.instant('PARENTALREPORTS.WEEKDAYS.WEDNESDAY') },
      { id: 'THURSDAY', value: this.translateService.instant('PARENTALREPORTS.WEEKDAYS.THURSDAY') },
      { id: 'FRIDAY', value: this.translateService.instant('PARENTALREPORTS.WEEKDAYS.FRIDAY') },
      { id: 'SATURDAY', value: this.translateService.instant('PARENTALREPORTS.WEEKDAYS.SATURDAY') },
    ];
    const sDate = `${this.ScheduleReportForm.controls['startDate'].value}`,
      eDate = `${this.ScheduleReportForm.controls['endDate'].value}`;
    const start = new Date(sDate);
    const end = new Date(eDate);
    end.setDate(end.getDate() + 1);
    this.Weekday = [];
    let i = 0;
    while (i < 7 && start < end) {
      this.Weekday.push(dayNames[start.getDay()]);
      start.setDate(start.getDate() + 1);
      i++;
    }
    this.ScheduleReportForm.controls['dayOfWeek'].setValue(null);
  }

  // Submitting the schedule report
  addSchedule() {
    try {
      let selectedStartDate;
      let selectedEndDate;
      let daysOfweek = this.ScheduleReportForm.controls['dayOfWeek'].value;
      let frequency = this.ScheduleReportForm.controls['frequencyType'].value;
      selectedStartDate = moment(
        this.ScheduleReportForm.controls['startDate'].value
      ).format('DD/MM/YYYY');
      selectedEndDate = moment(
        this.ScheduleReportForm.controls['endDate'].value
      ).format('DD/MM/YYYY');
      this.ScheduleReportForm.controls['startDate'].setValue(selectedStartDate);
      this.ScheduleReportForm.controls['endDate'].setValue(selectedEndDate);
      this.ScheduleReportForm.controls['deviceId'].setValue(this.deviceId);
      let ScheduleReportFormDTO = this.ScheduleReportForm.value;
      ScheduleReportFormDTO.reportTypeList = this.reportTypeList;
      if (
        (daysOfweek != null && frequency == 'WEEKLY') ||
        frequency == 'DAILY'
      ) {
        this._service
          .postService(
            this._service.API_URL.saveSchedule,
            ScheduleReportFormDTO
          )
          .subscribe((response) => {
            if (response && response.status.code === 200) {
              this.successpopup = true;
              this.enableAddSchedule = false;
              this.isRecordFound = false;
              this.delSchedule = false;
              this.deleteMsg = false;
              this.getSchedule();
            } else {
              this.enableAddSchedule = true;
              this._toaster.error('', response.status.message);
            }
          });
      }
    } catch (error) {
      console.error();
    }
  }

  optionalRequiredField(ev: any) {
    let val = ev.target.value;
    if (val != null) {
      if (val == 'WEEKLY') {
        this.ScheduleReportForm.controls['dayOfWeek']?.addValidators([
          Validators.required,
        ]);
      } else {
        this.ScheduleReportForm.controls['dayOfWeek']?.clearValidators();
      }
      this.ScheduleReportForm.controls['dayOfWeek']?.updateValueAndValidity();
    }
  }

  isParentalControl: boolean = false;
  isScreenMonitoring: boolean = false;
  reportTypeList: any[] = [];
  selectedReportType(event: any, val: string) {
    let checkedReportType = event?.target?.checked;
    if (val == 'PARENTAL') {
      this.isParentalControl = checkedReportType;
    } else {
      this.isScreenMonitoring = checkedReportType;
    }

    if (this.isParentalControl && !this.isScreenMonitoring) {
      this.reportTypeList = ['PARENTAL_CONTROL'];
    } else if (this.isScreenMonitoring && !this.isParentalControl) {
      this.reportTypeList = ['SCREEN_TIME_REPORT'];
    } else {
      this.reportTypeList = ['PARENTAL_CONTROL', 'SCREEN_TIME_REPORT'];
    }
  }

  editScheduleForm() {
    this.editScheduleData = true;
  }
  //  Opening the popup to show the Add Schedule report
  openScheduleButton() {
    this.isParentalControl = false;
    this.isScreenMonitoring = false;
    $('#Schedulepopup').modal('show');
    this.ScheduleReportForm.reset();
    this.isRecordFound = false;
    this.enableAddSchedule = false;
    this.successpopup = false;
    this.openShowSchedulePagePopup = false;
    this.delSchedule = false;
    if (
      this.scheduleData &&
      this.devicesList != null &&
      this.devicesList?.length != 0
    ) {
      this.isRecordFound = false;
      this.getSchedule();
      this.enableAddSchedule = true;
      this.delSchedule = false;
    } else {
      this.isRecordFound = true;
      this.scheduleData = [];
      this.scheduleData = null;
    }
  }

  goToAddDevice() {
    $('#Schedulepopup').modal('hide');
    this.router.navigateByUrl('/home/manage-device');
  }

  gotoAddSchedule() {
    this.isParentalControl = false;
    this.isScreenMonitoring = false;
    this.isRecordFound = false;
    this.enableAddSchedule = true;
    setTimeout(() => {
      this.EmailOrMobile.nativeElement.focus();
    }, 0);
  }
  //  Closing the modal here
  closeAddSchedule() {
    $('#Schedulepopup').modal('hide');
    this.isRecordFound = false;
    this.enableAddSchedule = false;
    this.successpopup = false;
    this.openShowSchedulePagePopup = false;
    this.delSchedule = false;
    this.Weekday = [
      { id: 'SUNDAY', value: this.translateService.instant('PARENTALREPORTS.WEEKDAYS.SUNDAY') },
      { id: 'MONDAY', value: this.translateService.instant('PARENTALREPORTS.WEEKDAYS.MONDAY') },
      { id: 'TUESDAY', value: this.translateService.instant('PARENTALREPORTS.WEEKDAYS.TUESDAY') },
      { id: 'WEDNESDAY', value: this.translateService.instant('PARENTALREPORTS.WEEKDAYS.WEDNESDAY') },
      { id: 'THURSDAY', value: this.translateService.instant('PARENTALREPORTS.WEEKDAYS.THURSDAY') },
      { id: 'FRIDAY', value: this.translateService.instant('PARENTALREPORTS.WEEKDAYS.FRIDAY') },
      { id: 'SATURDAY', value: this.translateService.instant('PARENTALREPORTS.WEEKDAYS.SATURDAY') },
    ];
  }
  //  Opening the modal to show the schedule status
  openShowSchedulePage() {
    this.openShowSchedulePagePopup = true;
    this.successpopup = false;
    this.enableAddSchedule = false;
    this.isRecordFound = false;
    this.delSchedule = false;
    this.getUserScheduledStatus();
  }

  //  Fetching the data for the schedule status
  getUserScheduledStatus() {
    this.isLoading = true;
    this._service
      .getService(this._service.API_URL.getUserScheduledStatus + this.deviceId)
      .subscribe((response) => {
        if (response && response.status.code === 200) {
          this.scheduleStatusArray = response.data;
          this.isLoading = false;
        } else {
          this._toaster.error('', response.status.message);
          this.isLoading = false;
        }
      });
  }

  //  Displaying the background color for the Schedule status field
  getStatus(val: string) {
    if (val == 'Success') {
      return 'btn btnsuccess';
    } else if (val == 'Pending') {
      return 'btn btnpending';
    } else {
      return 'btn btnfailed';
    }
  }

  //  Getting the schedule data so that we can edit the already schedule report
  getSchedule() {
    this.isLoading = true;
    if (this.deviceid != '') {
      this._service
        .getService(this._service.API_URL.getSchedule + this.deviceId)
        .subscribe((response) => {
          if (response && response.status.code === 200) {
            this.scheduleData = response.data;
            this.editScheduleData = false;
            this.isLoading = false;
            setTimeout(() => {
              this.ScheduleReportForm.patchValue(response.data);
              response?.data?.reportTypeList.forEach((res: any) => {
                if (res == 'PARENTAL_CONTROL') {
                  this.isParentalControl = true;
                } else if (res == 'SCREEN_TIME_REPORT') {
                  this.isScreenMonitoring = true;
                }
                if (this.isParentalControl && !this.isScreenMonitoring) {
                  this.reportTypeList = ['PARENTAL_CONTROL'];
                } else if (this.isScreenMonitoring && !this.isParentalControl) {
                  this.reportTypeList = ['SCREEN_TIME_REPORT'];
                } else {
                  this.reportTypeList = [
                    'PARENTAL_CONTROL',
                    'SCREEN_TIME_REPORT',
                  ];
                }
              });
            }, 2000);
          } else {
            this.isLoading = false;
            this._toaster.error('', response.status.message);
          }
        });
    }
  }

  deleteSchedule() {
    this.reportTypeList = [];
    this.scheduleData = null;
    this.openShowSchedulePagePopup = false;
    this.successpopup = false;
    this.isRecordFound = false;
    this.Weekday = [
      { id: 'SUNDAY', value: this.translateService.instant('PARENTALREPORTS.WEEKDAYS.SUNDAY') },
      { id: 'MONDAY', value: this.translateService.instant('PARENTALREPORTS.WEEKDAYS.MONDAY') },
      { id: 'TUESDAY', value: this.translateService.instant('PARENTALREPORTS.WEEKDAYS.TUESDAY') },
      { id: 'WEDNESDAY', value: this.translateService.instant('PARENTALREPORTS.WEEKDAYS.WEDNESDAY') },
      { id: 'THURSDAY', value: this.translateService.instant('PARENTALREPORTS.WEEKDAYS.THURSDAY') },
      { id: 'FRIDAY', value: this.translateService.instant('PARENTALREPORTS.WEEKDAYS.FRIDAY') },
      { id: 'SATURDAY', value: this.translateService.instant('PARENTALREPORTS.WEEKDAYS.SATURDAY') },
    ];
  }

  youTubeTableData(deviceId: any) {
    this.isLoading = true;
    this._service
      .getService(this._service.API_URL.youTubeTableData + deviceId)
      .subscribe((res: any) => {
        if (res && res.status.code == 200) {
          this.videoReport = res.data;
          this.isLoading = false;
        } else {
          this._toaster.error('', res.status.message);
          this.isLoading = false;
        }
      });
  }

  transformDate(value: any): string {
    //Format is  "9th Jul'24" from the date "09-Jul-2024"
    if (!value) return '';

    const dateParts = value.split('-');
    if (dateParts.length !== 3) return value; // Return original value if format is incorrect

    const day = parseInt(dateParts[0], 10);
    const month = dateParts[1];
    const year = dateParts[2].slice(-2); // Get last two digits of year

    // Convert day to ordinal suffix
    let suffix: string;
    switch (day % 10) {
      case 1:
        suffix = this.translateService.instant('PARENTALREPORTS.DATE_SUFFIX.ST');
        break;
      case 2:
        suffix = this.translateService.instant('PARENTALREPORTS.DATE_SUFFIX.ND');
        break;
      case 3:
        suffix = this.translateService.instant('PARENTALREPORTS.DATE_SUFFIX.RD');
        break;
      default:
        suffix = this.translateService.instant('PARENTALREPORTS.DATE_SUFFIX.TH');
    }

    // Handle special case for 11th, 12th, 13th
    if (day >= 11 && day <= 13) {
      suffix = this.translateService.instant('PARENTALREPORTS.DATE_SUFFIX.TH');
    }

    const dayStr = `${day}${suffix}`;

    return `${dayStr} ${month}'${year}`;
  }

  giveHourlyData(response: any) {
    let uTHourly = 0;
    let min = response;
    let str = response + this.chartsStrings['MNOT'];
    if (response >= 60) {
      uTHourly = Math.floor(Number(response / 60));
      min = response % 60;
      str =
        uTHourly +
        this.chartsStrings['HNOT'] +
        min +
        this.chartsStrings['MNOT'];
    }
    return str;
  }

  getValuesForKey(key: string): any[] {
    return this.listOfMaps.map((obj: { [x: string]: any }) => obj[key]);
  }

  getAllValues(): { key: string; values: any[] }[] {
    return this.keysList.map((key: string) => ({
      key,
      values: this.getValuesForKey(key),
    }));
  }

  getCatScreenTimeData(deviceId: any) {
    this.textArray = [
      {
        text: this.translateService.instant('PARENTALREPORTS.LIMIT_SET'),
        color: '#FFBFBF',
      },
      {
        text: this.translateService.instant('PARENTALREPORTS.WEB_ACCESS_ATTEMPTS'),
        color: '#D0E2EA',
      },
      {
        text: this.translateService.instant('PARENTALREPORTS.APP_ACCESS_ATTEMPTS'),
        color: '#DC392F',
      },
    ];
    this._service
      .getService(this._service.API_URL.getCatwiseWeeklyScreentime + deviceId)
      .subscribe((res: any) => {
        if (res && res.status.code == 200) {
          if (res.data.weeklyList.length != 0) {
            this.listOfMaps = res['data'].weeklyList.map(
              (res: any) => res.catTimeList
            );
            let dateValues = res['data'].weeklyList.map((res: any) =>
              res.key.split('-').join(' ')
            );
            let totalMins = res['data'].weeklyList
              .map((res: any) => res.usedTime)
              .reduce((acc: any, curr: any) => acc + curr, 0);
            this.totalCatScreentime = this.giveHourlyData(totalMins);
            this.keysList = Object.keys(this.listOfMaps[0]);
            let cat1List = this.getValuesForKey(this.keysList[0]);
            let cat1Mins =
              cat1List.reduce((acc: any, curr: any) => acc + curr, 0) * 60;
            this.cat1ScreenTime = this.giveHourlyData(cat1Mins);
            let cat2List = this.getValuesForKey(this.keysList[1]);
            let cat2Mins =
              cat2List.reduce((acc: any, curr: any) => acc + curr, 0) * 60;
            this.cat2ScreenTime = this.giveHourlyData(cat2Mins);
            let cat3List = this.getValuesForKey(this.keysList[2]);
            let cat3Mins =
              cat3List.reduce((acc: any, curr: any) => acc + curr, 0) * 60;
            this.cat3ScreenTime = this.giveHourlyData(cat3Mins);
            this.showAppCatChart = true;
            if (this.keysList.length != 0) {
              setTimeout(() => {
                let chartExist = Chart.getChart('catWiseScreentime'); // <canvas> id
                if (chartExist != undefined) {
                  chartExist.destroy();
                }
                let datalabels = dateValues;
                const canvas = document.getElementById('catWiseScreentime');
                const ctx = (canvas as HTMLCanvasElement)?.getContext('2d');
                const gradient = ctx?.createLinearGradient(0, 0, 0, 600);
                gradient?.addColorStop(0, '#E48701');
                gradient?.addColorStop(0.5, '#E48701');
                const gradient2 = ctx?.createLinearGradient(0, 0, 0, 600);
                gradient2?.addColorStop(0, '#006EE5');
                gradient2?.addColorStop(1, '#006EE5');
                const translate = this.translateService;
                this.chart = new Chart('catWiseScreentime', {
                  type: 'bar',
                  data: {
                    labels: datalabels,
                    datasets: [
                      {
                        data: cat1List,
                        label: this.keysList[0],
                        maxBarThickness: window.screen.width > 768 ? 60 : 40,
                        borderColor: '#FFFFFF',
                        borderRadius: {
                          topLeft: 10,
                          topRight: 10,
                          bottomRight: 10,
                        },
                        barPercentage: 0.6,
                        categoryPercentage: 0.1,
                        hoverBackgroundColor: '#0D79FF',
                        backgroundColor: '#0D79FF',
                        hoverBorderColor: '#FFFFFF',
                        borderWidth: 4,
                        barThickness: 14,
                      },
                      {
                        data: cat2List,
                        label: this.keysList[1],
                        maxBarThickness: window.screen.width > 768 ? 60 : 40,
                        borderColor: '#FFFFFF',
                        borderRadius: {
                          topLeft: 10,
                          bottomRight: 10,
                          topRight: 10,
                        },
                        barPercentage: 1,
                        categoryPercentage: 0.7,
                        hoverBackgroundColor: '#59CCFF',
                        backgroundColor: '#59CCFF',
                        hoverBorderColor: '#FFFFFF',
                        borderWidth: 4,
                        barThickness: 14,
                      },
                      {
                        data: cat3List,
                        label: this.keysList[2],
                        maxBarThickness: window.screen.width > 768 ? 60 : 40,
                        borderColor: '#FFFFFF',
                        borderRadius: {
                          topLeft: 10,
                          bottomRight: 10,
                          topRight: 10,
                        },
                        barPercentage: 0.1,
                        categoryPercentage: 0.5,
                        hoverBackgroundColor: '#FAA200',
                        backgroundColor: '#FAA200',
                        hoverBorderColor: '#FFFFFF',
                        borderWidth: 4,
                        barThickness: 14,
                      },
                    ],
                  },
                  options: {
                    maintainAspectRatio: false,
                    indexAxis: 'x',
                    plugins: {
                      legend: {
                        display: false,
                        position: 'top',
                        align: 'end',
                        labels: {
                          boxWidth: 10,
                        },
                      },
                      tooltip: {
                        displayColors: false,
                        backgroundColor: '#023047',
                        bodyColor: '#FFFFFF',
                        titleColor: '#FFFFFF',
                        borderColor: '#023047',
                        borderWidth: 1,
                        padding: {
                          right: 15,
                          left: 15,
                          top: 10,
                          bottom: 10,
                        },
                        callbacks: {
                          label(tooltipItem) {
                            console.log(tooltipItem);
                            let hours = Math.floor(
                              parseFloat(tooltipItem.formattedValue)
                            );
                            let mins = Math.round(
                              (parseFloat(tooltipItem.formattedValue) -
                                Math.trunc(
                                  parseFloat(tooltipItem.formattedValue)
                                )) *
                              60
                            );
                            return (
                              tooltipItem.dataset.label +
                              ' ' +
                              hours +
                              translate.instant('PARENTALREPORTS.HNOT') +
                              mins +
                              translate.instant('PARENTALREPORTS.MNOT')
                            );
                          },
                        },
                      },
                      datalabels: {
                        anchor: 'end',
                        align: 'end',
                        display: false,
                      },
                    },
                    responsive: true,
                    scales: {
                      x: {
                        stacked: false,
                        grid: {
                          display: false,
                          color: '#F1F1F1',
                          borderDash: [0, 0],
                          drawTicks: false,
                        },
                        title: {
                          display: true,
                          text: this.translateService.instant('PARENTALREPORTS.CHART.DAYS'),
                          font: {
                            family: 'open sans',
                            size: 14,
                          },
                        },
                        ticks: {
                          autoSkip: false,
                          maxRotation: 0,
                          minRotation: 0,
                        },
                      },
                      y: {
                        stacked: false,
                        grid: {
                          display: true,
                          color: '#F1F1F1',
                          borderDash: [0, 0],
                          drawTicks: false,
                        },
                        title: {
                          display: true,
                          text: this.translateService.instant('PARENTALREPORTS.CHART.HOURS'),
                          font: {
                            family: 'open sans',
                            size: 14,
                          },
                        },
                        ticks: {
                          autoSkip: false,
                          maxRotation: 0,
                          minRotation: 0,
                          callback: function (value) {
                            return `${value}h`;
                          },
                        },
                      },
                    },
                  },
                });
              }, 500);
            }
          } else {
            this.showAppCatChart = false;
          }
        }
      });
  }

  screenTimeTableData(deviceId: any) {
    this.isLoading = true;
    this._service
      .getService(this._service.API_URL.screenTimeTableReport + deviceId)
      .subscribe((res: any) => {
        if (res && res.status.code == 200) {
          this.ScreenMonitoringTable = res.data;
          this.ScreenMonitoringTable.forEach((resp: any) => {
            resp.date = resp.date.split('-').join('th ');
            resp.screenTimeReportList.forEach((response: any) => {
              response.usedTimeInMin = response['usedTime'];
              response.allowedTimeInMin = response['allowedTime'];
              response.usedTime = this.giveHourlyData(response['usedTime']);
              response.allowedTime = this.giveHourlyData(
                response['allowedTime']
              );
            });
          });
          this.isLoading = false;
        } else {
          this._toaster.error('', res.status.message);
          this.isLoading = false;
        }
      });
  }
  totalActiveCount: any;
  activeCount: any;
  threatTableData(deviceId: any) {
    this.isLoading = true;
    this._service
      .getService(
        this._service.API_URL.threatTableReport +
        deviceId +
        '?deviceType=' +
        this.deviceType
      )
      .subscribe((res: any) => {
        if (res && res.status.code == 200) {
          this.virusReport = res.data;
          this.totalActiveCount = this.virusReport[0].activeCount;
          this.isLoading = false;
        } else {
          this.isLoading = false;
        }
      });
  }

  totalFirewallActiveCount: any;
  firewallTableData(systemId: any) {
    if (!systemId) {
      console.warn('No valid systemId, skipping firewallTableData');
      this.firewallReport = [];
      this.totalFirewallActiveCount = 0;
      return;
    }

    console.log('Calling firewallTableData with systemId:', systemId);
    this.isLoading = true;

    this._service
      .getService(this._service.API_URL.firewallTableReport + systemId)
      .subscribe((res: any) => {
        if (res && res.status.code == 200) {
          this.firewallReport = res.data;
          this.totalFirewallActiveCount = this.firewallReport.length;
        } else {
          this._toaster.error('', res.status.message);
          this.firewallReport = [];
        }
        this.isLoading = false;
        this.isFirewallReport = true;
      });
  }




  idsIpsTableData(systemId: any) {
    console.log('Calling idsIpsTableData with systemId:', systemId);
    this.isLoading = true;
    this._service
      .getService(this._service.API_URL.idsIpsTableReport + systemId)
      .subscribe((res: any) => {
        console.log('IDS IPS Report data:: ', res);
        if (res && res.status.code == 200) {
          this.idsIpsReport = res.data;
        } else {
          this._toaster.error('', res.status.message);
          this.idsIpsReport = [];
        }
        this.isLoading = false;
        this.isIdsIpsReport = true;
      });
  }

  delScheduleReport() {
    this.isLoading = true;
    try {
      this._service
        .deleteService(this._service.API_URL.deleteSchedule + this.deviceId)
        .subscribe((response) => {
          if (response && response.status.code == 200) {
            this.deleteSchedule();
            this.delSchedule = false;
            this.openShowSchedulePagePopup = false;
            this.successpopup = true;
            this.enableAddSchedule = false;
            this.isRecordFound = false;
            this.deleteMsg = true;
            this.isLoading = false;
          } else {
            this.isLoading = false;
            this.delSchedule = true;
            this._toaster.error('', response.status.message);
          }
        });
    } catch (error) {
      this.isLoading = false;
      console.error();
    }
  }
  dropdownType = 'PARENTAL';
  openTabs(type: any) {
    console.log('tab type::', type);
    this.isGraphView = true;
    this.isListView = false;
    this.screenWidth = window.screen.width;
    //if (this.screenWidth <= 991) {
    //type = type;
    //}
    this.dropdownType = type;
    switch (type) {
      case 'PARENTAL':
        this.isGraphTrueFalse = true;
        this.isParentalControls = true;
        this.isYoutubeReports = false;
        this.isScreentimeMonitoring = false;
        this.isThreatReport = false;
        this.isAntiTrackerReport = false;
        this.isFirewallReport = false;
        this.isIdsIpsReport = false;
        this.websiteList = [];
        this.websiteDtoList = [];
        if (this.deviceType === 'SYSTEM') {
          this.deviceid = this.mobilesList[0].id;
          this.deviceId = this.mobilesList[0].id;
          this.deviceName = this.mobilesList[0].deviceName;
        }
        setTimeout(() => {
          if (this.deviceid != '') {
            this.getWebAppLineGraphData(this.deviceId);
            this.getAppData(this.deviceId);
            this.getWebData(this.deviceId);
            //add smart parental api methods here
            this.createParentalRestWebChart(this.deviceId);
            this.getRestrictedAppData(this.deviceId);
            this.getRestrictedHitsPerDevice(this.user);
            this.checkPremiumFeature(this.deviceId);
          }
        }, 100);
        break;
      case 'YOUTUBE':
        this.isParentalControls = false;
        this.isYoutubeReports = true;
        this.isScreentimeMonitoring = false;
        this.isThreatReport = false;
        this.isAntiTrackerReport = false;
        this.isFirewallReport = false;
        this.isIdsIpsReport = false;
        this.videoReport = [];
        if (this.deviceType === 'SYSTEM') {
          this.deviceid = this.mobilesList[0].id;
          this.deviceId = this.mobilesList[0].id;
          this.deviceName = this.mobilesList[0].deviceName;
        }
        setTimeout(() => {
          if (this.deviceid != '') {
            const device = this.devicesList.filter(
              (device: any) => device.id === this.deviceId
            );
            this.checkPremiumFeature(this.deviceId);
            this.youtubeUsageChartData(this.user);
            this.barchartYouTubeReport(this.deviceId);
            this.getBlockedVideoData(this.deviceId, false);
            this.getBlockedChannelsData(this.deviceId, false);
            this.getVideoCatData(this.deviceId, false);
            this.getChannelVisitsData(this.deviceId, false);
          }
        }, 100);
        break;
      case 'SCREEN':
        this.isParentalControls = false;
        this.isYoutubeReports = false;
        this.isScreentimeMonitoring = true;
        this.isThreatReport = false;
        this.isAntiTrackerReport = false;
        this.isFirewallReport = false;
        this.isIdsIpsReport = false;
        this.ScreenMonitoringTable = [];
        setTimeout(() => {
          this.timeInhours = this.chartsStrings['TIMEINMINS'];
          this.xaxisTittleYoutube = this.chartsStrings['APPUSAGE'];
          if (this.deviceid != '') {
            this.getScreentimeData(this.user);
            this.barchartWeekScreenTimeControl(this.deviceId);
            this.getCatScreenTimeData(this.deviceId);
            this.screenTimeDoughnutChart(this.deviceId);
            this.barchartWeeklyLimitScreenTimeControl(this.deviceId);
          }
        }, 100);
        break;
      case 'THREAT':
        this.isParentalControls = false;
        this.isYoutubeReports = false;
        this.isScreentimeMonitoring = false;
        this.isThreatReport = true;
        this.isAntiTrackerReport = false;
        this.isFirewallReport = false;
        this.isIdsIpsReport = false;
        this.virusReport = [];
        setTimeout(() => {
          if (this.deviceid != '') {
            this.areaChart(this.user);
            this.areaChartSmall(this.deviceId);
            this.donughtChart(this.deviceId);
            this.threatTableData(this.deviceId);
          }
        }, 100);
        break;
      case 'ANTITRACKER':
        this.isAntiTrackerReport = true;
        this.isParentalControls = false;
        this.isYoutubeReports = false;
        this.isScreentimeMonitoring = false;
        this.isThreatReport = false;
        this.isFirewallReport = false;
        this.isIdsIpsReport = false;

        setTimeout(() => {
          if (this.systemId != '') {
            this.getUserWiseAntiTrackerReport(this.user);
            this.getDesktopAntiTrackerReport(this.systemId);
          }
        }, 100);
        break;
      case 'FIREWALL':
        this.isFirewallReport = true;
        this.isAntiTrackerReport = false;
        this.isParentalControls = false;
        this.isYoutubeReports = false;
        this.isScreentimeMonitoring = false;
        this.isThreatReport = false;
        this.isIdsIpsReport = false;
        this.firewallReport = [];

        this.systemId = this.systemList[0].id;
        this.deviceName = this.systemList[0].deviceName;
        setTimeout(() => {
          if (this.systemId != '') {
            this.firewallTableData(this.systemId);
          }
        }, 100);
        break;
      case 'IDSIPS':
        this.isIdsIpsReport = true;
        this.isParentalControls = false;
        this.isYoutubeReports = false;
        this.isScreentimeMonitoring = false;
        this.isThreatReport = false;
        this.isAntiTrackerReport = false;
        this.isFirewallReport = false;
        setTimeout(() => {
          if (this.systemId != '') {
            this.idsIpsTableData(this.systemId);
          }
        }, 100);
        break;
    }
    this.short = 0;
  }

  get selectedSystem() {
    return (this.systemList as any[])?.find((system: any) => system.id === this.systemId);
  }


  getDesktopAntiTrackerReport(deviceId: any) {
    this.isLoading = true;
    this._service
      .getService(
        this._service.API_URL.getDeviceWiseAntiTrackerReport + deviceId
      )
      .subscribe((response) => {
        if (response && response.data && response.status.code === 200) {
          this.antiTrackerReportCnt = response.data.systemWiseDtoList?.length;
          this.isLoading = false;
          if (this.antiTrackerReportCnt != 0) {
            setTimeout(() => {
              let chartExist = Chart.getChart('systemWiseAntiTrackerReport'); // <canvas> id
              if (chartExist != undefined) {
                chartExist.destroy();
              }

              let list = response['data'].systemWiseDtoList || [];

              list.sort((a: any, b: any) => {
                const parseDate = (str: string) => {
                  const [day, monthStr] = str.split('-');

                  const months: any = {
                    Jan: 0, Feb: 1, Mar: 2, Apr: 3, May: 4, Jun: 5,
                    Jul: 6, Aug: 7, Sep: 8, Oct: 9, Nov: 10, Dec: 11
                  };

                  return new Date(new Date().getFullYear(), months[monthStr], Number(day));
                };

                return parseDate(a.date).getTime() - parseDate(b.date).getTime();
              });

              let dateLabels = list.map((res: any) => res.date);
              let analyticsValue = list.map((res: any) => res.anlytBlockCnt);
              let advertisementValue = list.map((res: any) => res.advBlockCnt);
              let socialMediaValue = list.map((res: any) => res.socMedBlockCnt);
              let othersValue = list.map((res: any) => res.otherBlockCnt);

              let analyticsCnt = analyticsValue.reduce(
                (sum: any, p: any) => sum + p
              );
              let advertisementCnt = advertisementValue.reduce(
                (sum: any, p: any) => sum + p
              );
              let socialMediaCnt = socialMediaValue.reduce(
                (sum: any, p: any) => sum + p
              );
              let otherCnt = othersValue.reduce((sum: any, p: any) => sum + p);
              let countsArr = [
                analyticsCnt,
                advertisementCnt,
                socialMediaCnt,
                otherCnt,
              ];
              this.antiTrackerDeviceWiseReportCnt = response['data'].totalCnt;
              const legendMargin = {
                id: 'legendMargin',
                beforeInit(chart: any) {
                  // Get a reference to the original fit function
                  const origFit = chart.legend.fit;
                  chart.legend.fit = function fit() {
                    origFit.bind(chart.legend)();
                    // Change the height to any desired value
                    return (this.height += 10);
                  };
                },
              };

              this.chart = new Chart('systemWiseAntiTrackerReport', {
                type: 'bar',
                data: {
                  labels: dateLabels,
                  datasets: [
                    {
                      data: analyticsValue,
                      label: this.translateService.instant('PARENTALREPORTS.LABELS.ANALYTICS'),
                      borderColor: '#377BFF',
                      hoverBackgroundColor: '#377BFF',
                      backgroundColor: '#377BFF',
                      hoverBorderColor: '#377BFF',
                      borderRadius: {
                        topLeft: 10,
                        topRight: 10,
                        bottomRight: 10,
                      },
                      barPercentage: 0.8,
                      categoryPercentage: 0.3,
                      borderWidth: 0,
                    },
                    {
                      data: advertisementValue,
                      label: this.translateService.instant('PARENTALREPORTS.LABELS.ADVERTISEMENT'),
                      borderColor: '#38B2C5',
                      borderRadius: {
                        topLeft: 10,
                        topRight: 10,
                        bottomRight: 10,
                      },
                      barPercentage: 0.8,
                      categoryPercentage: 0.3,
                      hoverBackgroundColor: '#38B2C5',
                      backgroundColor: '#38B2C5',
                      hoverBorderColor: '#38B2C5',
                      borderWidth: 0,
                    },
                    {
                      data: socialMediaValue,
                      label: this.translateService.instant('PARENTALREPORTS.LABELS.SOCIAL_MEDIA'),
                      borderColor: '#AF52DE',
                      borderRadius: {
                        topLeft: 10,
                        topRight: 10,
                        bottomRight: 10,
                      },
                      barPercentage: 0.8,
                      categoryPercentage: 0.3,
                      hoverBackgroundColor: '#AF52DE',
                      backgroundColor: '#AF52DE',
                      hoverBorderColor: '#AF52DE',
                      borderWidth: 0,
                    },
                    {
                      data: othersValue,
                      label: this.translateService.instant('PARENTALREPORTS.LABELS.OTHERS'),
                      borderColor: '#FFBE1A',
                      borderRadius: {
                        topLeft: 10,
                        topRight: 10,
                        bottomRight: 10,
                      },
                      barPercentage: 0.8,
                      categoryPercentage: 0.3,
                      hoverBackgroundColor: '#FFBE1A',
                      backgroundColor: '#FFBE1A',
                      hoverBorderColor: '#FFBE1A',
                      borderWidth: 0,
                    },
                  ],
                },
                options: {
                  indexAxis: 'x',
                  maintainAspectRatio: false,
                  plugins: {
                    legend: {
                      display: true,
                      position: 'top',
                      align: 'end',
                      labels: {
                        boxHeight: 10,
                        boxWidth: 10,
                        generateLabels: (chart: any) => {
                          return chart.data.datasets.map((l: any, i: any) => ({
                            datasetIndex: 0,
                            index: i,
                            text: [chart.data.datasets[i].label, countsArr[i]],
                            fillStyle: chart.data.datasets[i].backgroundColor,
                            strokeStyle:
                              chart.data.datasets[i].hoverBorderColor,
                          }));
                        },
                        font: {
                          size: 12,
                        },
                        padding: 20,
                      },
                    },
                    datalabels: {
                      display: false,
                    },
                    tooltip: {
                      displayColors: false,
                      backgroundColor: '#023047',
                      bodyColor: '#FFFFFF',
                      titleColor: '#FFFFFF',
                      borderColor: '#023047',
                      borderWidth: 1,
                      padding: {
                        right: 15,
                        left: 15,
                        top: 10,
                        bottom: 10,
                      },
                    },
                  },
                  responsive: true,
                  scales: {
                    x: {
                      grid: {
                        display: false,
                        color: '#F1F1F1',
                        borderDash: [0, 0],
                        drawTicks: false,
                      },
                      title: {
                        display: true,
                        text: this.translateService.instant('PARENTALREPORTS.CHART.DAYS'),
                        font: {
                          family: 'open sans',
                          size: 14,
                        },
                      },
                      ticks: {
                        autoSkip: false,
                        maxRotation: 0,
                        minRotation: 0,
                      },
                    },
                    y: {
                      grid: {
                        display: true,
                        color: '#F1F1F1',
                        borderDash: [0, 0],
                        drawTicks: false,
                      },
                      title: {
                        display: true,
                        text: this.translateService.instant('PARENTALREPORTS.CHART.TRACKERSBLOCKED'),
                        font: {
                          family: 'open sans',
                          size: 14,
                        },
                      },
                      ticks: {
                        autoSkip: false,
                        maxRotation: 0,
                        minRotation: 0,
                        precision: 0,
                        callback: function (value: any) {
                          return `${value}`;
                        },
                      },
                    },
                  },
                },
                plugins: [legendMargin],
              });
            }, 500);
          }
        }
      });
  }

  textArray: any[] = [];

  noOfItemToShowScreen: any;

  barchartWeekScreenTimeControl(deviceId: string) {
    this.textArray = [
      {
        text: this.translateService.instant('PARENTALREPORTS.UTILIZATION.UNDER'),
        color: '#D0E2EA',
      },
      {
        text: this.translateService.instant('PARENTALREPORTS.UTILIZATION.OVER'),
        color: 'rgba(255, 189, 19, 0.5)',
      },
    ];
    this.isLoading = true;
    this._service
      .getService(
        this._service.API_URL.screentimeBarReport +
        deviceId +
        '?width=' +
        this.screenWidth +
        '&height=' +
        this.screenHeight
      )
      .subscribe((response) => {
        if (response && response.data && response.status.code === 200) {
          this.lastUpdatedDate = response.data.lastUpdatedDate;
          this.data = response.data;
          this.isLoading = false;
          this.noOfItemToShowScreen = response.data.noOfItemToShow;

          setTimeout(() => {
            if (
              response.data.graphList &&
              response.data.graphList?.length != 0
            ) {
              this.norecordsWeekScreenTimeControl = false;
              this.showDailyAppChart = true;
            } else {
              this.norecordsWeekScreenTimeControl = true;
              this.showDailyAppChart = false;
            }
          }, 300);

          if (response.data.graphList?.length != 0) {
            setTimeout(() => {
              let chartExist = Chart.getChart('myChartWeekScreenTimeControl'); // <canvas> id
              if (chartExist != undefined) {
                chartExist.destroy();
              }
              let datalabels = response['data'].graphList?.map(
                (res: any) => res.key
              );
              let dataValue = response['data'].graphList?.map(
                (res: any) => res.underTime
              );
              let dataValueAllowed = response['data'].graphList?.map(
                (res: any) => res.overTime
              );
              let usedTime = response['data'].graphList?.map(
                (res: any) => res.usedTime / 60.0
              );

              this.dailyAppTime = response['data'].totalTime;
              this.dailyAppTH = Math.floor(this.dailyAppTime);
              this.dailyAppTM = Math.floor(
                (this.dailyAppTime - Math.trunc(this.dailyAppTime)) * 60
              );

              const titleTooltip = (tooltipItems: any) => {
                return '';
              };
              const canvas = document.getElementById(
                'myChartWeekScreenTimeControl'
              );
              const ctx = (canvas as HTMLCanvasElement)?.getContext('2d');
              const gradient = ctx?.createLinearGradient(0, 0, 0, 600);
              gradient?.addColorStop(0, '#D0E2EA');
              gradient?.addColorStop(0.5, '#EEF4F7');
              const gradient2 = ctx?.createLinearGradient(0, 0, 0, 600);
              gradient2?.addColorStop(0, 'rgba(255, 189, 19, 0.4)');
              gradient2?.addColorStop(1, 'rgba(255, 213, 106, 0.1)');
              const translate = this.translateService;
              const legendMargin = {
                id: 'legendMargin',
                beforeInit(chart: any) {
                  // Get a reference to the original fit function
                  const origFit = chart.legend.fit;
                  chart.legend.fit = function fit() {
                    origFit.bind(chart.legend)();
                    // Change the height to any desired value
                    return (this.height += 10);
                  };
                },
              };
              this.chart = new Chart('myChartWeekScreenTimeControl', {
                type: 'bar',
                data: {
                  labels: datalabels,
                  datasets: [
                    {
                      data: usedTime,
                      label: this.translateService.instant('PARENTALREPORTS.UTILIZATION.LIMIT'),
                      type: 'line',
                      borderColor: '#377BFF',
                      cubicInterpolationMode: 'monotone',
                      fill: false,
                      borderDash: [5, 5],
                      tension: 0.6,
                      hoverBackgroundColor: '#377BFF',
                      hoverBorderColor: '#377BFF',
                      backgroundColor: '#377BFF',
                      borderWidth: 1,
                      pointBackgroundColor: '#377BFF',
                      pointHoverBorderColor: '#377BFF',
                      pointHoverRadius: 0,
                      pointRadius: 0,
                    },
                    {
                      data: dataValue,
                      label: this.translateService.instant('PARENTALREPORTS.UTILIZATION.UNDER'),
                      maxBarThickness: window.screen.width > 768 ? 10 : 10,
                      borderColor: ' #ffffff',
                      borderRadius: {
                        topLeft: 10,
                        topRight: 10,
                        bottomRight: 10,
                      },
                      barPercentage: 0.8,
                      categoryPercentage: 0.4,
                      hoverBackgroundColor: '#BFD5FF',
                      hoverBorderColor: '#BFD5FF',
                      backgroundColor: '#BFD5FF',
                      borderWidth: 0,
                      barThickness: 10,
                    },
                    {
                      data: dataValueAllowed,
                      label: this.translateService.instant('PARENTALREPORTS.UTILIZATION.OVER'),
                      maxBarThickness: window.screen.width > 768 ? 60 : 40,
                      borderColor: '#ffffff',
                      borderRadius: {
                        topLeft: 10,
                        topRight: 10,
                        bottomRight: 10,
                      },
                      barPercentage: 0.8,
                      categoryPercentage: 0.4,
                      hoverBackgroundColor: '#377BFF',
                      backgroundColor: '#377BFF',
                      hoverBorderColor: '#377BFF',
                      borderWidth: 0,
                      barThickness: 10,
                    },
                  ],
                },
                options: {
                  maintainAspectRatio: false,
                  indexAxis: 'y',
                  plugins: {
                    legend: {
                      display: true,
                      position: 'top',
                      align: 'end',
                      labels: {
                        boxWidth: 10,
                        boxHeight: 10,
                        generateLabels: (chart: any) => {
                          return chart.data.datasets.map((l: any, i: any) => ({
                            datasetIndex: i,
                            text: chart.data.datasets[i].label,
                            fillStyle: chart.data.datasets[i].backgroundColor,
                            strokeStyle:
                              chart.data.datasets[i].hoverBorderColor,
                          }));
                        },
                        filter: (legendItem, data) => {
                          return legendItem.datasetIndex == 0 ? false : true;
                        },
                        font: {
                          size: 14,
                        },
                      },
                    },
                    tooltip: {
                      displayColors: false,
                      backgroundColor: '#023047',
                      bodyColor: '#FFFFFF',
                      titleColor: '#FFFFFF',
                      borderColor: '#023047',
                      borderWidth: 1,
                      padding: {
                        right: 15,
                        left: 15,
                        top: 10,
                        bottom: 10,
                      },
                      callbacks: {
                        label(tooltipItem) {
                          let hours = Math.floor(
                            parseFloat(tooltipItem.formattedValue)
                          );
                          let mins = Math.round(
                            (parseFloat(tooltipItem.formattedValue) -
                              Math.trunc(
                                parseFloat(tooltipItem.formattedValue)
                              )) *
                            60
                          );
                          return (
                            tooltipItem.dataset.label +
                            ' ' +
                            hours +
                            translate.instant('PARENTALREPORTS.HNOT') +
                            mins +
                            translate.instant('PARENTALREPORTS.HNOT')
                          );
                        },
                      },
                    },
                    datalabels: {
                      anchor: 'end',
                      align: 'end',
                      display: false,
                    },
                  },
                  responsive: true,
                  scales: {
                    x: {
                      stacked: true,
                      grid: {
                        display: true,
                        color: '#F1F1F1',
                        borderDash: [0, 0],
                        drawTicks: false,
                      },
                      title: {
                        display: true,
                        text: this.translateService.instant('PARENTALREPORTS.CHART.HOURS'),
                        font: {
                          family: 'open sans',
                          size: 14,
                        },
                      },
                      ticks: {
                        autoSkip: false,
                        maxRotation: 0,
                        minRotation: 0,
                        callback: function (value) {
                          return `${value}h`;
                        },
                      },
                    },
                    y: {
                      stacked: true,
                      grid: {
                        display: false,
                        color: '#F1F1F1',
                        borderDash: [0, 0],
                        drawTicks: false,
                      },
                      title: {
                        display: true,
                        text: this.translateService.instant('PARENTALREPORTS.CHART.APPS'),
                        font: {
                          family: 'open sans',
                          size: 14,
                        },
                      },
                      ticks: {
                        callback: function (value: any) {
                          return datalabels[value]?.length > 10 &&
                            window.screen.width >= 768
                            ? datalabels[value].substring(0, 7) + '...'
                            : datalabels[value]?.length > 2 &&
                              window.screen.width < 768
                              ? datalabels[value].substring(0, 2) + '...'
                              : datalabels[value];
                        },
                      },
                    },
                  },
                },
                plugins: [legendMargin],
              });
            }, 500);
          }
        } else {
          this.isLoading = false;
        }
      });
  }

  getSmartParentalSettings(userId: any) {
    this._service
      .getService(this._service.API_URL.getParentalSettings + userId)
      .subscribe((response) => {
        if (response && response.status.code === 200) {
          let settings = response['data']?.map((res: any) => res.isEnabled);
          let premiumDeviceData = response['data']?.map(
            (res: any) => res.isPremium
          );
          let enabledSetting = settings.filter(
            (setting: boolean) => setting === true
          );
          let premiumDevice = premiumDeviceData.filter(
            (data: boolean) => data === true
          );
          this.paretalToggle = enabledSetting?.length < 1 ? false : true;
          let deviceListpar = response['data']?.filter(
            (data: any) => data.deviceId === this.deviceId
          );
          this.parentalDeviceToggle = response['data']
            ?.filter((data: any) => data.deviceId === this.deviceId)
            .map((res: any) => res.isEnabled)[0];
          this.parentalPremiumStatus = premiumDevice?.length < 1 ? false : true;
        }
      });
  }

  getRestrictedHitsPerDevice(userId: any) {
    this.getSmartParentalSettings(userId);
    this.textArray = [
      {
        text: this.translateService.instant('PARENTALREPORTS.LIMIT_SET'),
        color: '#FFBFBF',
      },
      {
        text: this.translateService.instant('PARENTALREPORTS.WEB'),
        color: '#D0E2EA',
      },
      {
        text: this.translateService.instant('PARENTALREPORTS.APP'),
        color: '#DC392F',
      },
    ];
    this.isLoading = true;
    this._service
      .getService(this._service.API_URL.getRestictedHitsPerDevice + userId)
      .subscribe((response) => {
        if (response && response.data && response.status.code === 200) {
          this.responseData = response.data;
          if (response.data?.length != 0) {
            this.parentalDeviceReport = true;
          } else {
            this.parentalDeviceReport = false;
          }
          this.isLoading = false;
          this.noOfItemToShowScreen = response.data.length;
          this.parentalRepInfo = response.data;
          this.checkPremiumFeature(this.deviceId);
          if (response.data?.length != 0) {
            setTimeout(() => {
              let chartExist = Chart.getChart('deviceWiseParental'); // <canvas> id
              if (chartExist != undefined) {
                chartExist.destroy();
              }
              let datalabels = response['data']?.map(
                (res: any) => res.category
              );
              let webCountData = response['data']?.map(
                (res: any) => res.webHitCount
              );
              let appHitData = response['data']?.map(
                (res: any) => res.hitCount
              );
              let parentalToggle = response.data?.filter(
                (data: any) =>
                  data.premiumStatus != 'Toggle Off' &&
                  data.premiumStatus != 'Empty Report'
              );
              this.parentalGraph = parentalToggle?.length < 1 ? true : false;
              let webHitCount = response.data
                .filter((data: any) => data.premiumStatus === 'Premium Version')
                ?.map((res: any) => res.webHitCount)
                .reduce((acc: any, curr: any) => acc + curr, 0);
              let appHitCount = response.data
                .filter((data: any) => data.premiumStatus === 'Premium Version')
                ?.map((res: any) => res.hitCount)
                .reduce((acc: any, curr: any) => acc + curr, 0);
              let webBackgroundColors = response['data']?.map((res: any) =>
                res.premiumStatus === 'Premium Version' ? '#FF3C33' : '#C4C4C4'
              );
              let appBackgroundColors = response['data']?.map((res: any) =>
                res.premiumStatus === 'Premium Version' ? '#FAA200' : '#C4C4C4'
              );
              this.totalHitCounts = webHitCount + appHitCount;
              let datalabelUsed: any = this.textArray[1].text;
              let datalabelOver: any = this.textArray[2].text;
              let barwidth = 14;
              let borderwidth = 3;
              if (response.data.length > 1 && response.data.length < 4) {
                barwidth = 9;
                borderwidth = 2;
              }
              let tick1 = {
                autoSkip: false,
                maxRotation: 0,
                minRotation: 0,
                callback: function (val: any, index: string | number) {
                  return datalabels[index].length > 7
                    ? datalabels[index].slice(0, 7) + '...'
                    : datalabels[index];
                },
              };
              let tick2 = {
                autoSkip: false,
                maxRotation: 0,
                minRotation: 0,
                precision: 0,
              };
              let tickx;
              let ticky;
              if (response.data.length > 3) {
                this.parentalChartAxis = 'x';
                this.X_label_parental = this.translateService.instant('PARENTALREPORTS.CHART.DEVICES');
                this.Y_label_parental = this.translateService.instant('PARENTALREPORTS.CHART.NOOFATTEMPTS');
                this.horizontalGrid = true;
                this.verticalGrid = false;
                tickx = tick1;
                ticky = tick2;
              } else {
                this.parentalChartAxis = 'y';
                this.X_label_parental = this.translateService.instant('PARENTALREPORTS.CHART.DEVICES');
                this.Y_label_parental = this.translateService.instant('PARENTALREPORTS.CHART.NOOFATTEMPTS');
                this.horizontalGrid = false;
                this.verticalGrid = true;
                tickx = tick2;
                ticky = tick1;
              }
              const canvas = document.getElementById('deviceWiseParental');
              const ctx = (canvas as HTMLCanvasElement)?.getContext('2d');
              const gradient = ctx?.createLinearGradient(0, 0, 0, 600);
              gradient?.addColorStop(0, '#E48701');
              gradient?.addColorStop(0.5, '#E48701');
              const gradient2 = ctx?.createLinearGradient(0, 0, 0, 600);
              gradient2?.addColorStop(0, '#006EE5');
              gradient2?.addColorStop(1, '#006EE5');
              this.chart = new Chart('deviceWiseParental', {
                type: 'bar',
                data: {
                  labels: datalabels,
                  datasets: [
                    {
                      data: webCountData,
                      label: datalabelUsed,
                      maxBarThickness: window.screen.width > 768 ? 60 : 40,
                      borderColor: '#FFFFFF',
                      borderRadius: {
                        topLeft: 10,
                        topRight: 10,
                        bottomRight: 10,
                      },
                      barPercentage: 0.1,
                      categoryPercentage: 0.5,
                      hoverBackgroundColor: webBackgroundColors,
                      backgroundColor: webBackgroundColors,
                      hoverBorderColor: '#FFFFFF',
                      borderWidth: borderwidth,
                      barThickness: barwidth,
                    },
                    {
                      data: appHitData,
                      label: datalabelOver,
                      maxBarThickness: window.screen.width > 768 ? 60 : 40,
                      borderColor: '#FFFFFF',
                      borderRadius: {
                        topLeft: 10,
                        bottomRight: 10,
                        topRight: 10,
                      },
                      barPercentage: 0.1,
                      categoryPercentage: 0.5,
                      hoverBackgroundColor: appBackgroundColors,
                      backgroundColor: appBackgroundColors,
                      hoverBorderColor: '#FFFFFF',
                      borderWidth: borderwidth,
                      barThickness: barwidth,
                    },
                  ],
                },
                options: {
                  maintainAspectRatio: false,
                  indexAxis: this.parentalChartAxis,
                  plugins: {
                    legend: {
                      display: false,
                      position: 'top',
                      align: 'end',
                    },
                    tooltip: {
                      enabled: true,
                      displayColors: false,
                      backgroundColor: '#023047',
                      bodyColor: '#FFFFFF',
                      titleColor: '#FFFFFF',
                      borderColor: '#023047',
                      borderWidth: 1,
                      padding: {
                        right: 15,
                        left: 15,
                        top: 10,
                        bottom: 10,
                      },
                      callbacks: {
                        label: (tooltipItem) => {
                          let lbl =
                            tooltipItem.dataset.label +
                            ' : ' +
                            tooltipItem.dataset.data[tooltipItem.dataIndex];
                          if (
                            this.responseData[tooltipItem.dataIndex]
                              .premiumStatus === 'LICENSE_EXPIRED'
                          ) {
                            lbl = this.translateService.instant('PARENTALREPORTS.TOOLTIPS.LICENSE_EXPIRED');
                          } else if (
                            this.responseData[tooltipItem.dataIndex]
                              .premiumStatus === 'Free version'
                          ) {
                            lbl = this.translateService.instant('PARENTALREPORTS.TOOLTIPS.FREE_VERSION');
                          } else if (
                            this.responseData[tooltipItem.dataIndex]
                              .premiumStatus === 'Toggle Off'
                          ) {
                            lbl = this.translateService.instant('PARENTALREPORTS.TOOLTIPS.TOGGLE_OFF');
                          } else if (
                            this.responseData[tooltipItem.dataIndex]
                              .premiumStatus === 'Empty Report'
                          ) {
                            lbl = this.translateService.instant('PARENTALREPORTS.TOOLTIPS.EMPTY_REPORT');
                          }
                          return lbl;
                        },
                      },
                    },
                    datalabels: {
                      anchor: 'end',
                      align: 'end',
                      display: false,
                    },
                  },
                  responsive: true,
                  scales: {
                    x: {
                      stacked: false,
                      grid: {
                        display: this.verticalGrid,
                        color: '#F1F1F1',
                        borderDash: [0, 0],
                        drawTicks: false,
                      },
                      title: {
                        display: true,
                        text: this.X_label_parental,
                        font: {
                          family: 'open sans',
                          size: 14,
                        },
                      },
                      ticks: tickx,
                    },
                    y: {
                      stacked: false,
                      grid: {
                        display: this.horizontalGrid,
                        color: '#F1F1F1',
                        borderDash: [0, 0],
                        drawTicks: false,
                      },
                      title: {
                        display: true,
                        text: this.Y_label_parental,
                        font: {
                          family: 'open sans',
                          size: 14,
                        },
                      },
                      ticks: ticky,
                    },
                  },
                },
              });
            }, 500);
          }
        }
      });
  }

  averageAllowedTime: string = '';
  averageTimeLine: any;
  barchartWeeklyLimitScreenTimeControl(deviceId: string) {
    this.isLoading = true;
    this._service
      .getService(
        this._service.API_URL.screentimeweeklyGraphData +
        deviceId +
        '?deviceType=' +
        this.deviceType
      )
      .subscribe((response) => {
        if (response && response.status.code === 200) {
          this.data = response?.data;
          if (this.data.weeklyList.length > 0) {
            this.showWeeklyST = true;
          } else {
            this.showWeeklyST = false;
          }
          this.isLoading = false;
          setTimeout(() => {
            if (response.data.weeklyList?.length != 0) {
              this.norecordsWeeklyLimitScreenTime = false;
            } else {
              this.norecordsWeeklyLimitScreenTime = true;
            }
          }, 300);

          if (this.data.weeklyList?.length != 0) {
            setTimeout(() => {
              let chartExist = Chart?.getChart(
                'myChartWeeklyLimitScreenTimeControl'
              ); // <canvas> id
              if (chartExist != undefined) {
                chartExist.destroy();
              }
              let datalabels = response['data'].weeklyList.map((res: any) =>
                res.key.split('-').join(' ')
              );
              let dataValue = response['data'].weeklyList.map(
                (res: any) => res.usedTime
              );
              let dataUsedTime = response['data'].weeklyList.map(
                (res: any) => res.usedTime / 60.0
              );
              let dataValueAllowed = response['data']?.dailyScreenTime;
              let dataUnderTime = response['data'].weeklyList.map(
                (res: any) => res.underTime
              );
              let dataOverTime = response['data'].weeklyList.map(
                (res: any) => res.overTime
              );
              this.averageTimeLine = dataValueAllowed ?? 0;
              this.weeklyScreenHour = Math.floor(
                dataValue.reduce((acc: any, curr: any) => acc + curr, 0) / 60
              );
              this.weeklyScreenMins =
                dataValue.reduce((acc: any, curr: any) => acc + curr, 0) % 60;

              this.averageTimeLine = dataValueAllowed ?? 0;
              let len = 0;
              if (dataValue) len = dataValue?.length;
              let total = 0;
              let avgAllowedTime = 0;
              dataValue.forEach((element: any) => {
                total = total + element;
              });
              avgAllowedTime = total / len;
              let uTHourly = Math.floor(Number(avgAllowedTime / 60));
              let min = Math.floor(avgAllowedTime % 60);
              this.averageAllowedTime =
                uTHourly +
                this.chartsStrings['HRS'] +
                min +
                this.chartsStrings['MINS'];
              const titleTooltip = (tooltipItems: any) => {
                return '';
              };
              const canvas = document.getElementById(
                'myChartWeeklyLimitScreenTimeControl'
              );
              const ctx = (canvas as HTMLCanvasElement)?.getContext('2d');
              const gradient = ctx?.createLinearGradient(0, 0, 0, 600);
              gradient?.addColorStop(0, '#D0E2EA');
              gradient?.addColorStop(0.5, '#EEF4F7');
              const translate = this.translateService;
              this.chart = new Chart('myChartWeeklyLimitScreenTimeControl', {
                type: 'bar',
                data: {
                  labels: datalabels,
                  datasets: [
                    {
                      data: dataUnderTime,
                      label: this.translateService.instant('PARENTALREPORTS.UTILIZATION.UNDER'),
                      maxBarThickness: window.screen.width > 768 ? 60 : 40,
                      borderColor: '#FFBFBF',
                      borderRadius: 10,
                      barPercentage: 0.8,
                      categoryPercentage: 0.4,
                      hoverBackgroundColor: '#FFBFBF',
                      backgroundColor: '#FFBFBF',
                      hoverBorderColor: '#FFBFBF',
                      borderWidth: 0,
                      barThickness: 10,
                    },
                    {
                      data: dataOverTime,
                      label: this.translateService.instant('PARENTALREPORTS.UTILIZATION.OVER'),
                      maxBarThickness: window.screen.width > 768 ? 60 : 40,
                      borderColor: '#FF3C33',
                      borderRadius: {
                        topLeft: 10,
                        bottomRight: 10,
                        topRight: 10,
                      },
                      barPercentage: 0.8,
                      categoryPercentage: 0.4,
                      hoverBackgroundColor: '#FF3C33',
                      backgroundColor: '#FF3C33',
                      hoverBorderColor: '#FF3C33',
                      borderWidth: 0,
                      barThickness: 10,
                    },
                    {
                      data: dataUsedTime,
                      label: this.translateService.instant('PARENTALREPORTS.UTILIZATION.UTILIZEDTIME'),
                      type: 'line',
                      borderColor: '#FF3C33',
                      cubicInterpolationMode: 'monotone',
                      fill: false,
                      borderDash: [5, 5],
                      tension: 0.6,
                      hoverBackgroundColor: '#FF3C33',
                      hoverBorderColor: '#FF3C33',
                      backgroundColor: '#FF3C33',
                      borderWidth: 1,
                      pointBackgroundColor: '#FF3C33',
                      pointHoverBorderColor: '#FF3C33',
                      pointHoverRadius: 0,
                      pointRadius: 0,
                    },
                  ],
                },
                options: {
                  maintainAspectRatio: false,
                  indexAxis: 'x',
                  plugins: {
                    annotation: {
                      annotations: {
                        line1: {
                          type: 'line',
                          borderColor: '#AAA4A4',
                          borderWidth: 1,
                          scaleID: 'y',
                          value: 4,
                          borderDash: [5, 5],
                          label: {
                            content: 'Value = 4',
                            position: 'center',
                            backgroundColor: '#AAA4A4',
                          },
                        },
                      },
                    },
                    legend: {
                      display: false,
                      position: 'top',
                      align: 'end',
                    },
                    tooltip: {
                      backgroundColor: '#023047',
                      bodyColor: '#FFFFFF',
                      titleColor: '#FFFFFF',
                      borderColor: '#023047',
                      borderWidth: 1,
                      yAlign: 'bottom',
                      displayColors: false,
                      padding: {
                        right: 15,
                        left: 15,
                        top: 10,
                        bottom: 10,
                      },
                      callbacks: {
                        label(tooltipItem) {
                          let hours = Math.floor(
                            parseFloat(tooltipItem.formattedValue)
                          );
                          let mins = Math.round(
                            (parseFloat(tooltipItem.formattedValue) -
                              Math.trunc(
                                parseFloat(tooltipItem.formattedValue)
                              )) *
                            60
                          );
                          return (
                            tooltipItem.dataset.label +
                            ' ' +
                            hours +
                            translate.instant('PARENTALREPORTS.HNOT') +
                            mins +
                            translate.instant('PARENTALREPORTS.MNOT')
                          );
                        },
                      },
                    },
                    datalabels: {
                      anchor: 'end',
                      align: 'end',
                      display: false,
                    },
                  },
                  responsive: true,
                  scales: {
                    x: {
                      stacked: true,
                      grid: {
                        display: false,
                        color: '#E7E6E6',
                        borderDash: [5, 5],
                        drawTicks: false,
                      },
                      title: {
                        display: true,
                        text: this.translateService.instant('PARENTALREPORTS.CHART.DAYS'),
                        font: {
                          family: 'open sans',
                          size: 14,
                        },
                      },
                      ticks: {
                        autoSkip: false,
                        maxRotation: 0,
                        minRotation: 0,
                      },
                    },
                    y: {
                      stacked: true,
                      grid: {
                        color: '#F1F1F1',
                        borderDash: [0, 0],
                        drawTicks: false,
                      },
                      title: {
                        display: true,
                        text: this.translateService.instant('PARENTALREPORTS.CHART.TIMEINHOURS'),
                        font: {
                          family: 'open sans',
                          size: 14,
                        },
                      },
                      ticks: {
                        autoSkip: false,
                        maxRotation: 0,
                        minRotation: 0,
                        callback: function (value) {
                          return `${value}h`;
                        },
                      },
                    },
                  },
                },
              });
            }, 500);
          }
        } else {
          this.isLoading = false;
        }
      });
    // return;
  }

  getYoutubeSettings(userId: any) {
    this._service
      .getService(this._service.API_URL.youtubeSettings + userId)
      .subscribe((response) => {
        if (response && response.status.code === 200) {
          let settings = response['data']?.map((res: any) => res.isEnable);
          let enabledSetting = settings.filter(
            (setting: boolean) => setting === true
          );
          this.youtubeToggle = enabledSetting?.length < 1 ? true : false;
          this.youTubeDeviceToggle = response['data']
            ?.filter((data: any) => data.deviceId === this.deviceId)
            .map((res: any) => res.isEnable)[0];
        }
      });
  }

  youtubeUsageChartData(userId: any) {
    this.isLoading = true;
    this.getYoutubeSettings(userId);
    this._service
      .getService(this._service.API_URL.youtubeUsageReport + userId)
      .subscribe((response) => {
        if (response && response.status.code === 200) {
          this.isLoading = false;
          if (
            response.data.filter(
              (data: any) =>
                data.premiumStatus === 'Premium Version' ||
                data.premiumStatus === 'LICENSE_EXPIRED'
            ).length != 0
          ) {
            this.isYoutubeUsageChart = true;
            setTimeout(() => {
              let chartExist = Chart.getChart('youtubeUsageGraph'); // <canvas> id
              if (chartExist != undefined) {
                chartExist.destroy();
              }
              let datalabels = response['data']?.map((res: any) => res.key);
              let dataValue = response['data']?.map((res: any) => res.count);
              this.totalYoutubeUsage = response.data
                .filter((data: any) => data.premiumStatus === 'Premium Version')
                ?.map((res: any) => res.count)
                .reduce((acc: any, curr: any) => acc + curr, 0);
              this.isLoading = false;
              this.parentalRepInfo = response.data;
              this.checkPremiumFeature(this.deviceId);
              let BackgroundColors = response['data']?.map((res: any) =>
                res.premiumStatus === 'Premium Version' ? '#FF3C33' : '#C4C4C4'
              );
              let tick1 = {
                autoSkip: false,
                maxRotation: 0,
                minRotation: 0,
                callback: function (value: any, index: string | number) {
                  return datalabels[index].length > 7
                    ? datalabels[index].slice(0, 7) + '...'
                    : datalabels[index];
                },
              };
              let tick2 = {
                autoSkip: false,
                maxRotation: 0,
                minRotation: 0,
                precision: 0,
                callback: function (value: any) {
                  return `${value}`;
                },
              };
              let tickx;
              let ticky;
              if (response.data.length > 3) {
                tickx = tick1;
                ticky = tick2;
                this.youtubeChartAxis = 'x';
                this.verticalGrid = false;
                this.horizontalGrid = true;
              } else {
                tickx = tick2;
                ticky = tick1;
                this.youtubeChartAxis = 'y';
                this.verticalGrid = true;
                this.horizontalGrid = false;
              }
              this.chart = new Chart('youtubeUsageGraph', {
                type: 'bar',
                data: {
                  labels: datalabels,
                  datasets: [
                    {
                      data: dataValue,
                      label: this.translateService.instant('PARENTALREPORTS.CHART.ATTEMPTS'),
                      borderColor: BackgroundColors,
                      hoverBackgroundColor: BackgroundColors,
                      hoverBorderColor: BackgroundColors,
                      backgroundColor: BackgroundColors,
                      borderWidth: 0,
                      borderRadius: {
                        topLeft: 10,
                        bottomRight: 10,
                        topRight: 10,
                      },
                      barThickness: 10,
                    },
                  ],
                },
                options: {
                  maintainAspectRatio: false,
                  indexAxis: this.youtubeChartAxis,
                  plugins: {
                    legend: {
                      display: false,
                      position: 'top',
                      align: 'end',
                    },
                    tooltip: {
                      displayColors: false,
                      backgroundColor: '#023047',
                      bodyColor: '#FFFFFF',
                      titleColor: '#FFFFFF',
                      borderColor: '#023047',
                      borderWidth: 1,
                      padding: {
                        right: 15,
                        left: 15,
                        top: 10,
                        bottom: 10,
                      },
                      callbacks: {
                        label: (tooltipItem) => {
                          let lbl =
                            tooltipItem.dataset.label +
                            ' : ' +
                            tooltipItem.dataset.data[tooltipItem.dataIndex];
                          if (
                            response.data[tooltipItem.dataIndex]
                              .premiumStatus === 'LICENSE_EXPIRED'
                          ) {
                            lbl = this.translateService.instant('PARENTALREPORTS.TOOLTIPS.LICENSE_EXPIRED');
                          } else if (
                            response.data[tooltipItem.dataIndex]
                              .premiumStatus === 'Free version'
                          ) {
                            lbl = this.translateService.instant('PARENTALREPORTS.TOOLTIPS.FREE_VERSION');
                          } else if (
                            response.data[tooltipItem.dataIndex]
                              .premiumStatus === 'Toggle Off'
                          ) {
                            lbl = this.translateService.instant('PARENTALREPORTS.TOOLTIPS.TOGGLE_OFF');
                          } else if (
                            response.data[tooltipItem.dataIndex]
                              .premiumStatus === 'Empty Report'
                          ) {
                            lbl = this.translateService.instant('PARENTALREPORTS.TOOLTIPS.EMPTY_REPORT');
                          }
                          return lbl;
                        },
                      },
                    },
                    datalabels: {
                      anchor: 'end',
                      align: 'end',
                      display: false,
                    },
                  },
                  responsive: true,
                  scales: {
                    x: {
                      stacked: true,
                      grid: {
                        display: this.verticalGrid,
                        color: '#F1F1F1',
                        borderDash: [0, 0],
                        drawTicks: false,
                      },
                      title: {
                        display: true,
                        text: this.translateService.instant('PARENTALREPORTS.CHART.ATTEMPTS'),
                        font: {
                          family: 'open sans',
                          size: 14,
                        },
                      },
                      ticks: tickx,
                    },
                    y: {
                      stacked: true,
                      grid: {
                        display: this.horizontalGrid,
                        color: '#F1F1F1',
                        borderDash: [0, 0],
                        drawTicks: false,
                      },
                      title: {
                        display: true,
                        text: this.Y_axix_label,
                        font: {
                          family: 'open sans',
                          size: 14,
                        },
                      },
                      ticks: ticky,
                    },
                  },
                },
              });
            }, 200);
          } else {
            this.isYoutubeUsageChart = false;
          }
        }
      });
  }

  getBlockedVideoData(deviceId: any, isAllCat: boolean) {
    this._service
      .getService(
        this._service.API_URL.youtubeBlockedVideos +
        deviceId +
        '?isAllCat=' +
        isAllCat
      )
      .subscribe((response) => {
        if (response && response.status.code === 200) {
          if (isAllCat) {
            this.blockedVideoTable = response.data;
          } else {
            // setTimeout(() => {
            if (response.data.length != 0) {
              this.isBlockedVideoChart = true;

              // }, 500);
              setTimeout(() => {
                let chartExist = Chart.getChart('blockedVideosChart'); // <canvas> id
                if (chartExist != undefined) {
                  chartExist.destroy();
                }
                this.isBlockedVideoChart = true;
                this.youtubeDevices = response['data'].map(
                  (res: any) => res.key
                );
                let datalabels = this.youtubeDevices;
                this.videoCounts = response['data'].map((res: any) =>
                  Math.round(res.usageTime)
                );
                let dataValue = this.videoCounts;
                let counts = response['data'].map((res: any) => res.count);
                this.totalVideoHits = response['data']
                  .map((res: any) => res.count)
                  .reduce((prev: any, curr: any) => prev + curr, 0);
                let hovering = true;
                let substringLimit = 10;
                let backgroundColor = [
                  '#38B2C5',
                  '#377BFF',
                  '#B94282',
                  '#D35FD7',
                  '#FFBE1A',
                  '#FF4040',
                ];
                if (counts[0] == 0) {
                  backgroundColor = ['#F0F0F0'];
                  dataValue = [99];
                  datalabels = [this.translateService.instant('PARENTALREPORTS.CHART.NOOFATTEMPTS')];
                }
                const labelsData = datalabels;
                const doughnutlabel = {
                  id: 'doughnutlabel',
                  beforeDraw(chart: any, args: any, pluginOptions: any) {
                    const { ctx, data } = chart;
                    ctx.save();
                    var text = chart.options.plugins.title.text;
                    var xCoor = chart.getDatasetMeta(0).data[0].x;
                    var yCoor = chart.getDatasetMeta(0).data[0].y;
                    ctx.fillStyle = '#393E4A';
                    ctx.textAlign = 'center';
                    ctx.textBaseline = 'middle';
                    const fontSize = chart.options.plugins.title.font.size;
                    ctx.font = 'bold ' + fontSize + 'px sans-serif';
                    ctx.fillText(text, xCoor, yCoor);
                  },
                };
                let tooltip = document.getElementById('blockedVideosChart'),
                  tooltips = datalabels;
                this.doughnutChartDataFirst = new Chart('blockedVideosChart', {
                  type: 'doughnut',
                  data: {
                    labels: datalabels,
                    datasets: [
                      {
                        backgroundColor: backgroundColor,
                        borderColor: [
                          '#FFFFFF',
                          '#FFFFFF',
                          '#FFFFFF',
                          '#FFFFFF',
                          '#FFFFFF',
                          '#FFFFFF',
                        ],
                        hoverBackgroundColor: backgroundColor,
                        hoverBorderColor: backgroundColor,
                        hoverBorderWidth: 2,
                        data: dataValue,
                        borderWidth: 4,
                        hoverOffset: 1,
                      },
                    ],
                  },
                  options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    cutout: '86%',
                    layout: {
                      padding: {
                        bottom: 10,
                      },
                    },
                    plugins: {
                      title: {
                        display: false,
                        text: this.totalVideoHits + '',
                        font: {
                          size: 20,
                          weight: 'bold',
                        },
                      },
                      legend: {
                        display: false,
                        position: 'right',
                        maxWidth: 130,
                        onHover: function (event: any, legendItem: any) {
                          if (hovering) {
                            return datalabels[legendItem['index']];
                          }
                          hovering = true;
                          if (tooltip != null) {
                            tooltip.innerHTML = tooltips[legendItem['index']];
                            tooltip.style.left = 86 + '%';
                            tooltip.style.top = event.y - 40 + 'px';
                            tooltip.style.padding = '3.5px';
                            tooltip.style.minWidth = 'fit-content';
                            tooltip.style.whiteSpace = 'nowrap';
                          }
                        },
                        onLeave: function () {
                          hovering = false;
                          if (tooltip != null) {
                            tooltip.style.padding = '0px';
                            tooltip.innerHTML = '';
                          }
                        },
                        labels: {
                          generateLabels: (chart: any) => {
                            return chart.data.labels.map((l: any, i: any) => ({
                              datasetIndex: 0,
                              index: i,
                              text:
                                l?.length > substringLimit
                                  ? l.substring(0, substringLimit) + '...'
                                  : l,
                              fillStyle:
                                chart.data.datasets[0].backgroundColor[i],
                              strokeStyle:
                                chart.data.datasets[0].hoverBorderColor[i],
                              hiddens: !chart.getDatasetMeta(0).data[i].hidden,
                            }));
                          },
                          padding: 18,
                          usePointStyle: true,
                          font: {
                            size:
                              window.screen.width > 700 &&
                                window.screen.width < 800
                                ? 14
                                : window.screen.width < 1366
                                  ? 10
                                  : 12,
                          },
                        },
                        onClick(e: any, legendItem: any, legend: any) {
                          const index = legendItem.index;
                          const currentLabels = this.chart.data.labels;
                          let newLabels: any[] = [];
                          if (currentLabels) {
                            for (let i = 0; i < currentLabels?.length; i++) {
                              if (i == index) {
                                if (labelsData[i] == currentLabels[i]) {
                                  newLabels?.push(
                                    String(currentLabels[i])
                                      .split('')
                                      .map((char: any) => char + '\u0336')
                                      .join('')
                                  );
                                  legend.chart.getDatasetMeta(0).data[
                                    i
                                  ].hidden = true;
                                  legend.chart.getDatasetMeta(0).data[
                                    i
                                  ].visible = false;
                                  substringLimit = 15;
                                } else {
                                  newLabels.push(String(labelsData[i]));
                                  legend.chart.getDatasetMeta(0).data[
                                    i
                                  ].hidden = false;
                                  legend.chart.getDatasetMeta(0).data[
                                    i
                                  ].visible = true;
                                }
                              } else {
                                newLabels.push(String(currentLabels[i]));
                              }
                            }
                          }
                          // Update the label at the clicked index
                          this.chart.data.labels = newLabels;
                          this.chart.update();
                        },
                      },
                      tooltip: {
                        enabled: true,
                        backgroundColor: '#023047',
                        bodyColor: '#FFFFFF',
                        titleColor: '#FFFFFF',
                        borderColor: '#023047',
                        borderWidth: 1,
                        callbacks: {
                          label: (tooltipItem) => {
                            let lbl =
                              tooltipItem.label +
                              ' : ' +
                              counts[tooltipItem.dataIndex];
                            return lbl;
                          },
                        },
                      },
                      datalabels: {
                        display: false,
                        formatter: function (value, context: any) {
                          let hiddens = context.chart._hiddenIndices;
                          let total = 0;
                          let datapoints = context.dataset.data;
                          datapoints.forEach((val: any, i: any) => {
                            if (hiddens[i] != undefined) {
                              if (!hiddens[i]) {
                                total += val;
                              }
                            } else {
                              total += val;
                            }
                          });
                          let percentage =
                            ((value / total) * 100).toFixed(0) + '%';
                          let out =
                            context.chart.data.labels[context.dataIndex] ==
                              datalabels[context.dataIndex]
                              ? percentage
                              : '';
                          return out;
                        },
                        labels: {
                          value: {
                            color: 'black',
                            font: {
                              size:
                                window.screen.width > 700 &&
                                  window.screen.width < 800
                                  ? 14
                                  : window.screen.width < 1366
                                    ? 10
                                    : 12,
                            },
                          },
                        },
                      },
                    },
                  },
                  plugins: [doughnutlabel],
                });
                var ctx1 = this.doughnutChartDataFirst.ctx;
                var originalStroke = ctx1.stroke;
                ctx1.stroke = function () {
                  ctx1.save();
                  ctx1.shadowColor = '#D4D5D9';
                  ctx1.shadowBlur = 10;
                  ctx1.shadowOffsetX = 0;
                  ctx1.shadowOffsetY = 4;
                  originalStroke.apply(this, arguments);
                  ctx1.restore();
                };
              }, 0);
            } else {
              this.isBlockedVideoChart = false;
            }
          }
        }
      });
  }

  getBlockedChannelsData(deviceId: any, isAllCat: boolean) {
    this._service
      .getService(
        this._service.API_URL.youtubeBlockedChannels +
        deviceId +
        '?isAllCat=' +
        isAllCat
      )
      .subscribe((response) => {
        if (response && response.status.code === 200) {
          if (isAllCat) {
            this.blockedChannelTableData = response.data;
          } else {
            if (response.data.length != 0) {
              this.isBlockedChannnelChart = true;
              setTimeout(() => {
                let chartExist = Chart.getChart('blockedChannnelChart'); // <canvas> id
                if (chartExist != undefined) {
                  chartExist.destroy();
                }
                this.channelList = response['data'].map((res: any) => res.key);
                this.channelVistValue = response['data'].map((res: any) =>
                  Math.round(res.usageTime)
                );
                let datalabels = this.channelList;
                let dataValue = this.channelVistValue;
                let visitCountList = response['data'].map((res: any) =>
                  Math.round(res.count)
                );
                this.totalChannelCounts = response['data']
                  .map((res: any) => Math.round(res.count))
                  .reduce((prev: any, curr: any) => prev + curr, 0);
                let backgroundColor = [
                  '#38B2C5',
                  '#377BFF',
                  '#B94282',
                  '#D35FD7',
                  '#FFBE1A',
                  '#FF4040',
                ];
                if (visitCountList[0] === 0) {
                  dataValue = [99];
                  datalabels = [this.translateService.instant('PARENTALREPORTS.CHART.NOOFATTEMPTS')];
                  backgroundColor = ['#F0F0F0'];
                } else {
                  for (let i = 0; i < dataValue?.length; i++) {
                    if (dataValue[i] == 0 || dataValue[i] == 0.0) {
                      dataValue.splice(dataValue.indexOf(dataValue[i]), 1);
                      datalabels.splice(dataValue.indexOf(dataValue[i]), 1);
                      i--;
                    }
                  }
                }
                let substringLimit = 10;
                const labelsData = datalabels;
                let hovering = false;
                let tooltip = document.getElementById('AppUsagetooltip'),
                  tooltips = datalabels;
                const doughnutlabel = {
                  id: 'doughnutlabel',
                  beforeDraw(chart: any, args: any, pluginOptions: any) {
                    const { ctx, data } = chart;
                    ctx.save();
                    var text = chart.options.plugins.title.text;
                    var xCoor = chart.getDatasetMeta(0).data[0].x;
                    var yCoor = chart.getDatasetMeta(0).data[0].y;
                    ctx.fillStyle = '#393E4A';
                    ctx.textAlign = 'center';
                    ctx.textBaseline = 'middle';
                    const fontSize = chart.options.plugins.title.font.size;
                    ctx.font = 'bold ' + fontSize + 'px sans-serif';
                    ctx.fillText(text, xCoor, yCoor);
                  },
                };
                this.doughnutChartDataFirst = new Chart(
                  'blockedChannnelChart',
                  {
                    type: 'doughnut',
                    data: {
                      labels: datalabels,
                      datasets: [
                        {
                          backgroundColor: backgroundColor,
                          borderColor: [
                            '#FFFFFF',
                            '#FFFFFF',
                            '#FFFFFF',
                            '#FFFFFF',
                            '#FFFFFF',
                            '#FFFFFF',
                          ],
                          hoverBackgroundColor: backgroundColor,
                          hoverBorderColor: backgroundColor,
                          hoverBorderWidth: 2,
                          data: dataValue,
                          borderWidth: 4,
                          hoverOffset: 1,
                        },
                      ],
                    },
                    options: {
                      responsive: true,
                      maintainAspectRatio: false,
                      cutout: '86%',
                      layout: {
                        padding: {
                          bottom: 10,
                        },
                      },
                      plugins: {
                        title: {
                          display: false,
                          text: this.totalChannelCounts + '',
                          font: {
                            size: 20,
                            weight: 'bold',
                          },
                        },
                        legend: {
                          display: false,
                          position: 'right',
                          maxWidth: 130,
                          onHover: function (event: any, legendItem: any) {
                            if (hovering) {
                              return datalabels[legendItem['index']];
                            }
                            hovering = true;
                            if (tooltip != null) {
                              tooltip.innerHTML = tooltips[legendItem['index']];
                              tooltip.style.left = 86 + '%';
                              tooltip.style.top = event.y - 40 + 'px';
                              tooltip.style.padding = '3.5px';
                              tooltip.style.minWidth = 'fit-content';
                              tooltip.style.whiteSpace = 'nowrap';
                            }
                          },
                          onLeave: function () {
                            hovering = false;
                            if (tooltip != null) {
                              tooltip.style.padding = '0px';
                              tooltip.innerHTML = '';
                            }
                          },
                          labels: {
                            generateLabels: (chart: any) => {
                              return chart.data.labels.map(
                                (l: any, i: any) => ({
                                  datasetIndex: 0,
                                  index: i,
                                  text:
                                    l?.length > substringLimit
                                      ? l.substring(0, substringLimit) + '...'
                                      : l,
                                  fillStyle:
                                    chart.data.datasets[0].backgroundColor[i],
                                  strokeStyle:
                                    chart.data.datasets[0].hoverBorderColor[i],
                                  hiddens:
                                    !chart.getDatasetMeta(0).data[i].hidden,
                                })
                              );
                            },
                            padding: 18,
                            usePointStyle: true,
                            font: {
                              size:
                                window.screen.width > 700 &&
                                  window.screen.width < 800
                                  ? 14
                                  : window.screen.width < 1366
                                    ? 10
                                    : 12,
                            },
                          },
                          onClick(e: any, legendItem: any, legend: any) {
                            const index = legendItem.index;
                            const currentLabels = this.chart.data.labels;
                            let newLabels: any[] = [];
                            if (currentLabels) {
                              for (let i = 0; i < currentLabels?.length; i++) {
                                if (i == index) {
                                  if (labelsData[i] == currentLabels[i]) {
                                    newLabels?.push(
                                      String(currentLabels[i])
                                        .split('')
                                        .map((char: any) => char + '\u0336')
                                        .join('')
                                    );
                                    legend.chart.getDatasetMeta(0).data[
                                      i
                                    ].hidden = true;
                                    legend.chart.getDatasetMeta(0).data[
                                      i
                                    ].visible = false;
                                    substringLimit = 15;
                                  } else {
                                    newLabels.push(String(labelsData[i]));
                                    legend.chart.getDatasetMeta(0).data[
                                      i
                                    ].hidden = false;
                                    legend.chart.getDatasetMeta(0).data[
                                      i
                                    ].visible = true;
                                  }
                                } else {
                                  newLabels.push(String(currentLabels[i]));
                                }
                              }
                            }
                            // Update the label at the clicked index
                            this.chart.data.labels = newLabels;
                            this.chart.update();
                          },
                        },
                        tooltip: {
                          enabled: true,
                          backgroundColor: '#023047',
                          bodyColor: '#FFFFFF',
                          titleColor: '#FFFFFF',
                          borderColor: '#023047',
                          borderWidth: 1,
                          callbacks: {
                            label: (tooltipItem) => {
                              let lbl =
                                tooltipItem.label +
                                ' : ' +
                                visitCountList[tooltipItem.dataIndex];
                              return lbl;
                            },
                          },
                        },
                        datalabels: {
                          display: false,
                          formatter: function (value, context: any) {
                            let hiddens = context.chart._hiddenIndices;
                            let total = 0;
                            let datapoints = context.dataset.data;
                            datapoints.forEach((val: any, i: any) => {
                              if (hiddens[i] != undefined) {
                                if (!hiddens[i]) {
                                  total += val;
                                }
                              } else {
                                total += val;
                              }
                            });
                            let percentage =
                              ((value / total) * 100).toFixed(0) + '%';
                            let out =
                              context.chart.data.labels[context.dataIndex] ==
                                datalabels[context.dataIndex]
                                ? percentage
                                : '';
                            return out;
                          },
                          labels: {
                            value: {
                              color: 'black',
                              font: {
                                size:
                                  window.screen.width > 700 &&
                                    window.screen.width < 800
                                    ? 14
                                    : window.screen.width < 1366
                                      ? 10
                                      : 12,
                              },
                            },
                          },
                        },
                      },
                    },
                    plugins: [doughnutlabel],
                  }
                );
                var ctx1 = this.doughnutChartDataFirst.ctx;
                var originalStroke = ctx1.stroke;
                ctx1.stroke = function () {
                  ctx1.save();
                  ctx1.shadowColor = '#D4D5D9';
                  ctx1.shadowBlur = 10;
                  ctx1.shadowOffsetX = 0;
                  ctx1.shadowOffsetY = 4;
                  originalStroke.apply(this, arguments);
                  ctx1.restore();
                };
              }, 300);
            } else {
              this.isBlockedChannnelChart = false;
            }
          }
        }
      });
  }

  getVideoCatData(deviceId: any, isAllCat: boolean) {
    this.isLoading = false;
    this._service
      .getService(
        this._service.API_URL.youTubeReports +
        deviceId +
        '?isChannel=' +
        false +
        '&isAllCat=' +
        isAllCat +
        '&width' +
        this.screenWidth +
        '&height=' +
        this.screenHeight
      )
      .subscribe((response) => {
        if (response && response.status.code === 200) {
          this.isLoading = false;
          if (isAllCat) {
            this.videoCatTableData = response.data.graphList;
          } else {
            if (response.data.graphList.length != 0) {
              this.isVideoCatChart = true;
              setTimeout(() => {
                let chartExist = Chart.getChart('videoCatVisitChart'); // <canvas> id
                if (chartExist != undefined) {
                  chartExist.destroy();
                }
                let datalabels = response['data'].graphList?.map(
                  (res: any) => res.key
                );
                let dataValue = response['data'].graphList?.map(
                  (res: any) => res.count
                );
                this.totalVideoCatVisits = dataValue.reduce(
                  (prev: any, curr: any) => prev + curr,
                  0
                );
                let barColors = [
                  '#38B2C5',
                  '#377BFF',
                  '#FF3C33',
                  '#FFBE1A',
                  '#B750F0',
                ];
                this.chart = new Chart('videoCatVisitChart', {
                  type: 'bar',
                  data: {
                    labels: datalabels,
                    datasets: [
                      {
                        data: dataValue,
                        borderColor: barColors,
                        borderRadius: {
                          topLeft: 10,
                          topRight: 10,
                          bottomRight: 10,
                        },
                        barPercentage: 0.5,
                        hoverBackgroundColor: barColors,
                        backgroundColor: barColors,
                        hoverBorderColor: barColors,
                        barThickness: 10,
                        borderWidth: 0,
                      },
                    ],
                  },
                  options: {
                    maintainAspectRatio: false,
                    indexAxis: 'y',
                    plugins: {
                      legend: {
                        display: false,
                      },
                      tooltip: {
                        yAlign: 'bottom',
                        displayColors: false,
                        backgroundColor: '#023047',
                        bodyColor: '#FFFFFF',
                        titleColor: '#FFFFFF',
                        borderColor: '#023047',
                        borderWidth: 1,
                        padding: {
                          right: 15,
                          left: 15,
                          top: 10,
                          bottom: 10,
                        },
                      },
                      datalabels: {
                        anchor: 'end',
                        align: 'end',
                        display: false,
                      },
                    },
                    responsive: true,
                    scales: {
                      x: {
                        grid: {
                          color: '#F1F1F1',
                          borderDash: [0, 0],
                          drawTicks: false,
                        },
                        title: {
                          display: true,
                          text: this.translateService.instant('PARENTALREPORTS.CHART.X_AXIS_VISITS'),
                          font: {
                            family: 'open sans',
                            size: 14,
                          },
                        },
                        ticks: {
                          precision: 0,
                        },
                      },
                      y: {
                        grid: {
                          display: false,
                          color: '#E7E6E6',
                          borderDash: [5, 5],
                          drawTicks: false,
                        },
                        title: {
                          display: true,
                          text: this.translateService.instant('PARENTALREPORTS.CHART.Y_AXIS_VIDEO_CATEGORIES'),
                          font: {
                            family: 'open sans',
                            size: 14,
                          },
                        },
                        ticks: {
                          callback: function (value: any) {
                            return datalabels[value]?.length > 10 &&
                              window.screen.width >= 768
                              ? datalabels[value].substring(0, 10) + '...'
                              : datalabels[value]?.length > 2 &&
                                window.screen.width < 768
                                ? datalabels[value].substring(0, 2) + '...'
                                : datalabels[value];
                          },
                          autoSkip: false,
                          maxRotation: 0,
                          minRotation: 0,
                        },
                      },
                    },
                  },
                });
              }, 300);
            } else {
              this.isVideoCatChart = false;
            }
          }
        }
      });
  }

  getChannelVisitsData(deviceId: any, isAllCat: boolean) {
    this.isLoading = false;
    this._service
      .getService(
        this._service.API_URL.youTubeReports +
        deviceId +
        '?isChannel=' +
        true +
        '&isAllCat=' +
        isAllCat +
        '&width' +
        this.screenWidth +
        '&height=' +
        this.screenHeight
      )
      .subscribe((response) => {
        if (response && response.status.code === 200) {
          this.isLoading = false;
          if (isAllCat) {
            this.channelVisitTableData = response.data.graphList;
          } else {
            if (response.data.graphList.length != 0) {
              this.isChannelVisitChart = true;
              setTimeout(() => {
                let chartExist = Chart.getChart('channelVisitChart'); // <canvas> id
                if (chartExist != undefined) {
                  chartExist.destroy();
                }
                let datalabels = response['data'].graphList?.map(
                  (res: any) => res.key
                );
                let dataValue = response['data'].graphList?.map(
                  (res: any) => res.count
                );
                this.toatlChannelVisits = dataValue.reduce(
                  (prev: any, curr: any) => prev + curr,
                  0
                );
                let barColors = [
                  '#38B2C5',
                  '#377BFF',
                  '#FF3C33',
                  '#FFBE1A',
                  '#B750F0',
                ];
                this.chart = new Chart('channelVisitChart', {
                  type: 'bar',
                  data: {
                    labels: datalabels,
                    datasets: [
                      {
                        data: dataValue,
                        borderColor: barColors,
                        borderRadius: {
                          topLeft: 10,
                          topRight: 10,
                          bottomRight: 10,
                        },
                        barPercentage: 0.5,
                        hoverBackgroundColor: barColors,
                        backgroundColor: barColors,
                        hoverBorderColor: barColors,
                        barThickness: 10,
                        borderWidth: 0,
                      },
                    ],
                  },
                  options: {
                    maintainAspectRatio: false,
                    indexAxis: 'y',
                    plugins: {
                      legend: {
                        display: false,
                      },
                      tooltip: {
                        yAlign: 'bottom',
                        displayColors: false,
                        backgroundColor: '#023047',
                        bodyColor: '#FFFFFF',
                        titleColor: '#FFFFFF',
                        borderColor: '#023047',
                        borderWidth: 1,
                        padding: {
                          right: 15,
                          left: 15,
                          top: 10,
                          bottom: 10,
                        },
                      },
                      datalabels: {
                        anchor: 'end',
                        align: 'end',
                        display: false,
                      },
                    },
                    responsive: true,
                    scales: {
                      x: {
                        grid: {
                          color: '#F1F1F1',
                          borderDash: [0, 0],
                          drawTicks: false,
                        },
                        title: {
                          display: true,
                          text: this.translateService.instant('PARENTALREPORTS.CHART.X_AXIS_VISITS'),
                          font: {
                            family: 'open sans',
                            size: 14,
                          },
                        },
                        ticks: {
                          precision: 0,
                        },
                      },
                      y: {
                        grid: {
                          display: false,
                          color: '#E7E6E6',
                          borderDash: [5, 5],
                          drawTicks: false,
                        },
                        title: {
                          display: true,
                          text: this.translateService.instant('PARENTALREPORTS.CHART.CHANNELS'),
                          font: {
                            family: 'open sans',
                            size: 14,
                          },
                        },
                        ticks: {
                          callback: function (value: any) {
                            return datalabels[value]?.length > 10 &&
                              window.screen.width >= 768
                              ? datalabels[value].substring(0, 10) + '...'
                              : datalabels[value]?.length > 2 &&
                                window.screen.width < 768
                                ? datalabels[value].substring(0, 2) + '...'
                                : datalabels[value];
                          },
                          autoSkip: false,
                          maxRotation: 0,
                          minRotation: 0,
                        },
                      },
                    },
                  },
                });
              }, 300);
            } else {
              this.isChannelVisitChart = false;
            }
          }
        }
      });
  }

  barchartlength: any;
  barchartYouTubeReport(deviceId: any) {
    this.isLoading = true;
    this._service
      .getService(
        this._service.API_URL.youTubeReports +
        deviceId +
        '?isChannel=' +
        this.isChannel +
        '&width=' +
        this.screenWidth +
        '&height=' +
        this.screenHeight
      )
      .subscribe((response) => {
        if (response && response.status.code === 200) {
          this.lastUpdatedDate = response.data.lastUpdatedDate;
          this.data = response.data;
          this.isLoading = false;
          this.noOfItemToShow = response.data.noOfItemToShow;
          setTimeout(() => {
            if (response.data.graphList?.length != 0) {
              this.norecordsYouTubeReport = false;
            } else {
              this.norecordsYouTubeReport = true;
            }
          }, 300);

          if (this.data.graphList?.length != 0) {
            setTimeout(() => {
              let chartExist = Chart.getChart('myChartYouTubeReport'); // <canvas> id
              if (chartExist != undefined) {
                chartExist.destroy();
              }
              let datalabels = response['data'].graphList?.map(
                (res: any) => res.key
              );
              let dataValue = response['data'].graphList?.map(
                (res: any) => res.count
              );
              this.barchartlength = response.data.noOfItemToShow;
              const titleTooltip = (tooltipItems: any) => {
                return '';
              };
              const canvas = document.getElementById('myChartYouTubeReport');
              const ctx = (canvas as HTMLCanvasElement)?.getContext('2d');
              const gradient = ctx?.createLinearGradient(0, 0, 0, 600);
              gradient?.addColorStop(0, '#D0E2EA');
              gradient?.addColorStop(0.5, '#EEF4F7');
              this.chart = new Chart('myChartYouTubeReport', {
                type: 'bar',
                data: {
                  labels: datalabels,
                  datasets: [
                    {
                      data: dataValue,
                      // maxBarThickness: 45,
                      borderColor: '#136B97',
                      borderRadius: {
                        topLeft: 10,
                        topRight: 10,
                      },
                      barPercentage: 0.5,
                      barThickness:
                        window.screen.width > 768
                          ? 60
                          : window.screen.width < 768 &&
                            window.screen.width > 480
                            ? 30
                            : 20,
                      hoverBackgroundColor: '#136B97',
                      backgroundColor: gradient,
                      hoverBorderColor: '#9ecfdb',
                      borderWidth: 1,
                      borderSkipped: false,
                    },
                  ],
                },
                options: {
                  maintainAspectRatio: false,
                  plugins: {
                    legend: {
                      display: false,
                    },
                    tooltip: {
                      yAlign: 'bottom',
                      displayColors: false,
                      padding: {
                        right: 15,
                        left: 15,
                        top: 10,
                        bottom: 10,
                      },
                    },
                    datalabels: {
                      anchor: 'end',
                      align: 'end',
                      display: false,
                    },
                  },
                  responsive: true,
                  scales: {
                    x: {
                      grid: {
                        color: '#E7E6E6',
                        borderDash: [5, 5],
                      },
                      title: {
                        display: true,
                        text: this.xaxisTittleYoutube,
                        font: {
                          family: 'open sans',
                          size: 14,
                        },
                      },

                      ticks: {
                        callback: function (value: any) {
                          return datalabels[value]?.length > 10 &&
                            window.screen.width >= 768
                            ? datalabels[value].substring(0, 10) + '...'
                            : datalabels[value]?.length > 2 &&
                              window.screen.width < 768
                              ? datalabels[value].substring(0, 2) + '...'
                              : datalabels[value];
                        },
                        autoSkip: false,
                        maxRotation: 0,
                        minRotation: 0,
                      },
                    },
                    y: {
                      grid: {
                        color: '#E7E6E6',
                        borderDash: [5, 5],
                      },
                      title: {
                        display: true,
                        text: this.chartsStrings['NOOFVISITS'],
                        font: {
                          family: 'open sans',
                          size: 14,
                        },
                      },
                      ticks: {
                        precision: 0,
                      },
                    },
                  },
                },
              });
            }, 500);
          }
        } else {
          this.weeklyScreenHour = 0;
          this.weeklyScreenMins = 0;
          this.isLoading = false;
        }
      });
    // return;
  }

  totalCount: number = 0;

  totalthreatCount: number = 0;
  totalthreatDetectedCount: number = 0;

  countText: any;
  donughtChart(deviceId: any) {
    this.isLoading = true;
    this._service
      .getService(
        this._service.API_URL.threatDonutReport +
        deviceId +
        '?deviceType=' +
        this.deviceType
      )
      .subscribe((response) => {
        if (response && response.status.code === 200) {
          setTimeout(() => {
            this.totalthreatCount = 0;
            let count = response['data']?.map((res: any) => res.count);
            this.countText = count;
            count.forEach((element: any) => {
              this.totalthreatCount = this.totalthreatCount + element;
            });

            let counts = response['data']?.map((res: any) => res.totalCount);
            counts.forEach((element: any) => {
              this.totalthreatDetectedCount = element;
            });
          }, 450);
          this.data = response.data;
          this.isLoading = false;
          this.noOfItemToShow = response.data.noOfItemToShow;
          setTimeout(() => {
            if (response.data?.length != 0) {
              this.norecordsThreatWebUsage = false;
            } else {
              this.norecordsThreatWebUsage = true;
            }
          }, 300);
          let datalabels = response['data']?.map((res: any) => res.key);
          const dataValue = response['data']?.map((res: any) => res.count);
          this.threatname = datalabels;
          this.threatcount = dataValue;
          for (let i = 0; i < dataValue?.length; i++) {
            if (dataValue[i] == 0 || dataValue[i] == 0.0) {
              dataValue.splice(dataValue.indexOf(dataValue[i]), 1);
              datalabels.splice(dataValue.indexOf(dataValue[i]), 1);
              i = i - 1;
            }
          }
          let substringLimit = 10;
          const labelsData = datalabels;

          if (this.data?.length != 0) {
            setTimeout(() => {
              let chartExist = Chart.getChart('myChartWebUsage'); // <canvas> id
              if (chartExist != undefined) {
                chartExist.destroy();
              }

              let hovering = false;
              let tooltip = document.getElementById('threatWebUsagetooltip'),
                tooltips = datalabels;
              const canvas = document.getElementById('myChartWebUsage');
              const ctx = (canvas as HTMLCanvasElement)?.getContext('2d');
              const gradient = ctx?.createLinearGradient(0, 0, 0, 600);
              let purpleGradient = ctx?.createLinearGradient(0, 0, 0, 450);
              let yellowGradient = ctx?.createLinearGradient(0, 0, 0, 450);
              let pinkGradient = ctx?.createLinearGradient(0, 0, 0, 450);
              let blueGradient = ctx?.createLinearGradient(0, 0, 0, 450);
              let redGradient = ctx?.createLinearGradient(0, 0, 0, 450);
              let greyGradient = ctx?.createLinearGradient(0, 0, 0, 450);
              let redishGradient = ctx?.createLinearGradient(0, 0, 0, 450);
              purpleGradient?.addColorStop(0, 'rgba(255, 208, 13, 1)');
              purpleGradient?.addColorStop(1, 'rgba(255, 208, 13, 1)');
              yellowGradient?.addColorStop(0, 'rgba(255, 189, 19, 1)');
              yellowGradient?.addColorStop(1, 'rgba(255, 213, 106, 0.8)');
              pinkGradient?.addColorStop(0, 'rgba(250, 51, 255, 1)');
              pinkGradient?.addColorStop(1, 'rgba(253, 175, 255, 0.8)');
              blueGradient?.addColorStop(0, 'rgba(80, 51, 255, 1)');
              blueGradient?.addColorStop(1, 'rgba(80, 51, 255, 0.6)');
              redGradient?.addColorStop(0, 'rgba(255, 94, 94, 1)');
              redGradient?.addColorStop(1, 'rgba(255, 255, 255, 0)');
              greyGradient?.addColorStop(0, 'rgba(209, 209, 209, 1)');
              greyGradient?.addColorStop(1, 'rgba(255, 255, 255, 0.8)');
              redishGradient?.addColorStop(0, 'rgba(255, 60, 51, 1)');
              redishGradient?.addColorStop(1, 'rgba(255, 60, 51, 1)');
              let chartColors = [
                'rgba(112, 161, 255, 0.8)rgba(242,247,255,0)',
                'rgba(255, 200, 58, 0.8)rgba(255,222,137,0)',
                'rgba(250,51,255,0.8)rgba(253,175,255,0)',
                'rgba(80,51,255,0.8)rgba(80,51,255,0)',
                'rgba(255, 64, 64, 0.8)rgba(255,255,255,0)',
                'rgba(209,209,209,0.8)rgba(255,255,255,0)',
              ];

              const doughnutlabel = {
                id: 'doughnutlabel',
                beforeDraw(chart: any, args: any, pluginOptions: any) {
                  const { ctx, data } = chart;
                  ctx.save();
                  var text = chart.options.plugins.title.text;
                  var xCoor = chart.getDatasetMeta(0).data[0].x;
                  var yCoor = chart.getDatasetMeta(0).data[0].y;
                  ctx.fillStyle = '#393E4A';
                  ctx.textAlign = 'center';
                  ctx.textBaseline = 'middle';
                  const fontSize = chart.options.plugins.title.font.size;
                  ctx.font = 'bold ' + fontSize + 'px sans-serif';
                  ctx.fillText(text, xCoor, yCoor);
                },
              };
              this.chart = new Chart('myChartWebUsage', {
                type: 'doughnut',
                data: {
                  labels: datalabels,
                  datasets: [
                    {
                      backgroundColor: [
                        '#FF4040',
                        '#FFBE1A',
                        '#377BFF',
                        '#B94282',
                        '#D35FD7',
                        '#38B2C5',
                      ],
                      borderColor: [
                        '#FFFFFF',
                        '#FFFFFF',
                        '#FFFFFF',
                        '#FFFFFF',
                        '#FFFFFF',
                        '#FFFFFF',
                      ],
                      hoverBackgroundColor: [
                        '#FF4040',
                        '#FFBE1A',
                        '#377BFF',
                        '#B94282',
                        '#D35FD7',
                        '#38B2C5',
                      ],
                      hoverBorderColor: [
                        '#FF4040',
                        '#FFBE1A',
                        '#377BFF',
                        '#B94282',
                        '#D35FD7',
                        '#38B2C5',
                      ],
                      hoverBorderWidth: 2,
                      borderWidth: 3,
                      data: dataValue,
                      hoverOffset: 1,
                    },
                  ],
                },
                options: {
                  responsive: true,
                  maintainAspectRatio: false,
                  cutout: '85%',
                  layout: {
                    padding: {
                      bottom: 10,
                    },
                  },
                  plugins: {
                    title: {
                      display: false,
                      text: this.totalthreatCount + '',
                      font: {
                        size: 20,
                        weight: 'bold',
                      },
                    },
                    legend: {
                      display: false,
                      position: 'right',
                      maxWidth: 130,
                      onHover:
                        this.deviceType == 'SYSTEM'
                          ? function (event: any, legendItem: any) {
                            hovering = false;
                          }
                          : function (event: any, legendItem: any) {
                            if (hovering) {
                              return datalabels[legendItem['index']];
                            }
                            hovering = true;
                            if (tooltip != null) {
                              tooltip.innerHTML =
                                tooltips[legendItem['index']];
                              tooltip.style.left = 86 + '%';
                              tooltip.style.top = event.y - 40 + 'px';
                              tooltip.style.padding = '3.5px';
                              tooltip.style.minWidth = 'fit-content';
                              tooltip.style.whiteSpace = 'nowrap';
                            }
                          },
                      onLeave: function () {
                        hovering = false;
                        if (tooltip != null) {
                          tooltip.style.padding = '0px';
                          tooltip.innerHTML = '';
                        }
                      },
                      labels: {
                        generateLabels: (chart: any) => {
                          return chart.data.labels.map((l: any, i: any) => ({
                            datasetIndex: 0,
                            index: i,
                            // chart.data.datasets.text = "middle",
                            text:
                              l?.length > substringLimit
                                ? l.substring(0, substringLimit) + '...'
                                : l + ' ' + chart.data.datasets[0].data[i],
                            fillStyle:
                              chart.data.datasets[0].backgroundColor[i],
                            strokeStyle:
                              chart.data.datasets[0].hoverBorderColor[i],
                            hiddens: !chart.getDatasetMeta(0).data[i].hidden,
                          }));
                        },

                        padding: 18,
                        usePointStyle: true,
                        font: {
                          size:
                            window.screen.width > 700 &&
                              window.screen.width < 800
                              ? 14
                              : window.screen.width < 1366
                                ? 10
                                : 12,
                        },
                      },
                      onClick(e: any, legendItem: any, legend: any) {
                        const index = legendItem.index;
                        const currentLabels = this.chart.data.labels;
                        let newLabels: any[] = [];
                        if (currentLabels) {
                          for (let i = 0; i < currentLabels?.length; i++) {
                            if (i == index) {
                              if (labelsData[i] == currentLabels[i]) {
                                newLabels?.push(
                                  String(currentLabels[i])
                                    .split('')
                                    .map((char: any) => char + '\u0336')
                                    .join('')
                                );
                                legend.chart.getDatasetMeta(0).data[i].hidden =
                                  true;
                                legend.chart.getDatasetMeta(0).data[
                                  i
                                ].visible = 0;
                                substringLimit = 15;
                              } else {
                                newLabels.push(String(labelsData[i]));
                                legend.chart.getDatasetMeta(0).data[i].hidden =
                                  false;
                                legend.chart.getDatasetMeta(0).data[
                                  i
                                ].visible = 1;
                              }
                            } else {
                              newLabels.push(String(currentLabels[i]));
                            }
                          }
                        }
                        // Update the label at the clicked index
                        this.chart.data.labels = newLabels;
                        this.chart.update();
                      },
                    },

                    tooltip: {
                      enabled: true,
                      backgroundColor: '#023047',
                      titleColor: '#FFFFFF',
                      bodyColor: '#FFFFFF',
                      titleFont: { weight: 'bold' },
                      padding: 9,
                      cornerRadius: 3,
                      position: 'nearest',
                      borderColor: '#023047',
                      borderWidth: 1,
                      usePointStyle: true,
                      xAlign: left,
                      callbacks: {
                        title: () => {
                          return '';
                        },
                      },
                    },
                    datalabels: {
                      display: false,
                      formatter: function (value, context: any) {
                        let hiddens = context.chart._hiddenIndices;
                        let total = 0;
                        let datapoints = context.dataset.data;
                        datapoints.forEach((val: any, i: any) => {
                          if (hiddens[i] != undefined) {
                            if (!hiddens[i]) {
                              total += val;
                            }
                          } else {
                            total += val;
                          }
                        });
                        let percentage =
                          ((value / total) * 100).toFixed(0) + '%';
                        let out =
                          context.chart.data.labels[context.dataIndex] ==
                            datalabels[context.dataIndex]
                            ? percentage
                            : '';
                        return out;
                      },

                      labels: {
                        value: {
                          color: 'black',
                          font: {
                            size:
                              window.screen.width > 700 &&
                                window.screen.width < 800
                                ? 14
                                : window.screen.width < 1366
                                  ? 10
                                  : 12,
                          },
                        },
                      },
                    },
                  },
                },
                plugins: [doughnutlabel],
              });
              var ctx1 = this.chart.ctx;
              var originalStroke = ctx1.stroke;
              ctx1.stroke = function () {
                ctx1.save();
                ctx1.shadowColor = '#D4D5D9';
                ctx1.shadowBlur = 10;
                ctx1.shadowOffsetX = 0;
                ctx1.shadowOffsetY = 4;
                originalStroke.apply(this, arguments);
                ctx1.restore();
              };
            }, 500);
          }
        } else {
          this.isLoading = false;
        }
      });
    // return;
  }

  hourlystring: string;
  screenTimeDoughnutChart(deviceId: any) {
    this.isLoading = true;
    this._service
      .getService(this._service.API_URL.screentimedoughnutReport + deviceId)
      .subscribe((response) => {
        if (response && response.status.code === 200) {
          setTimeout(() => {
            this.totalCount = 0;
          }, 450);
          this.data = response.data;
          this.isLoading = false;
          this.noOfItemToShow = response.data.noOfItemToShow;
          setTimeout(() => {
            if (response.data?.length > 0) {
              this.showScreentimeDonut = true;
            } else {
              this.showScreentimeDonut = false;
            }
            this.norecordsScreentimeDougnut = response.data?.length == 0;
          }, 300);

          if (this.data?.length != 0) {
            setTimeout(() => {
              let chartExist = Chart.getChart('screentimeDougnut'); // <canvas> idscreentimeDougnut
              if (chartExist != undefined) {
                chartExist.destroy();
              }
              response.data.forEach((element: any) => {
                this.totalCount = this.totalCount + element.usedTime;
              });
              this.hourlystring = this.giveHourlyData(this.totalCount);
              let datalabels: any[] = response['data']?.map(
                (res: any) => res.key
              );
              this.screenDonutApps = datalabels;
              let dataValue: any[] = response['data']?.map((res: any) =>
                Math.round(res.percentage)
              );
              let usageInMins: any[] = response['data']?.map((res: any) =>
                Math.round(res.usedTime)
              );
              this.screenDonutPercentage = dataValue;
              for (let i = 0; i < dataValue?.length; i++) {
                if (dataValue[i] == 0 || dataValue[i] == 0.0) {
                  dataValue.splice(dataValue.indexOf(dataValue[i]), 1);
                  datalabels.splice(dataValue.indexOf(dataValue[i]), 1);
                  i--;
                }
              }
              let substringLimit = 10;
              const labelsData = datalabels;
              let hovering = false;
              let tooltip = document.getElementById('screentimetooltip'),
                tooltips = datalabels;
              const canvas = document.getElementById('screentimeDougnut');
              const ctx = (canvas as HTMLCanvasElement)?.getContext('2d');
              const gradient = ctx?.createLinearGradient(0, 0, 0, 600);
              let purpleGradient = ctx?.createLinearGradient(0, 0, 0, 450);
              let yellowGradient = ctx?.createLinearGradient(0, 0, 0, 450);
              let pinkGradient = ctx?.createLinearGradient(0, 0, 0, 450);
              let blueGradient = ctx?.createLinearGradient(0, 0, 0, 450);
              let redGradient = ctx?.createLinearGradient(0, 0, 0, 450);
              let greyGradient = ctx?.createLinearGradient(0, 0, 0, 450);
              purpleGradient?.addColorStop(0, 'rgba(112, 161, 255, 1)');
              purpleGradient?.addColorStop(1, 'rgba(242, 247, 255, 1)');
              yellowGradient?.addColorStop(0, 'rgba(255, 189, 19, 1)');
              yellowGradient?.addColorStop(1, 'rgba(255, 213, 106, 0.8)');
              pinkGradient?.addColorStop(0, 'rgba(250, 51, 255, 1)');
              pinkGradient?.addColorStop(1, 'rgba(253, 175, 255, 0.8)');
              blueGradient?.addColorStop(0, 'rgba(80, 51, 255, 1)');
              blueGradient?.addColorStop(1, 'rgba(80, 51, 255, 0.6)');
              redGradient?.addColorStop(0, 'rgba(255, 94, 94, 1)');
              redGradient?.addColorStop(1, 'rgba(255, 255, 255, 0)');
              greyGradient?.addColorStop(0, 'rgba(209, 209, 209, 1)');
              greyGradient?.addColorStop(1, 'rgba(255, 255, 255, 0.8)');

              let chartColors = [
                'rgba(112, 161, 255, 0.8)rgba(242,247,255,0)',
                'rgba(255, 200, 58, 0.8)rgba(255,222,137,0)',
                'rgba(250,51,255,0.8)rgba(253,175,255,0)',
                'rgba(80,51,255,0.8)rgba(80,51,255,0)',
                'rgba(255, 64, 64, 0.8)rgba(255,255,255,0)',
                'rgba(209,209,209,0.8)rgba(255,255,255,0)',
              ];
              const doughnutlabel = {
                id: 'doughnutlabel',
                beforeDraw(chart: any, args: any, pluginOptions: any) {
                  const { ctx, data } = chart;
                  ctx.save();
                  var text = chart.options.plugins.title.text;
                  var xCoor = chart.getDatasetMeta(0).data[0].x;
                  var yCoor = chart.getDatasetMeta(0).data[0].y;
                  ctx.fillStyle = '#393E4A';
                  ctx.textAlign = 'center';
                  ctx.textBaseline = 'middle';
                  const fontSize = chart.options.plugins.title.font.size;
                  ctx.font = 'bold ' + fontSize + 'px sans-serif';
                  ctx.fillText(text, xCoor, yCoor);
                },
              };
              this.chart = new Chart('screentimeDougnut', {
                type: 'doughnut',
                data: {
                  labels: datalabels,
                  datasets: [
                    {
                      backgroundColor: [
                        '#38B2C5',
                        '#377BFF',
                        '#B94282',
                        '#D35FD7',
                        '#FFBE1A',
                        '#FF4040',
                      ],
                      borderColor: [
                        '#FFFFFF',
                        '#FFFFFF',
                        '#FFFFFF',
                        '#FFFFFF',
                        '#FFFFFF',
                        '#FFFFFF',
                      ],
                      hoverBackgroundColor: [
                        '#38B2C5',
                        '#377BFF',
                        '#B94282',
                        '#D35FD7',
                        '#FFBE1A',
                        '#FF4040',
                      ],
                      hoverBorderColor: [
                        '#38B2C5',
                        '#377BFF',
                        '#B94282',
                        '#D35FD7',
                        '#FFBE1A',
                        '#FF4040',
                      ],
                      hoverBorderWidth: 4,
                      data: dataValue,
                      hoverOffset: 1,
                      borderWidth: 3,
                    },
                  ],
                },
                options: {
                  responsive: true,
                  maintainAspectRatio: false,
                  cutout: '85%',
                  layout: {
                    padding: {
                      bottom: 10,
                    },
                  },
                  plugins: {
                    title: {
                      display: false,
                      text: this.hourlystring,
                      font: {
                        size: 20,
                        weight: 'bold',
                      },
                    },
                    legend: {
                      display: false,
                      position: 'right',
                      maxWidth: 130,
                      onHover: function (event: any, legendItem: any) {
                        if (hovering) {
                          return datalabels[legendItem['index']];
                        }
                        hovering = true;
                        if (tooltip != null) {
                          tooltip.innerHTML = tooltips[legendItem['index']];
                          tooltip.style.left = 86 + '%';
                          tooltip.style.top = event.y - 40 + 'px';
                          tooltip.style.padding = '3.5px';
                          tooltip.style.minWidth = 'fit-content';
                          tooltip.style.whiteSpace = 'nowrap';
                        }
                      },
                      onLeave: function () {
                        hovering = false;
                        if (tooltip != null) {
                          tooltip.style.padding = '0px';
                          tooltip.innerHTML = '';
                        }
                      },

                      labels: {
                        generateLabels: (chart: any) => {
                          return chart.data.labels.map((l: any, i: any) => ({
                            datasetIndex: 0,
                            index: i,
                            text:
                              l?.length > substringLimit
                                ? l.substring(0, substringLimit) +
                                '...(' +
                                chart.data.datasets[0].data[i] +
                                '%)'
                                : l +
                                ' (' +
                                chart.data.datasets[0].data[i] +
                                '%)',
                            fillStyle:
                              chart.data.datasets[0].backgroundColor[i],
                            strokeStyle:
                              chart.data.datasets[0].hoverBorderColor[i],
                            hiddens: !chart.getDatasetMeta(0).data[i].hidden,
                          }));
                        },
                        padding: 10,
                        usePointStyle: true,
                        font: {
                          size:
                            window.screen.width > 700 &&
                              window.screen.width < 800
                              ? 14
                              : window.screen.width < 1366
                                ? 10
                                : 12,
                        },
                      },
                      onClick(e: any, legendItem: any, legend: any) {
                        const index = legendItem.index;
                        const currentLabels = this.chart.data.labels;
                        this.chart.update();
                      },
                    },
                    tooltip: {
                      enabled: true,
                      backgroundColor: '#023047',
                      bodyColor: '#FFFFFF',
                      titleColor: '#FFFFFF',
                      borderColor: '#023047',
                      borderWidth: 1,
                      callbacks: {
                        label: (tooltipItem) => {
                          let lbl =
                            tooltipItem.label +
                            ' : ' +
                            this.giveHourlyData(
                              usageInMins[tooltipItem.dataIndex]
                            );
                          return lbl;
                        },
                      },
                    },
                    datalabels: {
                      display: false,
                      formatter: function (value, context: any) {
                        let hiddens = context.chart._hiddenIndices;
                        let total = 0;
                        let datapoints = context.dataset.data;
                        datapoints.forEach((val: any, i: any) => {
                          if (hiddens[i] != undefined) {
                            if (!hiddens[i]) {
                              total += val;
                            }
                          } else {
                            total += val;
                          }
                        });
                        let percentage =
                          ((value / total) * 100).toFixed(0) + '%';
                        let out =
                          context.chart.data.labels[context.dataIndex] ==
                            datalabels[context.dataIndex]
                            ? percentage
                            : '';
                        return out;
                      },
                      labels: {
                        value: {
                          color: 'black',
                          font: {
                            size:
                              window.screen.width > 700 &&
                                window.screen.width < 800
                                ? 14
                                : window.screen.width < 1366
                                  ? 10
                                  : 12,
                          },
                        },
                      },
                    },
                  },
                },
                plugins: [doughnutlabel],
              });
              var ctx1 = this.chart.ctx;
              var originalStroke = ctx1.stroke;
              ctx1.stroke = function () {
                ctx1.save();
                ctx1.shadowColor = '#D4D5D9';
                ctx1.shadowBlur = 10;
                ctx1.shadowOffsetX = 0;
                ctx1.shadowOffsetY = 4;
                originalStroke.apply(this, arguments);
                ctx1.restore();
              };
            }, 500);
          }
        } else {
          this.isLoading = false;
        }
      });
  }

  threatDeviceCount: any[] = [];
  devicenamelength: any;
  deviceNameData: any;
  imagesList: any;
  images = [
    { url: './assets/images/deviceNameimage1.svg' },
    { url: './assets/images/deviceNameimage2.svg' },
    { url: '/assets/images/deviceNameimage3.svg' },
    { url: '/assets/images/deviceNameimage4.svg' },
    { url: '/assets/images/deviceNameimage5.svg' },
    { url: '/assets/images/deviceNameimage6.svg' },
    { url: '/assets/images/deviceNameimage7.svg' },
    { url: '/assets/images/deviceNameimage8.svg' },
    { url: '/assets/images/deviceNameimage9.png' },
    { url: '/assets/images/deviceNameimage10.svg' },
  ];
  item: { key: unknown } = { key: 'string' }; // Adjust the type as needed
  isString(value: unknown): value is string {
    return typeof value === 'string';
  }
  areaNoOfCategories: any;
  areaChart(userId: any) {
    this.isLoading = true;
    this._service
      .getService(
        this._service.API_URL.threatReportsDevices +
        this.user +
        '?width=' +
        this.screenWidth +
        '&height=' +
        this.screenHeight +
        '&deviceType=' +
        'MOBILE'
      )
      .subscribe((response) => {
        if (response && response.status.code === 200) {
          this.lastUpdatedDate = response.data.lastUpdatedDate;
          this.data = response.data;
          this.areaNoOfCategories = response.data.noOfItemToShow;
          this.isLoading = false;
          let countsList2: any[] = [];
          let totalcountsnew: any[] = [];
          response.data.graphList.forEach(
            (item: { youtubeTableDtoList: any[] }) => {
              countsList2.push(item.youtubeTableDtoList);
            }
          );
          this.noOfItemToShowThreat = countsList2.filter(
            (countsList2) => countsList2.length != 0
          );
          this.threatsdetected = this.noOfItemToShowThreat.length;
          this.threatDeviceCount = this.noOfItemToShowThreat;
          let devicenameset = new Set();
          let deviceNameList = this.threatDeviceCount.flatMap((subArray) =>
            subArray.map((obj: { deviceName: any }) =>
              devicenameset.add(obj.deviceName)
            )
          );
          this.threatDeviceCount.map((i) => i.deviceName);
          deviceNameList.filter(
            (i) => i.deviceName && i.deviceName !== i.deviceName
          );
          this.deviceNameData = Array.from(devicenameset);
          this.devicenamelength = this.deviceNameData.length;
          this.imagesList = this.images;
          this.deviceNameListMap = new Map();
          // Populate the Map using the two lists
          this.deviceNameData.forEach((key: any, index: string | number) => {
            const value = this.imagesList[index];
            this.deviceNameListMap.set(key, value.url);
          });

          setTimeout(() => {
            this.totalCount = 0;
          }, 300);
          setTimeout(() => {
            let chartExist = Chart.getChart('threatReportChart'); // <canvas> id
            if (chartExist != undefined) {
              chartExist.destroy();
            }
            response.data.graphList.forEach(
              (graph: { youtubeTableDtoList: any[] }) => {
                let totalcounts: string[] = [];
                graph.youtubeTableDtoList.forEach((item) => {
                  totalcounts.push(item.count);
                });
                totalcountsnew.push(totalcounts);
              }
            );

            let countsList: string[] = [];
            response.data.graphList.forEach(
              (graph: { youtubeTableDtoList: any[] }) => {
                graph.youtubeTableDtoList.forEach((item) => {
                  countsList.push(item.count);
                });
              }
            );

            countsList.forEach((element: any) => {
              this.totalCount = this.totalCount + element;
            });
            let datalabels =
              response.data.graphList[0].youtubeTableDtoList?.map(
                (res: any) => res.date
              );
            const titleTooltip = (tooltipItems: any) => {
              return '';
            };
            const canvas = document.getElementById('threatReportChart');
            const ctx = (canvas as HTMLCanvasElement)?.getContext('2d');
            let areaGradient = ctx?.createLinearGradient(0, 0, 0, 600);
            areaGradient?.addColorStop(0, '#D0E2EA');
            areaGradient?.addColorStop(0.5, '#EEF4F7');
            this.chart = new Chart('threatReportChart', {
              type: 'line',
              data: {
                labels: datalabels,
                datasets: [
                  {
                    data: totalcountsnew[0],
                    borderColor: '#FF3C33',
                    backgroundColor: '#ffff',
                    cubicInterpolationMode: 'monotone',
                    tension: 0.001,
                    fill: false,
                    pointStyle: 'dot',
                    pointBackgroundColor: '#FF3C33',
                    pointHoverBackgroundColor: '#FF3C33',
                    pointRadius: 5,
                  },
                  {
                    data: totalcountsnew[1],
                    borderColor: '#0D79FF',
                    backgroundColor: '#ffff',
                    cubicInterpolationMode: 'monotone',
                    tension: 0.001,
                    fill: false,
                    pointStyle: 'dot',
                    pointBackgroundColor: '#0D79FF',
                    pointHoverBackgroundColor: '#0D79FF',
                    pointRadius: 5,
                  },
                  {
                    data: totalcountsnew[2],
                    borderColor: '#FF950D',
                    backgroundColor: '#ffff',
                    cubicInterpolationMode: 'monotone',
                    tension: 0.001,
                    fill: false,
                    pointStyle: 'dot',
                    pointBackgroundColor: '#FF950D',
                    pointHoverBackgroundColor: '#FF3C0D79FF33',
                    pointRadius: 5,
                  },
                  {
                    data: totalcountsnew[3],
                    borderColor: '#D35FD7',
                    backgroundColor: '#ffff',
                    cubicInterpolationMode: 'monotone',
                    tension: 0.001,
                    fill: false,
                    pointStyle: 'dot',
                    pointBackgroundColor: '#D35FD7',
                    pointHoverBackgroundColor: '#FF3C0D79FF33',
                    pointRadius: 5,
                  },
                  {
                    data: totalcountsnew[4],
                    borderColor: '#38B2C5',
                    backgroundColor: '#ffff',
                    cubicInterpolationMode: 'monotone',
                    tension: 0.001,
                    fill: false,
                    pointStyle: 'dot',
                    pointBackgroundColor: '#38B2C5',
                    pointHoverBackgroundColor: '#FF3C0D79FF33',
                    pointRadius: 5,
                  },
                  {
                    data: totalcountsnew[5],
                    borderColor: '#7CB342',
                    backgroundColor: '#ffff',
                    cubicInterpolationMode: 'monotone',
                    tension: 0.001,
                    fill: false,
                    pointStyle: 'dot',
                    pointBackgroundColor: '#7CB342',
                    pointHoverBackgroundColor: '#FF3C0D79FF33',
                    pointRadius: 5,
                  },
                  {
                    data: totalcountsnew[6],
                    borderColor: '#039BE5',
                    backgroundColor: '#ffff',
                    cubicInterpolationMode: 'monotone',
                    tension: 0.001,
                    fill: false,
                    pointStyle: 'dot',
                    pointBackgroundColor: '#039BE5',
                    pointHoverBackgroundColor: '#FF3C0D79FF33',
                    pointRadius: 5,
                  },
                  {
                    data: totalcountsnew[7],
                    borderColor: '#673AB7',
                    backgroundColor: '#ffff',
                    cubicInterpolationMode: 'monotone',
                    tension: 0.001,
                    fill: false,
                    pointStyle: 'dot',
                    pointBackgroundColor: '#673AB7',
                    pointHoverBackgroundColor: '#FF3C0D79FF33',
                    pointRadius: 5,
                  },
                  {
                    data: totalcountsnew[8],
                    borderColor: '#546E7A',
                    backgroundColor: '#ffff',
                    cubicInterpolationMode: 'monotone',
                    tension: 0.001,
                    fill: false,
                    pointStyle: 'dot',
                    pointBackgroundColor: '#546E7A',
                    pointHoverBackgroundColor: '#FF3C0D79FF33',
                    pointRadius: 5,
                  },
                  {
                    data: totalcountsnew[9],
                    borderColor: '#FFF176',
                    backgroundColor: '#ffff',
                    cubicInterpolationMode: 'monotone',
                    tension: 0.001,
                    fill: false,
                    pointStyle: 'dot',
                    pointBackgroundColor: '#FFF176',
                    pointHoverBackgroundColor: '#FF3C0D79FF33',
                    pointRadius: 5,
                  },
                  {
                    data: totalcountsnew[10],
                    borderColor: '#FFF176',
                    backgroundColor: '#ffff',
                    cubicInterpolationMode: 'monotone',
                    tension: 0.001,
                    fill: false,
                    pointStyle: 'dot',
                    pointBackgroundColor: '#FFF176',
                    pointHoverBackgroundColor: '#FF3C0D79FF33',
                    pointRadius: 5,
                  },
                ],
              },
              options: {
                plugins: {
                  datalabels: {
                    display: false,
                  },
                  legend: {
                    display: false,
                  },
                  tooltip: {
                    enabled: true,
                    backgroundColor: '#023047',
                    titleColor: '#FFFFFF',
                    bodyColor: '#FFFFFF',
                    titleFont: { weight: 'bold' },
                    padding: 9,
                    cornerRadius: 3,
                    position: 'nearest',
                    borderColor: '#023047',
                    borderWidth: 1,
                    usePointStyle: true,
                    xAlign: left,
                    callbacks: {
                      title: () => {
                        return '';
                      },
                    },
                  },
                  title: {
                    display: true,
                  },
                },
                scales: {
                  y: {
                    suggestedMin: 0,
                    suggestedMax: 6,
                    grid: {
                      color: '#E7E6E6',
                      borderDash: [5, 0],
                    },
                    title: {
                      display: true,
                      text:
                        this.deviceType == 'MOBILE'
                          ? this.chartsStrings['THREATCOUNT']
                          : this.chartsStrings['THREATSDETECTED'],
                      font: {
                        family: 'open sans',
                        size: 12,
                      },
                    },
                    ticks: {
                      precision: 0,
                    },
                  },
                  x: {
                    grid: {
                      display: false,
                      color: '#E7E6E6',
                      borderDash: [0, 5],
                    },
                    title: {
                      display: true,
                      text: this.chartsStrings['DAYS'],
                      font: {
                        family: 'open sans',
                        size: 14,
                      },
                    },
                    ticks: {
                      callback: function (value: any) {
                        if (datalabels[value]?.length > 10) {
                          return datalabels[value].substr(0, 10) + '...';
                        } else {
                          return datalabels[value];
                        }
                      },
                      autoSkip: false,
                      maxRotation: 0,
                      minRotation: 0,
                    },
                  },
                },
                responsive: true,
                maintainAspectRatio: false,
              },
            });
          }, 500);
          //}
        } else {
          this.isLoading = false;
        }
      });
  }
  areaNoOfCategories1: any;
  areaChartSmall(deviceId: any) {
    this.isLoading = true;
    this._service
      .getService(
        this._service.API_URL.threatReports +
        deviceId +
        '?width=' +
        this.screenWidth +
        '&height=' +
        this.screenHeight +
        '&deviceType=' +
        this.deviceType
      )
      .subscribe((response) => {
        if (response && response.status.code === 200) {
          this.lastUpdatedDate = response.data.lastUpdatedDate;

          this.data = response.data;
          this.areaNoOfCategories = response.data.noOfItemToShow;
          this.isLoading = false;
          let responseData = response.data.graphList;
          setTimeout(() => {
            this.norecordsThreatReportArea = responseData?.length == 0;
          }, 300);

          if (this.data.graphList?.length != 0) {
            setTimeout(() => {
              let chartExist = Chart.getChart('smallThreatReportChart'); // <canvas> id
              if (chartExist != undefined) {
                chartExist.destroy();
              }
              let datalabels = responseData?.map((res: any) => res.date);
              let dataValue = responseData?.map((res: any) => res.count);
              datalabels = datalabels.reverse();
              dataValue = dataValue.reverse();
              const titleTooltip = (tooltipItems: any) => {
                return '';
              };
              const canvas = document.getElementById('smallThreatReportChart');
              const ctx = (canvas as HTMLCanvasElement)?.getContext('2d');
              let areaGradient = ctx?.createLinearGradient(0, 0, 0, 600);
              areaGradient?.addColorStop(0, '#D0E2EA');
              areaGradient?.addColorStop(0.5, '#EEF4F7');
              this.chart = new Chart('smallThreatReportChart', {
                type: 'line',
                data: {
                  labels: datalabels,
                  datasets: [
                    {
                      data: dataValue,
                      borderColor: '#FF3C33',
                      backgroundColor: '#ffff',
                      cubicInterpolationMode: 'monotone',
                      fill: false,
                      pointStyle: 'dot',
                      pointBackgroundColor: '#FF3C33',
                      pointHoverBackgroundColor: '#FF3C33',
                      pointRadius: 5,
                    },
                  ],
                },
                options: {
                  plugins: {
                    datalabels: {
                      display: false,
                    },
                    legend: {
                      display: false,
                    },
                    tooltip: {
                      enabled: true,
                      backgroundColor: '#023047',
                      titleColor: '#FFFFFF',
                      bodyColor: '#FFFFFF',
                      titleFont: { weight: 'bold' },
                      padding: 9,
                      cornerRadius: 3,
                      position: 'nearest',
                      borderColor: '#023047',
                      borderWidth: 1,
                      usePointStyle: true,
                      xAlign: left,
                      callbacks: {
                        title: () => {
                          return '';
                        },
                      },
                    },
                    title: {
                      display: true,
                    },
                  },
                  scales: {
                    y: {
                      suggestedMin: 0,
                      suggestedMax: 6,
                      grid: {
                        color: '#E7E6E6',
                        borderDash: [5, 0],
                      },
                      title: {
                        display: true,
                        text:
                          this.deviceType == 'SYSTEM'
                            ? this.chartsStrings['THREATCOUNT']
                            : this.chartsStrings['THREATSDETECTED'],
                        font: {
                          family: 'open sans',
                          size: 14,
                        },
                      },
                      ticks: {
                        precision: 0,
                      },
                    },
                    x: {
                      grid: {
                        display: false,
                        color: '#E7E6E6',
                        borderDash: [0, 5],
                      },
                      title: {
                        display: true,
                        text: this.chartsStrings['DAYS'],
                        font: {
                          family: 'open sans',
                          size: 14,
                        },
                      },
                      ticks: {
                        callback: function (value: any) {
                          if (datalabels[value]?.length > 10) {
                            return datalabels[value].substr(0, 10) + '...';
                          } else {
                            return datalabels[value];
                          }
                        },
                        autoSkip: false,
                        maxRotation: 0,
                        minRotation: 0,
                      },
                    },
                  },
                  responsive: true,
                  maintainAspectRatio: false,
                },
              });
            }, 500);
          }
        } else {
          this.isLoading = false;
        }
      });
  }

  getScreentimeSettings(userId: any) {
    this._service
      .getService(this._service.API_URL.getScreentimeSettings + userId)
      .subscribe((response: any) => {
        if (response && response.data && response.status.code === 200) {
          let settings = response['data']?.map((res: any) => res.isEnabled);
          let dumy = response['data']?.filter(
            (res: any) => res.deviceId === this.deviceId
          );
          this.screenDeviceToggle =
            this.deviceType == 'SYSTEM' ? true : dumy[0].isEnabled;
          let enabledSetting = settings.filter(
            (setting: boolean) => setting === true
          );
          if (settings.length != 0) {
            this.screenToggle = enabledSetting?.length < 1 ? false : true;
          } else {
            this.screenToggle = true;
          }
        }
      });
  }

  //Devicewise Screentime Repoprt same from Dashboard
  textArray1: any[] = [];
  getScreentimeData(userId: any) {
    this.textArray1 = [
      {
        text: this.translateService.instant('PARENTALREPORTS.UTILIZATION.LIMIT'),
        color: '#FFBFBF',
      },
      {
        text: this.translateService.instant('PARENTALREPORTS.UTILIZATION.UNDER'),
        color: '#D0E2EA',
      },
      {
        text: this.translateService.instant('PARENTALREPORTS.UTILIZATION.OVER'),
        color: '#DC392F',
      },
    ];
    this.isLoading = true;
    this.getScreentimeSettings(userId);
    this._service
      .getService(
        this._service.API_URL.getUserWiseScreentime +
        userId +
        '?width=' +
        this.screenWidth +
        '&height=' +
        this.screenHeight
      )
      .subscribe((response) => {
        if (response && response.data && response.status.code === 200) {
          console.log(response.data);
          this.data = response.data;
          this.isLoading = false;
          this.noOfDeviceData = response.data.filter(
            (temp: any) => temp.settingStatus === 'Report Device'
          ).length;
          if (response.data.length > 3) {
            this.screentimeHorizon = 'x';
            (this.recommdAxis = 'y'), (this.horizontalGrid = true);
            this.verticalGrid = false;
            this.X_axis_label = this.translateService.instant('PARENTALREPORTS.CHART.DEVICES');
            this.Y_axix_label = this.translateService.instant('PARENTALREPORTS.CHART.HOURS');
          } else {
            this.screentimeHorizon = 'y';
            (this.recommdAxis = 'x'), (this.horizontalGrid = false);
            this.verticalGrid = true;
            this.X_axis_label = this.translateService.instant('PARENTALREPORTS.CHART.HOURS');
            this.Y_axix_label = this.translateService.instant('PARENTALREPORTS.CHART.DEVICES');
          }

          setTimeout(() => {
            if (
              response.data.graphList &&
              response.data.graphList?.length != 0
            ) {
              this.norecordsWeekScreenTimeControl = false;
            } else {
              this.norecordsWeekScreenTimeControl = true;
            }
          }, 300);

          if (response.data.graphList?.length != 0) {
            setTimeout(() => {
              let chartExist = Chart.getChart('deviceWiseScreentime'); // <canvas> id
              if (chartExist != undefined) {
                chartExist.destroy();
              }
              let datalabels = response['data']?.map(
                (res: any) => res.deviceName
              );
              let dataValue = response['data']?.map((res: any) =>
                res.settingStatus === 'Report Device' ? res.usedTime : 0
              );
              let dataUnderTime = response['data']?.map(
                (res: any) => res.underTime
              );
              let dataOverTime = response['data']?.map(
                (res: any) => res.overTime
              );
              let settingStatusData = response['data']?.map(
                (res: any) => res.settingStatus
              );
              let overBarColors = response['data']?.map((res: any) =>
                res.settingStatus === 'Report Device' ? '#FF3C33' : '#C4C4C4'
              );
              let datalabelUsed: any = this.textArray1[1].text;
              let datalabelOver: any = this.textArray1[2].text;
              this.totalScreentime = dataValue.reduce(
                (acc: any, curr: any) => acc + curr,
                0
              );
              this.totalHours = Math.floor(this.totalScreentime);
              this.totalMin = Math.round(
                (this.totalScreentime - Math.trunc(this.totalScreentime)) * 60
              );
              const titleTooltip = (tooltipItems: any) => {
                return '';
              };
              let tick1 = {
                autoSkip: false,
                maxRotation: 0,
                minRotation: 0,
                callback: function (val: any, index: string | number) {
                  return datalabels[index].length > 7
                    ? datalabels[index].slice(0, 7) + '...'
                    : datalabels[index];
                },
              };
              let tick2 = {
                autoSkip: false,
                maxRotation: 0,
                minRotation: 0,
                precision: 0,
                callback: function (value: any) {
                  return `${value}h`;
                },
              };
              let tickx;
              let ticky;
              if (response.data?.length > 3) {
                tickx = tick1;
                ticky = tick2;
              } else {
                tickx = tick2;
                ticky = tick1;
              }
              const canvas = document.getElementById('deviceWiseScreentime');
              const ctx = (canvas as HTMLCanvasElement)?.getContext('2d');
              const gradient = ctx?.createLinearGradient(0, 0, 0, 600);
              gradient?.addColorStop(0, '#E48701');
              gradient?.addColorStop(0.5, '#E48701');
              const gradient2 = ctx?.createLinearGradient(0, 0, 0, 600);
              gradient2?.addColorStop(0, '#006EE5');
              gradient2?.addColorStop(1, '#006EE5');
              const translate = this.translateService;
              this.chart = new Chart('deviceWiseScreentime', {
                type: 'bar',
                data: {
                  labels: datalabels,
                  datasets: [
                    {
                      data: dataUnderTime,
                      label: datalabelUsed,
                      maxBarThickness: window.screen.width > 768 ? 10 : 10,
                      borderColor: '#FFFFFF',
                      borderRadius: 10,
                      barPercentage: 0.8,
                      categoryPercentage: 0.4,
                      hoverBackgroundColor: '#FFBFBF',
                      backgroundColor: '#FFBFBF',
                      hoverBorderColor: '#FFBFBF',
                      borderWidth: 0,
                      barThickness: 10,
                    },
                    {
                      data: dataOverTime,
                      label: datalabelOver,
                      maxBarThickness: window.screen.width > 768 ? 60 : 40,
                      borderColor: overBarColors,
                      borderRadius: {
                        topLeft: 10,
                        bottomRight: 10,
                        topRight: 10,
                      },
                      barPercentage: 0.8,
                      categoryPercentage: 0.4,
                      hoverBackgroundColor: overBarColors,
                      backgroundColor: overBarColors,
                      hoverBorderColor: overBarColors,
                      borderWidth: 0,
                      barThickness: 10,
                    },
                  ],
                },
                options: {
                  maintainAspectRatio: false,
                  indexAxis: this.screentimeHorizon,
                  plugins: {
                    annotation: {
                      annotations: {
                        line1: {
                          type: 'line',
                          borderColor: '#AAA4A4',
                          borderWidth: 1,
                          scaleID: this.recommdAxis,
                          value: 4,
                          borderDash: [5, 5],
                          label: {
                            content: 'Value = 4',
                            position: 'center',
                            backgroundColor: '#AAA4A4',
                          },
                        },
                      },
                    },
                    legend: {
                      display: false,
                      position: 'top',
                      align: 'end',
                      labels: {
                        padding: 30,
                        usePointStyle: true,
                        boxWidth: 15,
                      },
                    },
                    tooltip: {
                      displayColors: false,
                      backgroundColor: '#023047',
                      bodyColor: '#FFFFFF',
                      titleColor: '#FFFFFF',
                      borderColor: '#023047',
                      borderWidth: 1,
                      padding: {
                        right: 15,
                        left: 15,
                        top: 10,
                        bottom: 10,
                      },
                      callbacks: {
                        label(tooltipItem) {
                          let lbl;
                          if (
                            settingStatusData[tooltipItem.dataIndex] ===
                            'Toggle Off'
                          ) {
                            lbl = translate.instant('PARENTALREPORTS.TOOLTIPS.ENABLE_SCREENTIME');
                          } else if (
                            settingStatusData[tooltipItem.dataIndex] ===
                            'Empty Report'
                          ) {
                            lbl = translate.instant('PARENTALREPORTS.TOOLTIPS.EMPTY_REPORT');
                          } else {
                            let hours = Math.floor(
                              parseFloat(tooltipItem.formattedValue)
                            );
                            let mins = Math.round(
                              (parseFloat(tooltipItem.formattedValue) -
                                Math.trunc(
                                  parseFloat(tooltipItem.formattedValue)
                                )) *
                              60
                            );
                            lbl =
                              tooltipItem.dataset.label +
                              ' ' +
                              hours +
                              translate.instant('PARENTALREPORTS.HNOT') +
                              mins +
                              translate.instant('PARENTALREPORTS.MNOT');
                          }
                          return lbl;
                        },
                      },
                    },
                    datalabels: {
                      anchor: 'end',
                      align: 'end',
                      display: false,
                    },
                  },
                  responsive: true,
                  scales: {
                    x: {
                      stacked: true,

                      grid: {
                        display: this.verticalGrid,
                        color: '#F1F1F1',
                        borderDash: [0, 0],
                        drawTicks: false,
                      },
                      title: {
                        display: true,
                        text: this.X_axis_label,
                        font: {
                          family: 'open sans',
                          size: 14,
                        },
                      },
                      ticks: tickx,
                    },
                    y: {
                      stacked: true,
                      grid: {
                        display: this.horizontalGrid,
                        color: '#F1F1F1',
                        borderDash: [0, 0],
                        drawTicks: false,
                      },
                      title: {
                        display: true,
                        text: this.Y_axix_label,
                        font: {
                          family: 'open sans',
                          size: 14,
                        },
                      },
                      ticks: ticky,
                    },
                  },
                },
              });
            }, 500);
          }
        }
      });
    console.log(this.chart);
  }
  getUserWiseAntiTrackerReport(userId: any) {
    this.isLoading = true;
    this._service
      .getService(this._service.API_URL.getUserWiseAntiTrackerReport + userId)
      .subscribe((response) => {
        if (response && response.data && response.status.code === 200) {
          this.data = response.data;
          this.isLoading = false;
          this.antiTrackerDeviceCnt =
            response.data?.desktopAntiTrackerDtoList?.length;
          this.setAxisForAntiTrackerGraph(this.antiTrackerDeviceCnt);
          if (this.antiTrackerDeviceCnt != 0) {
            setTimeout(() => {
              let chartExist = Chart.getChart('userWiseAntiTrackerReport'); // <canvas> id
              if (chartExist != undefined) {
                chartExist.destroy();
              }
              let datalabels = response['data'].desktopAntiTrackerDtoList?.map(
                (res: any) => res.systemName
              );
              let dataValue = response['data'].desktopAntiTrackerDtoList?.map(
                (res: any) => res.count
              );
              let datalabelUsed: string = this.translateService.instant('PARENTALREPORTS.CHART.TRACKERSBLOCKED');
              this.antiTrackersBlockedCnt = response['data'].totalCnt;
              let tick1 = {
                autoSkip: false,
                maxRotation: 0,
                minRotation: 0,
                callback: function (val: any, index: string | number) {
                  return datalabels[index].length > 7
                    ? datalabels[index].slice(0, 7) + '...'
                    : datalabels[index];
                },
              };
              let tick2 = {
                autoSkip: false,
                maxRotation: 0,
                minRotation: 0,
                precision: 0,
                callback: function (value: any) {
                  return `${value}`;
                },
              };
              let tickx;
              let ticky;
              if (this.antiTrackerDeviceCnt > 3) {
                tickx = tick1;
                ticky = tick2;
              } else {
                tickx = tick2;
                ticky = tick1;
              }

              this.chart = new Chart('userWiseAntiTrackerReport', {
                type: 'bar',
                data: {
                  labels: datalabels,
                  datasets: [
                    {
                      data: dataValue,
                      label: datalabelUsed,
                      maxBarThickness: window.screen.width > 768 ? 60 : 40,
                      borderColor: '#FF3C33',
                      borderRadius: {
                        topLeft: 10,
                        topRight: 10,
                        bottomRight: 10,
                      },
                      barPercentage: 0.8,
                      categoryPercentage: 0.4,
                      hoverBackgroundColor: '#FF3C33',
                      backgroundColor: '#FF3C33',
                      hoverBorderColor: '#FF3C33',
                      borderWidth: 0,
                      barThickness: 10,
                    },
                  ],
                },
                options: {
                  maintainAspectRatio: false,
                  indexAxis: this.antiTrackerChartAxis,
                  plugins: {
                    legend: {
                      display: false,
                      position: 'top',
                      align: 'end',
                    },
                    tooltip: {
                      displayColors: false,
                      padding: {
                        right: 15,
                        left: 15,
                        top: 10,
                        bottom: 10,
                      },
                    },
                    datalabels: {
                      anchor: 'end',
                      align: 'end',
                      display: false,
                    },
                  },
                  responsive: true,
                  scales: {
                    x: {
                      stacked: true,
                      grid: {
                        display: this.verticalGrid,
                        color: '#F1F1F1',
                        borderDash: [0, 0],
                        drawTicks: false,
                      },
                      title: {
                        display: true,
                        text: this.antiTracker_X_lable,
                        font: {
                          family: 'open sans',
                          size: 14,
                        },
                      },
                      ticks: tickx,
                    },
                    y: {
                      stacked: true,
                      grid: {
                        display: this.horizontalGrid,
                        color: '#F1F1F1',
                        borderDash: [0, 0],
                        drawTicks: false,
                      },
                      title: {
                        display: true,
                        text: this.antiTracker_Y_lable,
                        font: {
                          family: 'open sans',
                          size: 14,
                        },
                      },
                      ticks: ticky,
                    },
                  },
                },
              });
            }, 500);
          }
        }
      });
  }
  setAxisForAntiTrackerGraph(count: any) {
    if (count > 3) {
      this.antiTrackerChartAxis = 'x';
      this.horizontalGrid = true;
      this.verticalGrid = false;
      this.antiTracker_X_lable = this.translateService.instant('PARENTALREPORTS.CHART.DEVICES');
      this.antiTracker_Y_lable = this.translateService.instant('PARENTALREPORTS.CHART.TRACKERSBLOCKED');
    } else {
      this.antiTrackerChartAxis = 'y';
      this.horizontalGrid = false;
      this.verticalGrid = true;
      this.antiTracker_X_lable = this.translateService.instant('PARENTALREPORTS.CHART.TRACKERSBLOCKED');
      this.antiTracker_Y_lable = this.translateService.instant('PARENTALREPORTS.CHART.DEVICES');
    }
  }
  removeSpace(event: any) {
    if (event.code === 'Space') {
      event.preventDefault();
    }
  }

  tableShow(el: any, data: any) {
    this.viewmoreArray = [];
    this.viewmoreArray.push(data);
    $('#tableDetails').modal('show');
    if (el == 'SCREENMONITORING') {
      this.isChannelCategoryReport = true;
    } else if (el === 'PARENTALWEBUSAGE') {
      this.isParentalWebUsageReport = true;
    } else if (el === 'YOUTUBEVIDEOREPORT') {
      this.isYoutubeVideoReport = true;
    } else if (el === 'YOUTUBECHANNELREPORT') {
      this.isYoutubeChannelReport = true;
    } else if (el === 'THREATREPORT') {
      this.isThreatReportTable = true;
    } else if (el === 'PARENTALAPPUSAGE') {
      this.isParentalAppUsageReport = true;
    } else if (el === 'FIREWALLREPORT') {
      this.isFirewallReportTable = true;
    }
  }

  goToYoutubeVideo(val: any) {
    if (val.key) {
      window.open(val.key, '_blank');
    } else {
      window.open(val.videoName, '_blank');
    }
  }

  closeTable() {
    $('#tableDetails').modal('hide');
    this.isChannelCategoryReport = false;
    this.isParentalWebUsageReport = false;
    this.isYoutubeVideoReport = false;
    this.isYoutubeChannelReport = false;
    this.isThreatReportTable = false;
    this.isParentalAppUsageReport = false;
    this.isFirewallReportTable = false;
    this.searchText = '';
    this.p = 1;
  }
  openWeeklyAppUsageTable() {
    $('#WeeklyAppSTTablePopup').modal('show');
    this.screenTimeTableData(this.deviceId);
  }

  closeSTTableModal(modalId: String) {
    this.isGraphTrueFalse = true;
    this.isParentalAppUsageReport = false;
    this.isParentalWebUsageReport = false;
    this.isRestAppReport = false;
    this.isRestWebReport = false;
    this.isBlockedChannelReport = false;
    this.isVideoVisitReport = false;
    this.isBlockedVideoReport = false;
    this.isChannelVisitReport = false;
    $(modalId).modal('hide');
  }

  getname(val: any) {
    let l = val?.length;
    let final = '';
    if (l > 10) {
      let a = val.split('');
      for (let i = 0; i < 9; i++) {
        final = final + a[i];
      }
      final = final + '...';
    } else {
      final = val;
    }
    return final;
  }

  getStatusname(val: string) {
    if (val == 'UNINSTALLED') {
      return 'btn btnsuccess';
    } else if (val == 'QUARANTINED') {
      return 'btn btnquarantined';
    } else {
      return 'btn btnquarantined';
    }
  }

  sortByDateAsc() {
    this.firewallReport.sort(
      (a, b) =>
        new Date(a.dateTimeRaw).getTime() - new Date(b.dateTimeRaw).getTime()
    );
  }

  sortByDateDesc() {
    this.firewallReport.sort(
      (a, b) =>
        new Date(b.dateTimeRaw).getTime() - new Date(a.dateTimeRaw).getTime()
    );
  }

  openMyIndexRenewLicense(system: any) {
    let prdkey = '';
    let url = '';

    if (this.userTimezone == 'Asia/Kolkata' || this.userTimezone == 'Asia/Calcutta') {
      if (this.selectedLanguage && this.selectedLanguage !== 'en') {
        prdkey = this.crwSupportedProductTypes.includes(system?.productType) ? system.productKey : '';
        url = `${system.productLink}?prdkey=${prdkey}&QVER=${system.buildVersion}`;
      } else {
        prdkey = this.crwSupportedProductTypes.includes(system?.productType)
          ? system.encryptedProductKey : system.productKey;
        url = `${system.productLink}?prdkey=${prdkey}`;
      }
    } else {
      prdkey = this.crwSupportedProductTypes.includes(system?.productType) ? system.productKey : '';
      url = `${system.productLink}?prdkey=${prdkey}&QVER=${system.buildVersion}`;
    }
    const newTab = window.open(url, '_blank');

    const messageHandler = (event: MessageEvent) => {
      if (event.origin !== system.crwDomainUrl) return;

      if (event.data === 'payment_success') {
        window.removeEventListener('message', messageHandler);
        this.handlePaymentSuccess(system.productKey);
      } else {
        window.removeEventListener('message', messageHandler);
      }
    };

    window.addEventListener('message', messageHandler);
    // Poll to detect if the user closes the tab without completing payment
    const tabWatcher = setInterval(() => {
      if (newTab?.closed) {
        clearInterval(tabWatcher);
        window.removeEventListener('message', messageHandler);
      }
    }, 500); // Check every 500ms
  }

  handlePaymentSuccess(productKey: string): void {
    console.log('handlePaymentSuccess ::', productKey);
    this.getDesktopProductKeyDetails(productKey);
  }
  getDesktopProductKeyDetails(productKey: string): void {
    this.isLoading = true;
    console.log('getDesktopProductKeyDetails ::', productKey);
    try {
      this._service
        .getService(
          this._service.API_URL.getDesktopProductKeyDetails +
          '?productKey=' +
          productKey
        )
        .subscribe((response) => {
          console.log('activation response:: ', response);
          if (response && response.status.code === 200) {
            this.isLoading = false;
            this.devicesList.expiryDate =
              response.data.expiryDate;

            console.log('getDesktopProductKeyDetails response:: ', response);
          }
        });
    } catch (error) {
      console.log(error);
    }
  }

}
